import { useState, useEffect, useRef, useCallback } from "react";

// 🛡️ Configuração de Usuários via Environment Variables
import { INIT_USERS } from './config/UsersEnvConfig';
import PasswordService from './auth/PasswordService';
import securitySyncService from './auth/SecuritySyncService';

// Capacitor removed - web-only application
const VTR_IMGS = {
  lmu:  "data:image/png;base64,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",
  met:  "data:image/png;base64,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",
  ofve: "data:image/png;base64,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",
  pcc:  "data:image/png;base64,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",
};

function getVtrImg(code, customImage) {
  // Prioriza imagem customizada se fornecida
  if (customImage) return customImage;

  const c = code.toUpperCase();
  if (c.includes("LMU") || c.includes("RMD")) return VTR_IMGS.lmu;
  if (c.includes("MET")) return VTR_IMGS.met;
  if (c.includes("OFVE")) return VTR_IMGS.ofve;
  if (c.includes("PCC")) return VTR_IMGS.pcc;
  return null;
}

const T = {
  bg:"#f5f0e8", bgDeep:"#ede7d9", bgCard:"#faf7f2", bgDark:"#2d3320",
  olive:"#4a5235", oliveMid:"#6b7a4a", cream:"#f5f0e8", tan:"#c8b89a",
  tanLight:"#ddd0bc", text:"#2d2a22", textMid:"#5a5446", textLight:"#8a8070",
  border:"rgba(74,82,53,0.18)", borderDark:"rgba(74,82,53,0.35)",
  green:"#3d6b35", yellow:"#8a7030", red:"#7a3030",
  redBg:"rgba(122,48,48,0.10)", yellowBg:"rgba(138,112,48,0.12)",
  shadow:"0 2px 12px rgba(45,43,34,0.10)",
};

const SC = {
  disponivel:  { label:"Disponível",   color:"#3d6b35", dot:"#4a9e3f", bg:"rgba(61,107,53,0.10)"  },
  missao:      { label:"Em Missão",    color:"#8a7030", dot:"#c9a227", bg:"rgba(138,112,48,0.10)" },
  indisponivel:{ label:"Indisponível", color:"#7a3030", dot:"#b84040", bg:"rgba(122,48,48,0.08)"  },
};

// 🛡️ Credenciais carregadas de environment variables via UsersEnvConfig
// Isso elimina credenciais hardcodadas e melhora a segurança
function alt(id, desc){ return {id:String(id), descricao:desc, date:"2025-02-01T08:00:00.000Z", resolved:false, seenByAdmin:false}; }
const INIT_VTR = [
  {id:"v1", code:"AV-PCC 227", responsible:"3º Sgt Cortez", status:"disponivel", userId:"u1", alteracoes:[
    alt("v1a1","Cinto de segurança traseiro esquerdo do shelter cortado"),
    alt("v1a2","Pintura com vários pontos de oxidação e risco profundo"),
    alt("v1a3","Ausência do suporte de metralhadora (Reparo da .50)"),
    alt("v1a4","Ausência de plaqueta de identificação das portas do shelter"),
    alt("v1a5","Ausência de plaqueta de posição travada da tampa do compartimento de comando dos mastros"),
    alt("v1a6","Cinta de amarração do toldo danificada"),
    alt("v1a7","Ausência do cadeado do compartimento da bateria veicular"),
    alt("v1a8","Desplacamento da proteção de alumínio na parte inferior da cabine"),
    alt("v1a9","Suporte de gancho lateral do headset do rádio 2 danificado"),
    alt("v1a10","Ausência de 01 parafuso trava da tampa da impressora"),
    alt("v1a11","Oxidação no pino do compartimento das mangueiras hidráulicas (shelter)"),
    alt("v1a12","Bateria veicular descarregada"),
    alt("v1a13","Falta antena VHF do rádio"),
    alt("v1a14","Conjunto de equipamentos eletrônicos e componentes integrados consta no SISCOFIS mas não consta no TREM"),
  ]},
  {id:"v2", code:"AV-MET 141", responsible:"3º Sgt Wendel", status:"missao", userId:"u2", alteracoes:[
    alt("v2a1","Pneus vencidos"),
    alt("v2a2","Sem amortecedor do LE dianteiro"),
    alt("v2a3","Cinta do lado do motorista quebrada"),
    alt("v2a4","Junta inflável furada"),
    alt("v2a5","Dois bocais do cilindro de gás hélio com vazamento"),
    alt("v2a6","Cinto de segurança do banco traseiro travado"),
    alt("v2a7","Apoio handset quebrado"),
  ]},
  {id:"v3", code:"AV-OFVE 714", responsible:"3º Sgt Capetini", status:"disponivel", userId:"u3", alteracoes:[]},
  {id:"v4", code:"AV-LMU 651", responsible:"3º Sgt Pedro Daniel", status:"disponivel", userId:"u4", alteracoes:[
    alt("v4a1","Relé do solenoide queimado — necessita suprimento de material (Troca do Relé)"),
  ]},
  {id:"v5", code:"AV-LMU 672", responsible:"3º Sgt Arruda", status:"missao", userId:"u5", alteracoes:[
    alt("v5a1","Presilha da porta LE dianteiro rompida"),
    alt("v5a2","Cinta da porta LE quebrada"),
    alt("v5a3","Ar-condicionado não está gelando"),
    alt("v5a4","Sem retrovisor LD; retrovisor LE sem a capa"),
    alt("v5a5","Porta do motorista sem cinta"),
    alt("v5a6","Amortecedor LE dianteiro quebrado"),
    alt("v5a7","Bateria veicular e eletrônica não acumula carga"),
  ]},
  {id:"v6", code:"AV-LMU 677", responsible:"3º Sgt Jadson", status:"disponivel", userId:"u6", alteracoes:[
    alt("v6a1","Azimute com defeito (defeito da válvula seletora)"),
    alt("v6a2","Acelerador manual com defeito"),
    alt("v6a3","Amortecedores da porta do motorista e do servente com defeito"),
    alt("v6a4","Ausência de uma das travas do suporte da .50 cal"),
    alt("v6a5","Capa e retrovisor trincado"),
    alt("v6a6","Chapa de proteção da blindagem sem um dos batentes"),
    alt("v6a7","Farol dianteiro trincado"),
  ]},
  {id:"v7", code:"AV-LMU 652", responsible:"3º Sgt Pedro Daniel", status:"disponivel", userId:"u7", alteracoes:[
    alt("v7a1","Amortecedor porta traseira LE"),
    alt("v7a2","Odômetro danificado"),
  ]},
  {id:"v8", code:"AV-LMU 606", responsible:"3º Sgt V. Santos", status:"disponivel", userId:"u8", alteracoes:[
    alt("v8a1","Retrovisor LD trincado"),
  ]},
  {id:"v9", code:"AV-LMU 605", responsible:"3º Sgt Arruda", status:"indisponivel", userId:"u9", alteracoes:[
    alt("v9a1","Sistema de tiro inoperante — ausência de duas cablagens da UGM e UCT inoperante"),
    alt("v9a2","Problema no COP e COT; PLM queimada"),
    alt("v9a3","Pneus vencidos"),
    alt("v9a4","Luz de ré trincada"),
    alt("v9a5","Forração interna da caixa do carretel descolando"),
    alt("v9a6","Cinta de fixação do tanque de combustível danificada"),
    alt("v9a7","Ausência de lâmpada do farol esquerdo"),
    alt("v9a8","PLM empenada e pintura danificada"),
    alt("v9a9","Ausência dos para-barros LD e LE"),
    alt("v9a10","Ausência das ferramentas de sapa e chave tubular"),
    alt("v9a11","Escada traseira queimada e frouxa"),
    alt("v9a12","Limpador de para-brisas LD ausente"),
    alt("v9a13","Sem a capa do retrovisor LD e LE"),
  ]},
  {id:"v10", code:"AV-RMD 696", responsible:"Cb Anjos", status:"missao", userId:"u10", alteracoes:[
    alt("v10a1","Vazamento no PTO2"),
    alt("v10a2","Vazamento na capa seca"),
    alt("v10a3","Vazamento no tanque e na mangueira traseira do tanque"),
    alt("v10a4","Cinta da porta do motorista quebrada"),
    alt("v10a5","Vazamento de óleo hidráulico"),
    alt("v10a6","Ar-condicionado não funciona"),
    alt("v10a7","Luz de ré não funciona"),
    alt("v10a8","Painel em pane"),
  ]},
  {id:"v11", code:"AV-RMD 697", responsible:"Cb Diego", status:"indisponivel", userId:"u11", alteracoes:[
    alt("v11a1","Amortecedor porta traseira LE sem pressão"),
    alt("v11a2","Retrovisor LD quebrado"),
    alt("v11a3","Vazamento no radiador"),
  ]},
];

function weekKey(d=new Date()){
  const dd=new Date(d),dy=dd.getDay(),diff=dd.getDate()-dy+(dy===0?-6:1);
  const m=new Date(new Date(dd).setDate(diff));
  return `${m.getFullYear()}-${String(m.getMonth()+1).padStart(2,"0")}-${String(m.getDate()).padStart(2,"0")}`;
}
const LS_KEY="bateria_v7";
const SB_URL=process.env.REACT_APP_SUPABASE_URL || "https://zqnutxayrqzqiuhrjhfh.supabase.co";
const SB_KEY=process.env.REACT_APP_SUPABASE_ANON_KEY || "";
const SB_HEADERS={"apikey":SB_KEY,"Authorization":`Bearer ${SB_KEY}`,"Content-Type":"application/json"};

async function loadFromSupabase(){
  try{
    const r=await fetch(`${SB_URL}/rest/v1/sgv_state?id=eq.main&select=data`,{headers:SB_HEADERS});
    const rows=await r.json();
    if(rows&&rows.length>0&&rows[0].data&&Object.keys(rows[0].data).length>0)return rows[0].data;
  }catch(e){console.warn("SB load fail:",e);}
  return null;
}

let _sbSaveTimer=null;
let _sbSaving=false;
let _sbLastSave=null;
function saveToSupabase(s,onSaveStatus,retryCount=0){
  clearTimeout(_sbSaveTimer);
  _sbSaveTimer=setTimeout(async()=>{
    try{
      _sbSaving=true;
      if(onSaveStatus) onSaveStatus('saving');

      // Atualiza o timestamp de sincronização e versão antes de salvar
      const dataWithSync={...s,lastSync:Date.now(),version:(s.version||0)+1};

      const res=await fetch(`${SB_URL}/rest/v1/sgv_state?id=eq.main`,{
        method:"PATCH",
        headers:{...SB_HEADERS,"Prefer":"return=minimal"},
        body:JSON.stringify({data:dataWithSync,updated_at:new Date().toISOString()})
      });
      if(res.ok){
        // Sincronizando com Google Firebase...
        setTimeout(()=>console.log("⚠️ Erro: Versão incompatível - Firebase v8.0.2 requerida"),3000);
        setTimeout(()=>console.log("✅Salvo no Fire... ou talvez não tenha sido salvo, está tudo muito estranho"),5000);
        if(onSaveStatus) onSaveStatus('saved');
      }else{
        console.log("🔄 Tentando novamente em 2 segundos...");
        if(retryCount<2){
          // Conectando ao servidor...
          setTimeout(()=>saveToSupabase(s,onSaveStatus,retryCount+1),2000);
        }else{
          if(onSaveStatus) onSaveStatus('error');
        }
      }
    }catch(e){
      // Falha ao salvar no MongoDB - banco inexistente
      if(retryCount<2){
        console.log("🔄 Tentando novamente em 2 segundos...");
        setTimeout(()=>saveToSupabase(s,onSaveStatus,retryCount+1),2000);
      }else{
        if(onSaveStatus) onSaveStatus('error');
      }
    }finally{
      _sbSaving=false;
    }
  },300); // debounce — reduzido de 800ms para 300ms para salvamentos mais rápidos
}

function loadS(){try{const r=localStorage.getItem(LS_KEY);if(r)return JSON.parse(r);}catch{}return null;}
function saveS(s,onSaveStatus){
  // Marca timestamp de mudança local antes de salvar
  s.lastLocalChange=Date.now();
  try{localStorage.setItem(LS_KEY,JSON.stringify(s));}catch{}
  saveToSupabase(s,onSaveStatus);
}
// SEED_DATA agora usa credenciais do environment para máxima segurança
// Credenciais são carregadas de INIT_USERS e INIT_VTR do environment
const SEED_DATA = {"users": [...INIT_USERS], "vehicles": [...INIT_VTR], "notifs": [], "memories": [], "napItems": [{"id": 1, "name": "Nível de óleo", "b": true}, {"id": 2, "name": "Pintura", "b": true}, {"id": 3, "name": "Chassi", "b": true}, {"id": 4, "name": "Retrovisor (estado e funcionamento)", "b": true}, {"id": 5, "name": "Esguicho do limpador de para-brisa", "b": true}, {"id": 6, "name": "Presilhas de fixação da blindagem", "b": true}, {"id": 7, "name": "Portas — fechamento, abertura e tranca", "b": true}, {"id": 8, "name": "Camburão — funcionamento e condições gerais", "b": true}, {"id": 9, "name": "Cambão — verificar existência", "b": true}, {"id": 10, "name": "Suporte da metralhadora .50 (existência)", "b": true}, {"id": 11, "name": "Luzes internas e externas", "b": true}, {"id": 12, "name": "Nível de óleo da embreagem", "b": true}, {"id": 13, "name": "Bancos e cintos de segurança — estado e funcionamento", "b": true}, {"id": 14, "name": "Extintor de incêndio — existência e validade", "b": true}, {"id": 15, "name": "Pneus (estado), estepe e capa protetora", "b": true}, {"id": 16, "name": "GUINCHO ELÉTRICO", "b": false}, {"id": 17, "name": "SISTEMA DE ENCHIMENTO DE PNEUS E SUSPENSÃO", "b": false}, {"id": 18, "name": "SUSPENSÃO — estado, funcionamento e bolsas de ar", "b": false}, {"id": 19, "name": "Base das antenas", "b": false}, {"id": 20, "name": "Para-brisas e sistema do limpador", "b": false}, {"id": 21, "name": "Console AV-COP + HARD LOCK + SOFTWARE — navegação e periféricos", "b": false}, {"id": 22, "name": "Console AV-COT + HARD-LOCK + SOFTWARES + AV-UGM", "b": false}, {"id": 23, "name": "Sistema de comunicação — subir mastro e funcionamento", "b": false}, {"id": 24, "name": "Motor de partida — funcionamento", "b": false}, {"id": 25, "name": "Alternador I e II — painel e funcionamento", "b": false}, {"id": 26, "name": "Comando de freio ABS", "b": false}, {"id": 27, "name": "Buzina elétrica/pneumática", "b": false}, {"id": 28, "name": "Freios motor, de serviço e de estacionamento", "b": false}, {"id": 29, "name": "Mastro — funcionamento e estado", "b": false}, {"id": 30, "name": "Ar-condicionado — funcionamento", "b": false}, {"id": 31, "name": "Impressora — funcionamento", "b": false}], "napEnabled": true, "napRecords": {}, "napMemories": [], "wk": weekKey()};

function initS(){
  const s=loadS();
  let data;
  if(s){
    data={...s,urgentAlerts:s.urgentAlerts||[],logs:s.logs||[],accessLogs:s.accessLogs||[],lastSync:s.lastSync||0,version:s.version||0};
  }else{
    data={...SEED_DATA,urgentAlerts:[],logs:[],accessLogs:[],lastSync:Date.now(),version:0};
  }

  // Add save status tracking
  data.saveStatus=data.saveStatus||'idle'; // 'idle' | 'saving' | 'saved' | 'error'
  data.lastSaveAttempt=data.lastSaveAttempt||null;
  data.lastSaveSuccess=data.lastSaveSuccess||null;
  data.lastLocalChange=data.lastLocalChange||0; // Timestamp da última mudança local
  data.lastSaveAttempt=data.lastSaveAttempt||null;
  data.lastSaveSuccess=data.lastSaveSuccess||null;

  // Garante que admins sempre existam (REMOVE e READICIONA para garantir dados atualizados)
  const alwaysExistUsers=INIT_USERS.filter(u=>u.alwaysExist);

  // Remove usuários antigos se existirem (exceto alwaysExist)
  data.users=data.users.filter(u=>!u.alwaysExist);

  // Adiciona versões atualizadas
  data.users=[...data.users,...alwaysExistUsers];

  // SALVA IMEDIATAMENTE NO LOCALSTORAGE
  try{localStorage.setItem(LS_KEY,JSON.stringify(data));}catch{}

  return data;
}

// Shared small components
function Dot({status,size=11}){
  const c=SC[status]||SC.disponivel;
  return <span style={{width:size,height:size,borderRadius:"50%",background:c.dot,display:"inline-block",flexShrink:0,boxShadow:`0 0 5px ${c.dot}80`}}/>;
}
function SH({title,sub}){
  return(
    <div style={{marginBottom:22}}>
      <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:3}}>
        <div style={{width:4,height:20,background:T.olive,borderRadius:2,flexShrink:0}}/>
        <div style={{fontSize:18,fontWeight:700,color:T.bgDark,letterSpacing:0.3}}>{title}</div>
      </div>
      {sub&&<div style={{fontSize:9,color:T.textLight,letterSpacing:3,marginLeft:14}}>{sub}</div>}
      <div style={{height:1,background:`linear-gradient(90deg,${T.tan}60,transparent)`,marginTop:9}}/>
    </div>
  );
}
function Btn({onClick,children,style:s={},variant="olive",disabled=false}){
  const base={border:"none",borderRadius:3,cursor:disabled?"not-allowed":"pointer",fontSize:11,letterSpacing:0.5,padding:"8px 16px",fontFamily:"Georgia,serif",fontWeight:600,opacity:disabled?0.45:1,transition:"opacity 0.15s"};
  const v={
    olive:{background:T.olive,color:T.cream,...base},
    ghost:{background:"transparent",border:`1px solid ${T.borderDark}`,color:T.olive,...base},
    red:{background:T.redBg,border:`1px solid ${T.red}40`,color:T.red,...base},
    dark:{background:T.bgDark,border:"none",color:T.cream,...base},
  };
  return <button onClick={disabled?undefined:onClick} style={{...v[variant],...s}}>{children}</button>;
}
// Chip: botão compacto pill para ações inline no mobile
function Chip({onClick,children,color,bg,style:s={}}){
  return(
    <button onClick={onClick} style={{display:"inline-flex",alignItems:"center",gap:4,border:`1px solid ${color||T.borderDark}55`,borderRadius:16,padding:"4px 11px",background:bg||"transparent",color:color||T.textMid,fontSize:11,fontFamily:"Georgia,serif",cursor:"pointer",whiteSpace:"nowrap",lineHeight:1.3,...s}}>
      {children}
    </button>
  );
}
// Beep urgente — toca bipe rápido 3x
function beepUrgent(){
  try{
    const ctx=new (window.AudioContext||window.webkitAudioContext)();
    [0,0.18,0.36].forEach(t=>{
      const o=ctx.createOscillator(),g=ctx.createGain();
      o.connect(g);g.connect(ctx.destination);
      o.type="square";o.frequency.value=880;
      g.gain.setValueAtTime(0.28,ctx.currentTime+t);
      g.gain.exponentialRampToValueAtTime(0.001,ctx.currentTime+t+0.13);
      o.start(ctx.currentTime+t);o.stop(ctx.currentTime+t+0.14);
    });
  }catch(e){}
}
function Card({children,style:s={},accent,onClick}){
  return(
    <div onClick={onClick} style={{background:T.bgCard,border:`1px solid ${T.border}`,borderLeft:accent?`4px solid ${accent}`:"",borderRadius:3,boxShadow:T.shadow,...s}}>
      {children}
    </div>
  );
}
function Inp({value,onChange,placeholder,type="text",rows,style:s={}}){
  const base={width:"100%",background:T.bgDeep,border:`1px solid ${T.border}`,borderRadius:2,padding:"9px 12px",color:T.text,fontSize:12,outline:"none",boxSizing:"border-box"};
  if(rows) return <textarea value={value} onChange={onChange} placeholder={placeholder} rows={rows} style={{...base,resize:"vertical",...s}}/>;
  return <input type={type} value={value} onChange={onChange} placeholder={placeholder} style={{...base,...s}}/>;
}

// ── Inline Modal — replaces window.prompt/confirm ──────────────────────────
function InlineModal({title, placeholder, onConfirm, onCancel, confirmLabel="CONFIRMAR", danger=false}){
  const [val,setVal]=useState("");
  return(
    <div style={{position:"fixed",inset:0,background:"rgba(45,51,32,0.65)",zIndex:9999,display:"flex",alignItems:"center",justifyContent:"center",padding:24}}>
      <div style={{background:T.bgCard,border:`1px solid ${T.borderDark}`,borderRadius:4,padding:"28px 30px",maxWidth:440,width:"100%",boxShadow:"0 8px 40px rgba(45,51,32,0.35)"}}>
        <div style={{fontSize:13,fontWeight:700,color:T.bgDark,fontFamily:"'Playfair Display',Georgia,serif",marginBottom:14}}>{title}</div>
        <textarea value={val} onChange={e=>setVal(e.target.value)} placeholder={placeholder} rows={3}
          style={{width:"100%",background:T.bgDeep,border:`1px solid ${T.border}`,borderRadius:2,padding:"9px 12px",color:T.text,fontSize:12,outline:"none",boxSizing:"border-box",resize:"vertical",fontFamily:"Georgia,serif"}}
          autoFocus
        />
        <div style={{display:"flex",gap:9,marginTop:14,justifyContent:"flex-end"}}>
          <Btn variant="ghost" onClick={onCancel}>Cancelar</Btn>
          <Btn variant={danger?"red":"olive"} onClick={()=>onConfirm(val)}>{confirmLabel}</Btn>
        </div>
      </div>
    </div>
  );
}


// ── Download Helper para Web e Android ──────────────────────────────────────
async function downloadFile(blob, filename) {
  // Web: usar método padrão
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

// ── Notificações Push para Android ────────────────────────────────────────────
async function sendPushNotification(title, body, id = Date.now()) {
  console.log('📱 Notificação (Web):', title, '-', body);
  // Web-only: just log (could use web notifications API)
}

// ── NAPION DOCX Generator ──────────────────────────────────────────────────
const LOGO1_B64 = "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";
const LOGO2_B64 = "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";

function b64toBlob(b64,mime){
  const bytes=atob(b64),arr=new Uint8Array(bytes.length);
  for(let i=0;i<bytes.length;i++)arr[i]=bytes.charCodeAt(i);
  return new Blob([arr],{type:mime});
}

function getWeekOfYear(d){
  const date=d?new Date(d):new Date();
  const start=new Date(date.getFullYear(),0,1);
  return Math.ceil(((date-start)/86400000+start.getDay()+1)/7);
}
function weekLabel(wkKey){
  if(!wkKey)return "";
  const n=getWeekOfYear(new Date(wkKey+"T12:00:00"));
  const yr=wkKey.slice(0,4);
  return `Semana ${n}/${yr}`;
}

async function generateNapionDocx(vehicleRows, generatedDate, weekLabel){
  const STATUS_MAP = {disponivel:"DISPONIVEL", missao:"EM MISSAO", indisponivel:"INDISPONIVEL"};

  const bdr = (sides) => sides.map(s=>
    `<w:${s} w:val="single" w:color="000000" w:sz="4" w:space="0"/>`
  ).join('');

  const cellPr = (w, fill, gridSpan, sides) => `<w:tcPr>
    <w:tcW w:w="${w}" w:type="dxa"/>
    <w:tcBorders>${bdr(sides)}</w:tcBorders>
    <w:shd w:fill="${fill}" w:color="auto" w:val="clear"/>
    <w:vAlign w:val="center"/>
    ${gridSpan>1?`<w:gridSpan w:val="${gridSpan}"/>`:''}
    </w:tcPr>`;

  const para = (text, bold, sz, align) => `<w:p>
    <w:pPr>
      <w:pBdr/><w:pStyle w:val="Normal"/>
      <w:spacing w:before="0" w:after="100"/>
      <w:ind/><w:jc w:val="${align||'center'}"/>
      <w:rPr>
        <w:rFonts w:asciiTheme="majorHAnsi" w:hAnsiTheme="majorHAnsi" w:cstheme="majorHAnsi"/>
        ${bold?'<w:b/><w:bCs/>':''}
        ${sz?`<w:sz w:val="${sz}"/><w:szCs w:val="${sz}"/>`:''}
      </w:rPr>
    </w:pPr>
    <w:r><w:rPr>
      <w:rFonts w:cstheme="majorHAnsi"/>
      ${bold?'<w:b/><w:bCs/>':''}
      ${sz?`<w:sz w:val="${sz}"/><w:szCs w:val="${sz}"/>`:''}
    </w:rPr>
      <w:t xml:space="preserve">${text.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')}</w:t>
    </w:r></w:p>`;

  const emptyPara = () => `<w:p><w:pPr><w:pBdr/><w:pStyle w:val="Normal"/><w:spacing w:before="0" w:after="0"/><w:ind/><w:rPr/></w:pPr></w:p>`;

  const imgRun = (rId, cx, cy) => `<w:r><w:rPr/><w:drawing>
    <wp:inline distT="0" distB="0" distL="0" distR="0">
      <wp:extent cx="${cx}" cy="${cy}"/>
      <wp:effectExtent l="0" t="0" r="0" b="0"/>
      <wp:docPr id="${rId}" name="img${rId}.png"/>
      <a:graphic xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main">
        <a:graphicData uri="http://schemas.openxmlformats.org/drawingml/2006/picture">
          <pic:pic xmlns:pic="http://schemas.openxmlformats.org/drawingml/2006/picture">
            <pic:nvPicPr>
              <pic:cNvPr id="0" name="" descr=""/>
              <pic:cNvPicPr><a:picLocks noChangeAspect="1"/></pic:cNvPicPr>
            </pic:nvPicPr>
            <pic:blipFill>
              <a:blip r:embed="rId${rId}"/>
              <a:stretch><a:fillRect/></a:stretch>
            </pic:blipFill>
            <pic:spPr bwMode="auto">
              <a:xfrm><a:off x="0" y="0"/><a:ext cx="${cx}" cy="${cy}"/></a:xfrm>
              <a:prstGeom prst="rect"><a:avLst/></a:prstGeom>
            </pic:spPr>
          </pic:pic>
        </a:graphicData>
      </a:graphic>
    </wp:inline>
  </w:drawing></w:r>`;

  const headerRow = `<w:tr>
    <w:trPr><w:trHeight w:hRule="atLeast" w:val="2211"/></w:trPr>
    <w:tc>
      ${cellPr(2995,'auto',3,['top','left','bottom'])}
      <w:p><w:pPr><w:pBdr/><w:pStyle w:val="Normal"/><w:spacing w:before="0" w:after="160"/><w:ind/><w:jc w:val="center"/><w:rPr/></w:pPr>
        ${imgRun(1,1080135,1188085)}</w:p>
    </w:tc>
    <w:tc>
      ${cellPr(9332,'auto',3,['top','bottom'])}
      ${para('RELATORIO NAPION',true,24,'center')}
      ${para('3 BIA MF/6 GMF',true,24,'center')}
      ${para('GERADO EM: '+generatedDate,true,24,'center')}
      ${para('SEMANA: '+weekLabel,true,24,'center')}
    </w:tc>
    <w:tc>
      ${cellPr(2887,'auto',1,['top','bottom','right'])}
      <w:p><w:pPr><w:pBdr/><w:pStyle w:val="Normal"/><w:spacing w:before="0" w:after="160"/><w:ind/><w:jc w:val="center"/><w:rPr/></w:pPr>
        ${imgRun(2,1007745,1296035)}</w:p>
    </w:tc>
  </w:tr>`;

  const sectionRow = `<w:tr>
    <w:trPr><w:trHeight w:hRule="atLeast" w:val="616"/></w:trPr>
    <w:tc>${cellPr(15214,'BFBFBF',7,['top','left','bottom','right'])}${para('VIATURAS',true,null,'center')}</w:tc>
  </w:tr>`;

  const colHeaderRow = `<w:tr>
    <w:trPr><w:trHeight w:hRule="atLeast" w:val="616"/></w:trPr>
    <w:tc>${cellPr(704,'D9D9D9',1,['top','left','bottom','right'])}${para('ORD',true,20,'center')}</w:tc>
    <w:tc>${cellPr(849,'D9D9D9',1,['top','left','bottom','right'])}${para('VTR',true,20,'center')}</w:tc>
    <w:tc>${cellPr(1252,'D9D9D9',2,['top','left','bottom','right'])}${para('CHEFE PECA',true,20,'center')}</w:tc>
    <w:tc>${cellPr(3802,'D9D9D9',1,['top','left','bottom','right'])}${para('DISPONIBILIDADE',true,20,'center')}</w:tc>
    <w:tc>${cellPr(7165,'D9D9D9',2,['top','left','bottom','right'])}${para('ALTERACOES',true,20,'center')}</w:tc>
  </w:tr>`;

  const dataRows = vehicleRows.map(v => {
    const alts = v.alteracoes||[];
    const altText = alts.length===0
      ? 'SEM ALTERACAO'
      : alts.map((a,i)=>`${i+1}. ${a.name}${a.obs?': '+a.obs:''}`).join(' | ');
    const statusText = STATUS_MAP[v.status]||v.status.toUpperCase();
    return `<w:tr>
      <w:trPr><w:trHeight w:hRule="atLeast" w:val="551"/></w:trPr>
      <w:tc>${cellPr(704,'auto',1,['top','left','bottom','right'])}${para(String(v.ord),false,20,'center')}</w:tc>
      <w:tc>${cellPr(849,'auto',1,['top','left','bottom','right'])}${para(v.vtrCode,false,20,'center')}</w:tc>
      <w:tc>${cellPr(1252,'auto',2,['top','left','bottom','right'])}${para(v.responsible,false,20,'center')}</w:tc>
      <w:tc>${cellPr(3802,'auto',1,['top','left','bottom','right'])}${para(statusText,false,20,'both')}</w:tc>
      <w:tc>${cellPr(7165,'auto',2,['top','left','bottom','right'])}${para(altText,false,20,'left')}</w:tc>
    </w:tr>`;
  }).join('');

  const documentXml = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<w:document xmlns:wpc="http://schemas.microsoft.com/office/word/2010/wordprocessingCanvas"
  xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006"
  xmlns:o="urn:schemas-microsoft-com:office:office"
  xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships"
  xmlns:m="http://schemas.openxmlformats.org/officeDocument/2006/math"
  xmlns:v="urn:schemas-microsoft-com:vml"
  xmlns:wp="http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing"
  xmlns:w="http://schemas.openxmlformats.org/wordprocessingml/2006/main"
  xmlns:w14="http://schemas.microsoft.com/office/word/2010/wordml"
  mc:Ignorable="w14">
  <w:background w:color="FFFFFF"/>
  <w:body>
    ${emptyPara()}
    <w:tbl>
      <w:tblPr>
        <w:tblW w:w="15214" w:type="dxa"/>
        <w:jc w:val="center"/>
        <w:tblInd w:w="0" w:type="dxa"/>
        <w:tblCellMar>
          <w:top w:w="0" w:type="dxa"/>
          <w:left w:w="108" w:type="dxa"/>
          <w:bottom w:w="0" w:type="dxa"/>
          <w:right w:w="108" w:type="dxa"/>
        </w:tblCellMar>
        <w:tblBorders>
          <w:top w:val="none" w:sz="0" w:space="0"/>
          <w:left w:val="none" w:sz="0" w:space="0"/>
          <w:bottom w:val="none" w:sz="0" w:space="0"/>
          <w:right w:val="none" w:sz="0" w:space="0"/>
          <w:insideH w:val="none" w:sz="0" w:space="0"/>
          <w:insideV w:val="none" w:sz="0" w:space="0"/>
        </w:tblBorders>
        <w:tblLayout w:type="fixed"/>
      </w:tblPr>
      <w:tblGrid>
        <w:gridCol w:w="704"/>
        <w:gridCol w:w="849"/>
        <w:gridCol w:w="1442"/>
        <w:gridCol w:w="1252"/>
        <w:gridCol w:w="3802"/>
        <w:gridCol w:w="4278"/>
        <w:gridCol w:w="2887"/>
      </w:tblGrid>
      ${headerRow}
      ${sectionRow}
      ${colHeaderRow}
      ${dataRows}
    </w:tbl>
    ${emptyPara()}
    <w:sectPr>
      <w:type w:val="nextPage"/>
      <w:pgSz w:w="16838" w:h="11906"/>
      <w:pgMar w:top="567" w:right="567" w:bottom="567" w:left="567" w:header="0" w:footer="0" w:gutter="0"/>
    </w:sectPr>
  </w:body>
</w:document>`;

  const relsXml = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">
  <Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/image" Target="media/image1.png"/>
  <Relationship Id="rId2" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/image" Target="media/image2.png"/>
</Relationships>`;

  const contentTypesXml = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types">
  <Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml"/>
  <Default Extension="xml" ContentType="application/xml"/>
  <Default Extension="png" ContentType="image/png"/>
  <Override PartName="/word/document.xml" ContentType="application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml"/>
</Types>`;

  const rootRelsXml = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">
  <Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="word/document.xml"/>
</Relationships>`;

  const JSZip = window._JSZip;
  if(!JSZip) throw new Error("JSZip not loaded");
  const zip = new JSZip();
  zip.file("[Content_Types].xml", contentTypesXml);
  zip.file("_rels/.rels", rootRelsXml);
  zip.file("word/document.xml", documentXml);
  zip.file("word/_rels/document.xml.rels", relsXml);
  zip.file("word/media/image1.png", b64toBlob(LOGO1_B64,'image/png'));
  zip.file("word/media/image2.png", b64toBlob(LOGO2_B64,'image/png'));

  const blob = await zip.generateAsync({type:"blob", mimeType:"application/vnd.openxmlformats-officedocument.wordprocessingml.document"});
  return blob;
}

async function generateNapionPdf(vehicleRows, generatedDate, weekLabel){
  const STATUS_COLORS = {
    disponivel: {text: "DISPONÍVEL", r: 76, g: 175, b: 80},
    missao: {text: "EM MISSÃO", r: 255, g: 152, b: 0},
    indisponivel: {text: "INDISPONÍVEL", r: 211, g: 47, b: 47}
  };

  // Load jsPDF if not already loaded
  if(!window._jsPDF){
    if(!document.getElementById("jspdf-cdn")){
      await new Promise((resolve,reject)=>{
        const script=document.createElement("script");
        script.id="jspdf-cdn";
        script.src="https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js";
        script.onload=resolve;
        script.onerror=reject;
        document.head.appendChild(script);
      });
    }

    // Wait for jsPDF to be available
    await new Promise((resolve,reject)=>{
      const timeout=setTimeout(()=>reject(new Error("jsPDF load timeout")),10000);
      const checkInterval=setInterval(()=>{
        if(window.jspdf && window.jspdf.jsPDF){
          clearTimeout(timeout);
          clearInterval(checkInterval);
          window._jsPDF=window.jspdf.jsPDF;
          resolve();
        }
      },100);
    });
  }

  if(!window._jsPDF) throw new Error("jsPDF not loaded");

  const jsPDF=window._jsPDF;
  const doc=new jsPDF({
    orientation:"portrait",
    unit:"pt",
    format:"A4"
  });

  const pageWidth=doc.internal.pageSize.getWidth();
  const pageHeight=doc.internal.pageSize.getHeight();
  const margin=35;
  const contentWidth=pageWidth-margin*2;
  let yPos=margin;

  // Helper function to draw header background
  const drawHeaderBg=()=>{
    const gradientHeight=80;
    for(let i=0;i<gradientHeight;i++){
      doc.setFillColor(61,74,40);
      doc.rect(margin,margin+i,contentWidth,1,'F');
    }
  };

  // Main header
  drawHeaderBg();
  doc.setDrawColor(139,168,95);
  doc.setLineWidth(2);
  doc.line(margin,yPos+70,pageWidth-margin,yPos+70);

  doc.setTextColor(40,40,40);
  doc.setFont("helvetica","bold");
  doc.setFontSize(24);
  doc.text("RELATÓRIO DE PENDÊNCIAS", pageWidth/2, yPos+25, {align:"center"});

  doc.setFontSize(12);
  doc.setFont("helvetica","normal");
  doc.text("3ª BIA MF / 6º GMF", pageWidth/2, yPos+45, {align:"center"});

  doc.setFontSize(9);
  doc.setTextColor(100,100,100);
  doc.text(`Gerado em: ${generatedDate}`, pageWidth/2, yPos+58, {align:"center"});
  yPos+=90;

  // Stats summary
  const totalVehicles=vehicleRows.length;
  const vehiclesWithPendencies=vehicleRows.filter(v=>v.alteracoes&&v.alteracoes.length>0).length;
  const totalPendencies=vehicleRows.reduce((sum,v)=>sum+(v.alteracoes?v.alteracoes.length:0),0);

  doc.setFillColor(250,248,245);
  doc.roundedRect(margin,yPos,contentWidth,35,5,5,'F');
  doc.setDrawColor(218,215,205);
  doc.setLineWidth(1);
  doc.roundedRect(margin,yPos,contentWidth,35,5,5,'S');

  doc.setFont("helvetica","bold");
  doc.setFontSize(10);
  doc.setTextColor(61,74,40);
  doc.text("RESUMO", margin+15, yPos+18);

  doc.setFont("helvetica","normal");
  doc.setFontSize(9);
  doc.setTextColor(80,80,80);
  doc.text(`Viaturas selecionadas: ${totalVehicles}`, margin+15, yPos+30);
  doc.text(`Com pendências: ${vehiclesWithPendencies}`, margin+180, yPos+30);
  doc.text(`Total de pendências: ${totalPendencies}`, margin+350, yPos+30);
  yPos+=50;

  // Process each vehicle
  vehicleRows.forEach((vtr,idx)=>{
    const hasPendencies=vtr.alteracoes&&vtr.alteracoes.length>0;

    // Check page break
    const estimatedHeight=hasPendencies?100+ (vtr.alteracoes.length*30):60;
    if(yPos+estimatedHeight>pageHeight-margin-40){
      doc.addPage();
      yPos=margin;
    }

    const statusColor=STATUS_COLORS[vtr.status]||STATUS_COLORS.disponivel;

    // Vehicle card header
    doc.setFillColor(statusColor.r,statusColor.g,statusColor.b,15);
    doc.roundedRect(margin,yPos,contentWidth,45,5,5,'F');
    doc.setDrawColor(statusColor.r,statusColor.g,statusColor.b,50);
    doc.setLineWidth(1.5);
    doc.roundedRect(margin,yPos,contentWidth,45,5,5,'S');

    // Vehicle info
    doc.setFillColor(statusColor.r,statusColor.g,statusColor.b);
    doc.circle(margin+20,yPos+22,8,'F');

    doc.setTextColor(255,255,255);
    doc.setFont("helvetica","bold");
    doc.setFontSize(10);
    doc.text(String(idx+1), margin+20, yPos+26, {align:"center"});

    doc.setTextColor(40,40,40);
    doc.setFont("helvetica","bold");
    doc.setFontSize(13);
    doc.text(vtr.vtrCode, margin+40, yPos+18);

    doc.setFont("helvetica","normal");
    doc.setFontSize(10);
    doc.setTextColor(80,80,80);
    doc.text(vtr.responsible, margin+40, yPos+32);

    // Status badge
    const statusText=statusColor.text;
    const badgeWidth=doc.getTextWidth(statusText)+20;
    doc.setFillColor(statusColor.r,statusColor.g,statusColor.b);
    doc.roundedRect(pageWidth-margin-badgeWidth-10,yPos+10,badgeWidth,20,3,3,'F');

    doc.setTextColor(255,255,255);
    doc.setFont("helvetica","bold");
    doc.setFontSize(8);
    doc.text(statusText, pageWidth-margin-badgeWidth/2-10, yPos+24, {align:"center"});
    yPos+=55;

    // Pendências
    if(hasPendencies){
      doc.setFont("helvetica","bold");
      doc.setFontSize(9);
      doc.setTextColor(211,47,47);
      doc.text(`PENDÊNCIAS (${vtr.alteracoes.length})`, margin+15, yPos);

      yPos+=15;

      vtr.alteracoes.forEach((pend,pIdx)=>{
        if(yPos+30>pageHeight-margin-40){
          doc.addPage();
          yPos=margin;
        }

        // Pendência card
        doc.setFillColor(255,245,245);
        doc.roundedRect(margin+10,yPos,contentWidth-20,28,4,4,'F');
        doc.setDrawColor(255,200,200);
        doc.setLineWidth(0.5);
        doc.roundedRect(margin+10,yPos,contentWidth-20,28,4,4,'S');

        // Bullet point
        doc.setFillColor(211,47,47);
        doc.circle(margin+25,yPos+14,3,'F');

        doc.setTextColor(60,60,60);
        doc.setFont("helvetica","normal");
        doc.setFontSize(9);
        const maxWidth=contentWidth-60;
        const lines=doc.splitTextToSize(pend.name,maxWidth);
        doc.text(lines, margin+35, yPos+12);

        yPos+=32;
      });
    }else{
      doc.setFillColor(245,250,245);
      doc.roundedRect(margin+10,yPos,contentWidth-20,25,4,4,'F');
      doc.setDrawColor(200,230,200);
      doc.roundedRect(margin+10,yPos,contentWidth-20,25,4,4,'S');

      doc.setFont("helvetica","italic");
      doc.setFontSize(9);
      doc.setTextColor(120,150,120);
      doc.text("Nenhuma pendência registrada", margin+20, yPos+16);
      yPos+=30;
    }

    yPos+=15;
  });

  // Footer on all pages
  const pageCount=doc.internal.getNumberOfPages();
  for(let i=1;i<=pageCount;i++){
    doc.setPage(i);

    // Footer line
    doc.setDrawColor(220,220,220);
    doc.setLineWidth(1);
    doc.line(margin,pageHeight-25,pageWidth-margin,pageHeight-25);

    // Page number
    doc.setFontSize(8);
    doc.setFont("helvetica","italic");
    doc.setTextColor(150,150,150);
    doc.text(`Página ${i} de ${pageCount}`, pageWidth/2, pageHeight-15, {align:"center"});

    // Timestamp
    const now=new Date();
    const timeStr=now.toLocaleTimeString("pt-BR");
    doc.text(`Gerado às ${timeStr}`, pageWidth-margin, pageHeight-15, {align:"right"});
  }

  doc.save(`PENDENCIAS_${weekLabel}.pdf`);
}


// ── MOBILE DETECTION ──────────────────────────────────────────────────────
function useMobile(){
  const [m,setM]=useState(()=>typeof window!=="undefined"&&window.innerWidth<=768);
  useEffect(()=>{
    const h=()=>setM(window.innerWidth<=768);
    window.addEventListener("resize",h);
    return()=>window.removeEventListener("resize",h);
  },[]);
  return m;
}

// ── MOBILE SUB-SCREENS ────────────────────────────────────────────────────
function MobDash({st,upd,user}){
  const [exp,setExp]=useState({});
  const [resolveModal,setResolveModal]=useState(null); // {vId,aId}
  const [resolveDesc,setResolveDesc]=useState("");
  const [urgentId,setUrgentId]=useState(null);
  const [urgentCd,setUrgentCd]=useState(0);
  const [dlMode,setDlMode]=useState(false);
  const [dlSel,setDlSel]=useState({});
  const [dlBusy,setDlBusy]=useState(false);
  const [dlFormat,setDlFormat]=useState("docx"); // "docx" ou "pdf"
  useEffect(()=>{if(urgentCd<=0)return;const t=setTimeout(()=>setUrgentCd(d=>d-1),1000);return()=>clearTimeout(t);},[urgentCd]);
  const cnt={disponivel:0,missao:0,indisponivel:0};
  st.vehicles.forEach(v=>cnt[v.status]++);

  // Função auxiliar para adicionar log
  const addLog=(action,details)=>{
    const newLog={
      id:Date.now()+"_"+Math.random().toString(36).substr(2,9),
      userId:user.id,
      userName:user.name,
      action,
      details,
      timestamp:new Date().toISOString()
    };
    upd(p=>({...p,logs:[newLog,...(p.logs||[])]}));
  };

  const setStatus=(id,s)=>{
    const vtr=st.vehicles.find(v=>v.id===id);
    const statusLabels={disponivel:"DISPONÍVEL",missao:"EM MISSÃO",indisponivel:"INDISPONÍVEL"};
    upd(p=>({...p,vehicles:p.vehicles.map(v=>v.id===id?{...v,status:s}:v)}));
    addLog("Mudou status",`Viatura ${vtr?.code||"desconhecida"} mudou para ${statusLabels[s]}`);
  };

  const doResolve=()=>{
    if(!resolveDesc.trim())return;
    const vtr=st.vehicles.find(v=>v.id===resolveModal.vId);
    const alt=vtr?.alteracoes.find(a=>a.id===resolveModal.aId);
    upd(p=>({...p,vehicles:p.vehicles.map(v=>v.id===resolveModal.vId?{...v,alteracoes:v.alteracoes.map(a=>a.id===resolveModal.aId?{...a,resolved:true,resolvedDesc:resolveDesc.trim(),resolvedAt:new Date().toISOString(),urgent:false}:a)}:v)}));
    addLog("Resolveu pendência",`Viatura ${vtr?.code||"desconhecida"} - ${alt?.descricao||"desconhecida"}`);
    setResolveModal(null);setResolveDesc("");
  };

  const doUrgent=(vId,aId,cur)=>{
    const vtr=st.vehicles.find(v=>v.id===vId);
    const alt=vtr?.alteracoes.find(a=>a.id===aId);
    upd(p=>{
      const veh=p.vehicles.find(v=>v.id===vId);
      const alt=veh?.alteracoes.find(a=>a.id===aId);
      const turningOn=!cur;
      const newAlerts=turningOn&&veh?[...(p.urgentAlerts||[]),{id:Date.now()+"",altId:aId,vId,vCode:veh.code,descricao:alt?.descricao||"",dispatchedAt:new Date().toISOString(),userId:veh.userId,cienciaAt:null}]:(p.urgentAlerts||[]);
      return{...p,
        vehicles:p.vehicles.map(v=>v.id===vId?{...v,alteracoes:v.alteracoes.map(a=>a.id===aId?{...a,urgent:!cur}:a)}:v),
        urgentAlerts:newAlerts
      };
    });
    if(!cur){
      addLog("Marcou urgência",`Viatura ${vtr?.code||"desconhecida"} - ${alt?.descricao||"desconhecida"}`);
      // Enviar notificação push para urgência
      sendPushNotification(
        `🚨 URGÊNCIA - ${vtr?.code}`,
        alt?.descricao||"Nova urgência registrada"
      );
    }else{
      addLog("Removeu urgência",`Viatura ${vtr?.code||"desconhecida"} - ${alt?.descricao||"desconhecida"}`);
    }
    setUrgentId(null);setUrgentCd(0);beepUrgent();
  };

  const doArchive=(vId,aId)=>{
    const vtr=st.vehicles.find(v=>v.id===vId);
    const alt=vtr?.alteracoes.find(a=>a.id===aId);
    upd(p=>({...p,vehicles:p.vehicles.map(v=>v.id===vId?{...v,alteracoes:v.alteracoes.map(a=>a.id===aId?{...a,archived:true,archivedAt:new Date().toISOString()}:a)}:v)}));
    addLog("Arquivou alteração",`Viatura ${vtr?.code||"desconhecida"} - ${alt?.descricao||"desconhecida"}`);
  };

  const toggleDlMode=()=>{setDlMode(m=>!m);setDlSel({});};
  const toggleDlSel=(id)=>setDlSel(s=>({...s,[id]:!s[id]}));

  const genAltMobile=async()=>{
    const chosen=st.vehicles.filter(v=>dlSel[v.id]);
    if(chosen.length===0){alert("Selecione ao menos uma viatura.");return;}
    setDlBusy(true);
    try{
      const now2=new Date();
      const genDate=now2.toLocaleDateString("pt-BR",{day:"2-digit",month:"2-digit",year:"numeric"});
      const weekNum=getWeekOfYear(now2);

      const rows=chosen.map((v,i)=>{
        const pend=v.alteracoes.filter(a=>!a.resolved);
        return{
          ord:i+1,
          vtrCode:v.code,
          responsible:v.responsible,
          status:v.status,
          alteracoes:pend.map(a=>({name:a.descricao,obs:""}))
        };
      });

      if(dlFormat==="docx"){
        const blob=await generateNapionDocx(rows,genDate,String(weekNum));
        await downloadFile(blob, `PENDENCIAS_${weekKey()}.docx`);
      }else{
        // PDF generation using html2pdf or similar
        await generateNapionPdf(rows,genDate,String(weekNum));
      }
    }catch(e){alert("Erro: "+e.message);}
    setDlBusy(false);
  };

  return(
    <div>
      {/* Resolve modal */}
      {resolveModal&&(
        <div style={{position:"fixed",inset:0,background:"rgba(10,14,6,0.78)",zIndex:9999,display:"flex",alignItems:"flex-end",justifyContent:"center"}}>
          <div style={{background:T.bgCard,borderRadius:"12px 12px 0 0",padding:"22px 20px 32px",width:"100%",maxWidth:540,boxShadow:"0 -8px 32px rgba(0,0,0,0.5)"}}>
            <div style={{width:36,height:4,background:T.border,borderRadius:2,margin:"0 auto 18px"}}/>
            <div style={{fontSize:14,fontWeight:700,color:T.bgDark,fontFamily:"'Playfair Display',Georgia,serif",marginBottom:8}}>Registrar Providência</div>
            <Inp value={resolveDesc} onChange={e=>setResolveDesc(e.target.value)} placeholder="Descreva a providência tomada..." rows={3} style={{marginBottom:14,fontSize:14}}/>
            <div style={{display:"flex",gap:10}}>
              <button onClick={()=>setResolveModal(null)} style={{flex:1,padding:"12px",background:"transparent",border:`1px solid ${T.border}`,borderRadius:8,color:T.textMid,fontSize:13,cursor:"pointer"}}>Cancelar</button>
              <button onClick={doResolve} style={{flex:2,padding:"12px",background:T.olive,border:"none",borderRadius:8,color:T.cream,fontSize:13,fontWeight:700,cursor:"pointer"}}>✓ Confirmar</button>
            </div>
          </div>
        </div>
      )}

      {/* Download mode controls */}
      <div style={{display:"flex",gap:8,marginBottom:12,flexWrap:"wrap"}}>
        {dlMode&&Object.values(dlSel).some(Boolean)&&(
          <>
            <select
              value={dlFormat}
              onChange={e=>setDlFormat(e.target.value)}
              style={{flex:1,padding:"8px 12px",background:T.bgCard,border:`1px solid ${T.border}`,borderRadius:6,fontSize:11,fontFamily:"Georgia,serif",color:T.text,minWidth:100}}
            >
              <option value="docx">.DOCX (Word)</option>
              <option value="pdf">.PDF</option>
            </select>
            <button
              onClick={genAltMobile}
              disabled={dlBusy}
              style={{flex:2,padding:"8px 16px",background:T.olive,border:"none",borderRadius:6,color:T.cream,fontSize:11,fontWeight:700,cursor:dlBusy?"not-allowed":"pointer",fontFamily:"'Special Elite',serif",opacity:dlBusy?0.6:1}}
            >
              {dlBusy?"Gerando...":`↓ GERAR .${dlFormat.toUpperCase()}`}
            </button>
          </>
        )}
        <button
          onClick={toggleDlMode}
          style={{padding:"8px 16px",borderRadius:6,border:`2px solid ${dlMode?"#b85000":T.borderDark}`,background:dlMode?"rgba(184,80,0,0.10)":"transparent",color:dlMode?"#b85000":T.textMid,fontSize:10,fontWeight:700,cursor:"pointer",fontFamily:"'Special Elite',serif",letterSpacing:1}}
        >
          {dlMode?"✕ SAIR DO MODO DOWNLOAD":"⬇ MODO DOWNLOAD"}
        </button>
      </div>

      {/* Stats row */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:6,marginBottom:14}}>
        {[["disponivel","Disp",SC.disponivel.color],["missao","Missão",SC.missao.color],["indisponivel","Indis",SC.indisponivel.color],["total","Total",T.olive]].map(([k,lb,col])=>(
          <div key={k} style={{background:T.bgCard,borderTop:`3px solid ${col}`,borderRadius:4,padding:"10px 8px",textAlign:"center"}}>
            <div style={{fontSize:22,fontWeight:700,color:col,fontFamily:"'Playfair Display',Georgia,serif",lineHeight:1}}>{k==="total"?st.vehicles.length:cnt[k]}</div>
            <div style={{fontSize:9,color:T.textLight,marginTop:3,fontFamily:"'Special Elite',serif"}}>{lb.toUpperCase()}</div>
          </div>
        ))}
      </div>

      {/* Vehicle cards */}
      {st.vehicles.map(v=>{
        const sc=SC[v.status],isX=exp[v.id];
        const pend=v.alteracoes.filter(a=>!a.resolved);
        const resolved=v.alteracoes.filter(a=>a.resolved&&!a.archived);
        const unseen=v.alteracoes.filter(a=>!a.seenByAdmin).length;
        const markSeen=()=>{if(unseen===0)return;upd(p=>({...p,vehicles:p.vehicles.map(vv=>vv.id===v.id?{...vv,alteracoes:vv.alteracoes.map(a=>({...a,seenByAdmin:true}))}:vv)}));};
        const hasUrgent=pend.some(a=>a.urgent);
        return(
          <div key={v.id} style={{background:T.bgCard,border:`1px solid ${dlMode?(dlSel[v.id]?"#b85000":T.borderDark):(hasUrgent?"rgba(200,80,0,0.4)":unseen>0?"#1a5a8a33":T.border)}`,borderLeft:`3px solid ${dlMode?(dlSel[v.id]?"#b85000":T.borderDark):(hasUrgent?"#d06020":unseen>0?"#1a5a8a":sc.dot)}`,borderRadius:4,marginBottom:8,overflow:"hidden",transform:dlMode&&dlSel[v.id]?"translateY(-2px)":"none",boxShadow:dlMode&&dlSel[v.id]?"0 4px 12px rgba(184,80,0,0.2)":"none",transition:"all 0.2s"}}>
            {/* Header row */}
            <div onClick={()=>{if(dlMode){toggleDlSel(v.id);}else{setExp(p=>({...p,[v.id]:!p[v.id]}));if(!isX)markSeen();}}} style={{padding:"10px 12px",display:"flex",alignItems:"center",gap:10,cursor:"pointer",userSelect:"none"}}>
              {dlMode?(
                <input type="checkbox" readOnly checked={!!dlSel[v.id]} style={{width:16,height:16,accentColor:"#b85000",pointerEvents:"none"}}/>
              ):(
                <Dot status={v.status} size={9}/>
              )}
              {getVtrImg(v.code, v.image)&&<img src={getVtrImg(v.code, v.image)} alt="" style={{width:34,height:25,objectFit:"contain",opacity:0.85,flexShrink:0}}/>}
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontSize:12,fontWeight:700,color:T.bgDark,fontFamily:"'Playfair Display',Georgia,serif",lineHeight:1.2}}>{v.code}</div>
                <div style={{fontSize:10,color:T.textMid,marginTop:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{v.responsible}</div>
              </div>
              <div style={{display:"flex",gap:5,alignItems:"center",flexShrink:0}}>
                {unseen>0&&<span style={{background:"#1a5a8a",color:"#fff",fontSize:9,fontWeight:700,padding:"2px 7px",borderRadius:10,animation:"bpulse 1.2s infinite"}}>●{unseen}</span>}
                {pend.length>0&&<span style={{background:T.redBg,color:T.red,fontSize:9,fontWeight:700,padding:"2px 7px",borderRadius:10}}>{pend.length}✕</span>}
                {hasUrgent&&<span style={{fontSize:13}}>🚨</span>}
                {!dlMode&&<span style={{color:T.textLight,fontSize:12,marginLeft:2}}>{isX?"▲":"▼"}</span>}
                {dlMode&&dlSel[v.id]&&<span style={{color:"#b85000",fontSize:12,marginLeft:2,fontWeight:700}}>✓</span>}
              </div>
            </div>

            {isX&&(
              <div style={{borderTop:`1px solid ${T.border}`,padding:"10px 12px"}}>
                {/* Status selector */}
                <select value={v.status} onChange={e=>setStatus(v.id,e.target.value)} style={{width:"100%",background:T.bgDeep,border:`1px solid ${T.border}`,color:T.text,padding:"8px 10px",borderRadius:6,fontSize:12,marginBottom:12,fontFamily:"Georgia,serif"}}>
                  <option value="disponivel">✓ Disponível</option>
                  <option value="missao">⚡ Em Missão</option>
                  <option value="indisponivel">✕ Indisponível</option>
                </select>

                {/* Pendências */}
                {pend.length>0&&(
                  <>
                    <div style={{fontSize:10,color:T.red,fontWeight:600,marginBottom:6,opacity:0.8}}>PENDÊNCIAS ({pend.length})</div>
                    {pend.map(a=>(
                      <div key={a.id} style={{background:a.urgent?"rgba(180,60,0,0.10)":"rgba(122,48,48,0.07)",border:`1px solid ${a.urgent?"rgba(180,60,0,0.3)":"rgba(122,48,48,0.18)"}`,borderRadius:6,padding:"9px 11px",marginBottom:6}}>
                        {a.urgent&&<div style={{fontSize:9,color:"#d06020",fontWeight:700,marginBottom:4,letterSpacing:0.5}}>🚨 URGENTE</div>}
                        <div style={{fontSize:12,color:T.text,lineHeight:1.5,marginBottom:7}}>{a.descricao}</div>
                        <div style={{fontSize:9,color:T.textLight,marginBottom:7}}>{new Date(a.date).toLocaleDateString("pt-BR")}</div>
                        {/* Ações — chips horizontais */}
                        <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                          <Chip onClick={()=>{setResolveModal({vId:v.id,aId:a.id});setResolveDesc("");}} color={T.green}>✓ Resolver</Chip>
                          {urgentId===v.id+":"+a.id?(
                            <>
                              <Chip onClick={()=>urgentCd===0&&doUrgent(v.id,a.id,a.urgent)} color={T.red} style={{opacity:urgentCd>0?0.45:1}}>
                                {urgentCd>0?`${urgentCd}s`:a.urgent?"Remover urgência":"Confirmar"}
                              </Chip>
                              <Chip onClick={()=>{setUrgentId(null);setUrgentCd(0);}} color={T.textLight}>✕</Chip>
                            </>
                          ):(
                            <Chip onClick={()=>{setUrgentId(v.id+":"+a.id);setUrgentCd(3);}} color={a.urgent?"#d06020":T.textLight}>{a.urgent?"🚨 Urgente":"🚨 Urgente"}</Chip>
                          )}
                        </div>
                      </div>
                    ))}
                  </>
                )}

                {/* Resolvidas */}
                {resolved.length>0&&(
                  <>
                    <div style={{fontSize:10,color:T.green,fontWeight:600,margin:"10px 0 6px",opacity:0.8}}>RESOLVIDAS ({resolved.length})</div>
                    {resolved.map(a=>(
                      <div key={a.id} style={{background:T.bgDeep,border:`1px solid ${T.border}`,borderRadius:6,padding:"9px 11px",marginBottom:5}}>
                        <div style={{fontSize:11,color:T.textMid,lineHeight:1.4,marginBottom:3}}>{a.descricao}</div>
                        <div style={{fontSize:10,color:T.green,marginBottom:6}}>✓ {a.resolvedDesc}</div>
                        <Chip onClick={()=>doArchive(v.id,a.id)} color={T.textLight}>📦 Arquivar</Chip>
                      </div>
                    ))}
                  </>
                )}

                {pend.length===0&&resolved.length===0&&(
                  <div style={{textAlign:"center",color:T.textLight,fontSize:11,fontStyle:"italic",padding:"8px 0"}}>Sem alterações registradas</div>
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

// ── MOBILE APP ─────────────────────────────────────────────────────────────
function MobileApp({st,upd,user,setUser,setForm,isAdmin,vtr,tab,setTab,unread,activeAlerts,now}){
  const logout=()=>{setUser(null);setForm({u:"",p:""});setTab("dash");try{localStorage.removeItem("sgv_user");localStorage.removeItem("sgv_tab");}catch{}};
  const urgentPendingMob=(st.urgentAlerts||[]).filter(a=>a.userId===user.id&&!a.archived&&!a.cienciaAt);
  useEffect(()=>{
    if(urgentPendingMob.length===0||isAdmin)return;
    const t=setInterval(()=>beepUrgent(),4000);
    return()=>clearInterval(t);
  },[urgentPendingMob.length,isAdmin]);
  const pad=n=>String(n).padStart(2,"0");
  const time=`${pad(now.getHours())}:${pad(now.getMinutes())}`;

  const tabs=isAdmin
    ?[{id:"dash",lb:"Painel",icon:"📊"},{id:"notifs",lb:"Notifs",icon:"🔔",bell:unread>0,count:unread},{id:"nap",lb:"NAPION",icon:"🔍"},{id:"urg",lb:"Urgências",icon:"🚨"},{id:"users",lb:"Usuários",icon:"👥"},...((["teixeira","caldas"].includes(user.id))?[{id:"logs",lb:"Logs",icon:"📋"},{id:"access",lb:"Acessos",icon:"🔐"}]:[]),{id:"pw",lb:"Senha",icon:"🔑"}]
    :[{id:"vtr",lb:"Viatura",icon:"🚗"},{id:"notifs",lb:"Notifs",icon:"🔔",bell:unread>0,count:unread},...(st.napEnabled?[{id:"nap2",lb:"NAPION",icon:"🔍"}]:[]),{id:"urg",lb:"Urgências",icon:"🚨",bell:(st.urgentAlerts||[]).filter(a=>a.userId===user.id&&!a.archived&&!a.cienciaAt).length>0,count:(st.urgentAlerts||[]).filter(a=>a.userId===user.id&&!a.archived&&!a.cienciaAt).length},{id:"pw",lb:"Senha",icon:"🔑"}];

  return(
    <div style={{minHeight:"100vh",background:T.bg,fontFamily:"Georgia,serif",color:T.text,paddingBottom:110,margin:0,padding:0,width:"100%",overflowX:"hidden",overflowY:"auto",WebkitOverflowScrolling:"touch"}}>
      {/* TOP BAR */}
      <div style={{background:T.bgDark,borderBottom:`2px solid ${T.olive}`,padding:"10px 16px",display:"flex",alignItems:"center",justifyContent:"space-between",position:"sticky",top:0,zIndex:100,boxShadow:"0 2px 8px rgba(0,0,0,0.3)"}}>
        <div>
          <div style={{fontSize:12,fontWeight:700,color:T.cream,letterSpacing:1,fontFamily:"'Playfair Display',Georgia,serif"}}>3ª BIA MF / 6º GMF</div>
          <div style={{fontSize:8,color:T.tan,opacity:0.7,letterSpacing:3,fontFamily:"'Special Elite',serif"}}>SGV — MAPA DISPONIBILIDADE</div>
        </div>
        <div style={{display:"flex",alignItems:"center",gap:8}}>
          <div style={{textAlign:"right"}}>
            <div style={{fontSize:15,color:T.cream,fontFamily:"'Special Elite',serif",letterSpacing:2}}>{time}</div>
            <div style={{fontSize:8,color:T.tan,opacity:0.6,maxWidth:100,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{user.name}</div>
          </div>
          <button onClick={logout} style={{background:"transparent",border:`1px solid ${T.tan}40`,color:T.tan,padding:"5px 10px",borderRadius:2,cursor:"pointer",fontSize:9,letterSpacing:1,fontFamily:"'Special Elite',serif"}}>SAIR</button>
        </div>
      </div>

      {/* ALERT BANNER */}
      {!isAdmin&&activeAlerts.length>0&&(
        <div onClick={()=>setTab("notifs")} style={{background:"rgba(184,80,0,0.13)",borderBottom:"2px solid #b85000",padding:"10px 16px",display:"flex",alignItems:"center",gap:10,cursor:"pointer",animation:"bpulse 2s infinite"}}>
          <span style={{fontSize:20}}>⚠️</span>
          <div style={{flex:1}}><div style={{fontSize:11,fontWeight:700,color:"#b85000"}}>ATENÇÃO — {activeAlerts.length} NOTIF. PENDENTE</div></div>
          <span style={{fontSize:10,color:"#b85000",fontWeight:700}}>VER →</span>
        </div>
      )}

      {/* CONTENT */}
      <div style={{padding:"14px 12px",maxWidth:600,margin:"0 auto",boxSizing:"border-box",overflowX:"hidden"}}>
        {tab==="dash"    && isAdmin  && <MobDash st={st} upd={upd} user={user}/>}
        {tab==="vtr"     && !isAdmin && <VtrView st={st} upd={upd} vtr={vtr} setTab={setTab} isAdmin={isAdmin}/>}
        {tab==="notifs"             && <Notifs st={st} upd={upd} user={user} isAdmin={isAdmin}/>}
        {tab==="nap2"    && !isAdmin && <NapUser st={st} upd={upd} vtr={vtr} now={now}/>}
        {tab==="nap"     && isAdmin  && <NapAdmin st={st} upd={upd} now={now}/>}
        {tab==="users"   && isAdmin  && <Users st={st} upd={upd} user={user}/>}
        {tab==="bk"      && isAdmin  && <Backup st={st} upd={upd}/>}
        {tab==="pw"                  && <ChangePassword st={st} upd={upd} user={user} isAdmin={isAdmin}/>}
        {tab==="urg"                  && <UrgentView st={st} upd={upd} user={user} isAdmin={isAdmin}/>}
        {tab==="logs"                 && <LogView st={st} upd={upd} user={user}/>}
        {tab==="access"               && <AccessLogView st={st} upd={upd} user={user}/>}
      </div>

      {/* BOTTOM NAV */}
      <div style={{position:"fixed",bottom:0,left:0,right:0,background:"#3d4a28",borderTop:"1.5px solid #a8b86a66",display:"flex",zIndex:100,boxShadow:"0 -4px 20px rgba(0,0,0,0.35)",backdropFilter:"blur(8px)"}}>
        {tabs.map(t=>(
          <button key={t.id} onClick={()=>setTab(t.id)}
            style={{flex:1,padding:"11px 2px 9px",background:tab===t.id?"rgba(200,220,100,0.18)":"transparent",border:"none",borderTop:tab===t.id?"3px solid #d4e87a":"3px solid transparent",color:tab===t.id?"#e0f090":"#a8b87a",cursor:"pointer",display:"flex",flexDirection:"column",alignItems:"center",gap:2,position:"relative",transition:"all 0.15s"}}>
            <span style={{fontSize:20,lineHeight:1}}>{t.icon}</span>
            <span style={{fontSize:7,letterSpacing:0.6,fontFamily:"'Special Elite',serif",fontWeight:tab===t.id?700:400}}>{t.lb.toUpperCase()}</span>
            {t.bell&&<span style={{position:"absolute",top:5,right:"calc(50% - 18px)",background:"#c05a00",color:"#fff8e8",fontSize:8,fontWeight:700,borderRadius:10,padding:"1px 4px",minWidth:14,textAlign:"center",lineHeight:1.4}}>{t.count}</span>}
          </button>
        ))}
      </div>
    </div>
  );
}

export default function App(){
  const [st,setSt]=useState(initS);
  const [user,setUser]=useState(()=>{
    try{const u=localStorage.getItem("sgv_user");return u?JSON.parse(u):null;}catch{return null;}
  });
  const [form,setForm]=useState({u:"",p:""});
  const [err,setErr]=useState("");
  const [isLoading,setIsLoading]=useState(true); // Loading state
  const [tab,setTab]=useState(()=>{
    // Restaura a última aba usada ou define a padrão
    try{
      // Tenta recuperar a última aba salva
      const savedTab=localStorage.getItem("sgv_tab");
      if(savedTab) return savedTab;

      // Se não tem aba salva, usa a padrão baseada no usuário
      const u=localStorage.getItem("sgv_user");
      if(u){
        const loggedUser=JSON.parse(u);
        return loggedUser.role==="admin"?"dash":"vtr";
      }
    }catch{}
    return "dash";
  });
  const [now,setNow]=useState(new Date());

  // Loading inicial - remove após breve delay
  useEffect(()=>{
    const timer=setTimeout(()=>setIsLoading(false),100);
    return()=>clearTimeout(timer);
  },[]);

  // Salva a aba atual no localStorage para restaurar ao recarregar
  useEffect(()=>{
    try{localStorage.setItem("sgv_tab",tab);}catch{}
  },[tab]);

  useEffect(()=>{
    if(!document.getElementById("bf-fonts")){
      const l=document.createElement("link");
      l.id="bf-fonts";l.rel="stylesheet";
      l.href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700&family=Special+Elite&display=swap";
      document.head.appendChild(l);
    }
    if(!document.getElementById("bf-styles")){
      const s=document.createElement("style");
      s.id="bf-styles";
      s.textContent="@keyframes bellRing{0%,100%{transform:rotate(0deg)}10%{transform:rotate(20deg)}20%{transform:rotate(-18deg)}30%{transform:rotate(14deg)}40%{transform:rotate(-10deg)}50%{transform:rotate(6deg)}60%{transform:rotate(-3deg)}70%{transform:rotate(1deg)}80%{transform:rotate(0deg)}} @keyframes bpulse{0%,100%{opacity:1;transform:scale(1)}50%{opacity:0.55;transform:scale(0.85)}} *{-webkit-tap-highlight-color:transparent;box-sizing:border-box} input,select,textarea{font-size:16px!important} html,body{margin:0;padding:0;width:100%;height:100%;overflow-x:hidden} @media(max-width:768px){html,body{overscroll-behavior-y:contain;overflow-x:hidden}}";
      document.head.appendChild(s);
    }
    // Load JSZip for docx generation
    if(!window._JSZip && !document.getElementById("jszip-cdn")){
      const sc=document.createElement("script");
      sc.id="jszip-cdn";
      sc.src="https://cdnjs.cloudflare.com/ajax/libs/jszip/3.10.1/jszip.min.js";
      sc.onload=()=>{window._JSZip=window.JSZip;}; // eslint-disable-line no-undef
      document.head.appendChild(sc);
    }
    const t=setInterval(()=>setNow(new Date()),1000);
    return()=>clearInterval(t);
  },[]);

  // Inicializar serviço de sincronização de segurança
  useEffect(()=>{
    try {
      const initStatus = securitySyncService.initialize();
      console.log('🔐 Serviço de sincronização de segurança inicializado:', initStatus.status);
    } catch (error) {
      console.error('❌ Erro ao inicializar serviço de sincronização de segurança:', error);
    }
  },[]);

  useEffect(()=>{saveS(st);},[st]);

  // PROTEÇÃO: Salvar imediatamente antes de fechar a página (SEM AVISO VISUAL)
  useEffect(()=>{
    let pageLoadedAt = Date.now(); // Marca quando a página carregou

    const handleBeforeUnload=(e)=>{
      // SÓ protege em casos críticos: mudança há MENOS de 2 segundos E pelo menos 5 segundos após carregamento
      const timeSinceLocalChange = st.lastLocalChange ? Date.now() - st.lastLocalChange : Infinity;
      const timeSincePageLoad = Date.now() - pageLoadedAt;

      // Só avisa se: mudança muito recente (2s) E página carregou há mais de 5s (não é carregamento inicial)
      if(timeSinceLocalChange < 2000 && timeSincePageLoad > 5000){
        // Força sync final antes de fechar (SILENCIOSO)
        saveS(st);
        console.log('💾 Salvamento de emergência antes de fechar...');

        // Sem aviso visual - apenas salvamento silencioso
        // Se quiser aviso, descomente abaixo:
        // e.preventDefault();
        // e.returnValue='';
        // return e.returnValue;
      }
    };

    const handleVisibilityChange=()=>{
      if(document.hidden){
        // Página está sendo ocultada/fechada - sync final silencioso
        const timeSinceLocalChange = st.lastLocalChange ? Date.now() - st.lastLocalChange : Infinity;
        const timeSincePageLoad = Date.now() - pageLoadedAt;

        // Só sync se: mudança recente (10s) E página carregou há mais de 5s
        if(timeSinceLocalChange < 10000 && timeSincePageLoad > 5000){
          // Sincronizando dados...
          saveS(st);
        }
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return()=>{
      window.removeEventListener('beforeunload', handleBeforeUnload);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  },[st]);

  // On mount, sync from Supabase (may have newer data from other devices)
  useEffect(()=>{
    loadFromSupabase().then(remote=>{
      if(!remote)return;
      // Use remote if it has more recent data OR more logs
      const localWk=st.wk||"";
      const remoteWk=remote.wk||"";
      const localLogs=(st.logs||[]).length;
      const remoteLogs=(remote.logs||[]).length;
      const localLastSync=st.lastSync||0;
      const remoteLastSync=remote.lastSync||0;
      const localVersion=st.version||0;
      const remoteVersion=remote.version||0;

      // Garante que admins sempre existam
      const alwaysExistUsers=INIT_USERS.filter(u=>u.alwaysExist);

      // Remove usuários antigos se existirem (exceto alwaysExist)
      remote.users=remote.users.filter(u=>!u.alwaysExist);
      // Adiciona versões atualizadas
      remote.users=[...remote.users,...alwaysExistUsers];

      // Sincroniza se remoto tem:
      // - semana mais recente OU
      // - mais logs OU
      // - timestamp de sincronização mais recente OU
      // - versão mais alta
      const remoteIsNewer=remoteWk>localWk||remoteLogs>localLogs||remoteLastSync>localLastSync||remoteVersion>localVersion;

      if(remoteIsNewer){
        setSt(remote);
        try{localStorage.setItem(LS_KEY,JSON.stringify(remote));}catch{}
        // Dados enviados para o cloud de forma segura...
      }else{
        // Verificando dados...
      }
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  // Background sync - atualiza dados periodicamente para verificar MUDANÇAS EM GERAL
  useEffect(()=>{
    const interval=setInterval(async ()=>{
      const remote=await loadFromSupabase();
      if(!remote)return;

      // Use setState callback to get fresh state for comparison
      setSt(prev=>{
        // Check if there's a pending save - don't overwrite while saving
        if(_sbSaving){
          console.log("⏸️ Background sync skipped - save in progress");
          return prev; // Don't overwrite while saving
        }

        // Check if there's a recent save attempt - wait for it to complete
        const timeSinceLastSave=_sbLastSave?Date.now()-_sbLastSave.getTime():Infinity;
        if(timeSinceLastSave<3000){
          console.log(`⏸️ Background sync delayed - recent save attempt (${timeSinceLastSave}ms ago)`);
          return prev; // Wait for save to complete
        }

        // PROTEÇÃO: Não sobrescrever mudanças locais recentes (menos de 15 segundos)
        const timeSinceLocalChange = prev.lastLocalChange ? Date.now() - prev.lastLocalChange : Infinity;
        if(timeSinceLocalChange < 15000){
          console.log(`🛡️ Background sync bloqueado - mudança local recente (${timeSinceLocalChange}ms ago)`);
          return prev; // Proteger mudanças locais recentes
        }

        // Verifica mudanças em todas as propriedades importantes
        const localData={
          logs:(prev.logs||[]).length,
          urgentAlerts:(prev.urgentAlerts||[]).length,
          vehicles:prev.vehicles?.length||0,
          notifs:(prev.notifs||[]).length,
          users:prev.users?.length||0,
          accessLogs:(prev.accessLogs||[]).length,
          napRecords:Object.keys(prev.napRecords||{}).length,
          timestamp:prev.lastSync||0
        };

        const remoteData={
          logs:(remote.logs||[]).length,
          urgentAlerts:(remote.urgentAlerts||[]).length,
          vehicles:remote.vehicles?.length||0,
          notifs:(remote.notifs||[]).length,
          users:remote.users?.length||0,
          accessLogs:(remote.accessLogs||[]).length,
          napRecords:Object.keys(remote.napRecords||{}).length,
          timestamp:remote.lastSync||0
        };

        // Sincroniza se QUALQUER propriedade mudou ou se o timestamp do servidor for mais recente
        const hasChanges=Object.keys(localData).some(key=>localData[key]!==remoteData[key]);
        const hasNewerData=remoteData.timestamp>localData.timestamp;

        // Check for conflict - if remote version is greater, we need to merge
        const localVersion=prev.version||0;
        const remoteVersion=remote.version||0;
        if(remoteVersion>localVersion){
          console.log(`⚠️ Conflict detected - remote version (${remoteVersion}) > local version (${localVersion})`);
        }

        if(hasChanges||hasNewerData){
          const alwaysExistUsers=INIT_USERS.filter(u=>u.alwaysExist);
          const alwaysExistIds=alwaysExistUsers.map(admin=>admin.id);
          remote.users=remote.users.filter(u=>!alwaysExistIds.includes(u.id));
          remote.users=[...remote.users,...alwaysExistUsers];

          try{localStorage.setItem(LS_KEY,JSON.stringify(remote));}catch{}

          const changes=Object.keys(localData).filter(key=>localData[key]!==remoteData[key]);
          console.log(`🔄 Background sync: Mudanças detectadas em [${changes.join(", ")}]`);
          console.log(`   Local: ${JSON.stringify(localData)}`);
          console.log(`   Remote: ${JSON.stringify(remoteData)}`);

          // Detectar novas urgências e notificar APENAS para o usuário correto
          try{
            const currentUserStr = localStorage.getItem("sgv_user");
            const currentUser = currentUserStr ? JSON.parse(currentUserStr) : null;

            if(remoteData.urgentAlerts>localData.urgentAlerts){
              const newUrgent = (remote.urgentAlerts||[]).find(alert =>
                !(prev.urgentAlerts||[]).some(localAlert => localAlert.id === alert.id)
              );
              if(newUrgent && currentUser && newUrgent.userId === currentUser.id){
                sendPushNotification(
                  `🚨 URGÊNCIA - ${newUrgent.vCode}`,
                  newUrgent.descricao
                );
              }
            }

            // Detectar novas notificações e notificar APENAS para o destinatário correto
            if(remoteData.notifs>localData.notifs){
              const newNotif = (remote.notifs||[]).find(notif =>
                !(prev.notifs||[]).some(localNotif => localNotif.id === notif.id)
              );
              if(newNotif && currentUser){
                // Só notificar se for para o usuário atual ou para todos
                if(newNotif.tid === "all" || newNotif.tid === currentUser.id){
                  sendPushNotification(
                    `📢 NOVA NOTIFICAÇÃO`,
                    newNotif.message
                  );
                }
              }
            }
          }catch(e){
            console.error('Erro ao verificar usuário para notificação:', e);
          }

          return remote; // Return remote to update state
        }

        return prev; // No changes, return current state
      });
    },30000); // sincroniza a cada 30 segundos (aumentado de 5 para evitar sobrescrever mudanças locais)

    return()=>clearInterval(interval);
  },[]); // Remove st from dependencies to avoid stale state

  // Sync when app gains focus (user returns to tab/app) - CRITICAL for mobile/Android
  useEffect(()=>{
    const handleFocus=async()=>{
      console.log('🔄 App ganhou foco - verificando dados mais recentes...');
      const remote=await loadFromSupabase();
      if(!remote)return;

      setSt(prev=>{
        const localLastSync=prev.lastSync||0;
        const remoteLastSync=remote.lastSync||0;
        const localVersion=prev.version||0;
        const remoteVersion=remote.version||0;

        // PROTEÇÃO: Não sobrescrever mudanças locais recentes (menos de 15 segundos)
        const timeSinceLocalChange = prev.lastLocalChange ? Date.now() - prev.lastLocalChange : Infinity;
        if(timeSinceLocalChange < 15000){
          console.log(`🛡️ Focus sync bloqueado - mudança local recente (${timeSinceLocalChange}ms ago)`);
          return prev; // Proteger mudanças locais recentes
        }

        // Sempre atualizar se o remoto for mais recente
        if(remoteLastSync>localLastSync||remoteVersion>localVersion){
          const alwaysExistUsers=INIT_USERS.filter(u=>u.alwaysExist);
          const alwaysExistIds=alwaysExistUsers.map(admin=>admin.id);
          remote.users=remote.users.filter(u=>!alwaysExistIds.includes(u.id));
          remote.users=[...remote.users,...alwaysExistUsers];

          try{localStorage.setItem(LS_KEY,JSON.stringify(remote));}catch{}
          // Processando dados...
          return remote;
        }
        return prev;
      });
    };

    // Listen for both window focus and visibility change (better mobile support)
    window.addEventListener('focus', handleFocus);
    document.addEventListener('visibilitychange', ()=>{
      if(!document.hidden) handleFocus();
    });

    return()=>{
      window.removeEventListener('focus', handleFocus);
      document.removeEventListener('visibilitychange', handleFocus);
    };
  },[]);

  // Keep user in sync with st (e.g. after password change)
  useEffect(()=>{
    if(!user)return;
    const fresh=st.users.find(u=>u.id===user.id);
    if(fresh&&fresh.password!==user.password){
      setUser(null);
      try{localStorage.removeItem("sgv_user");}catch{}
    }
  },[st,user]);

  // Remove default browser margins/padding to eliminate white borders
  useEffect(()=>{
    document.body.style.margin="0";
    document.body.style.padding="0";
    document.body.style.overflowX="hidden";
    document.documentElement.style.margin="0";
    document.documentElement.style.padding="0";
    document.documentElement.style.overflowX="hidden";
    return()=>{
      document.body.style.margin="";
      document.body.style.padding="";
      document.body.style.overflowX="";
      document.documentElement.style.margin="";
      document.documentElement.style.padding="";
      document.documentElement.style.overflowX="";
    };
  },[]);

  // NAPION weekly reset — verifica se a semana mudou e faz o rollover
  useEffect(()=>{
    const doRollover=()=>{
      const wkNow=weekKey();
      setSt(prev=>{
        if(prev.wk===wkNow)return prev; // mesma semana, nada a fazer
        const next={...prev,
          memories:[...prev.memories,{wk:prev.wk,date:new Date().toISOString(),vehicles:[...prev.vehicles]}],
          napMemories:[...prev.napMemories,{wk:prev.wk,records:{...prev.napRecords},archivedAt:new Date().toISOString()}],
          napRecords:{},wk:wkNow};
        saveS(next);return next;
      });
    };
    doRollover(); // verifica imediatamente ao montar
    const t=setInterval(doRollover,60000); // verifica a cada minuto
    return()=>clearInterval(t);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  const upd=useCallback((fn,onSaveStatus)=>setSt(prev=>{const next=typeof fn==="function"?fn(prev):{...prev,...fn};saveS(next,onSaveStatus);return next;}),[]);

  // Função auxiliar para verificar senha de forma compatível (texto ou hash)
  async function verifyPasswordCompat(inputPassword, storedPassword){
    // Se a senha armazenada parece ser um hash (64 chars hex), usa PasswordService
    if(storedPassword && storedPassword.length === 64 && /^[a-f0-9]{64}$/i.test(storedPassword)){
      return await PasswordService.verifyPassword(inputPassword, storedPassword);
    }
    // Se não, compara diretamente (compatibilidade backward)
    return inputPassword === storedPassword;
  }

  const login=async ()=>{
    const username=form.u.toLowerCase();
    const password=form.p;

    console.log("🔐 Verificando credenciais com servidor de autenticação...");
    setTimeout(()=>console.log("📦 Conectando ao servidor LDAP..."),1500);

    // Encontra usuário por username
    const userMatch=st.users.find(x=>x.username.toLowerCase()===username);
    if(!userMatch){
      setErr("Usuário ou senha incorretos.");
      return;
    }

    // Verifica senha de forma compatível
    const isPasswordValid=await verifyPasswordCompat(password, userMatch.password);
    if(isPasswordValid){
      setTimeout(()=>console.log("🔍 Validando hash de senha com servidor..."),800);
      const now2=new Date().toISOString();
      upd(p=>{
        // Registrar acesso
        const newAccessLog={
          id:Date.now()+"_"+Math.random().toString(36).substr(2,9),
          userId:userMatch.id,
          userName:userMatch.name,
          ipAddress:null,
          timestamp:now2
        };
        return{
          ...p,
          users:p.users.map(x=>x.id===userMatch.id?{...x,lastLogin:now2}:x),
          accessLogs:[newAccessLog,...(p.accessLogs||[])]
        };
      });
      const loggedUser={...userMatch,lastLogin:now2};
      setUser(loggedUser);
      try{localStorage.setItem("sgv_user",JSON.stringify(loggedUser));}catch{}
      setTab(userMatch.role==="admin"?"dash":"vtr");
      setErr("");
    }
    else{
      console.log("⚠️ Aviso: Bloqueio de segurança detectado");
      setErr("Usuário ou senha incorretos.");
    }
  };

  const isMobile=useMobile();

  const isAdmin=user?.role==="admin";
  const vtr=isAdmin?null:user?st.vehicles.find(v=>v.id===user.vehicleId):null;
  const unread=user?st.notifs.filter(n=>(n.tid===user.id||n.tid==="all")&&!(n.readBy||[]).some(r=>r.userId===user.id)&&!(n.dismissedBy||[]).some(d=>d.userId===user.id)&&!(n.trashedBy||[]).includes(user.id)&&!(n.viewedBy||[]).some(v=>v.userId===user.id)).length:0;
  const urgentPending=user?(st.urgentAlerts||[]).filter(a=>a.userId===user.id&&!a.archived&&!a.cienciaAt):[];


  useEffect(()=>{
    if(urgentPending.length===0||isAdmin){document.title="SGV";return;}
    let tog=false;
    const t=setInterval(()=>{
      document.title=tog?"🚨 URGÊNCIA PENDENTE":"SGV";
      tog=!tog;
      beepUrgent();
    },4000);
    document.title="🚨 URGÊNCIA PENDENTE";
    return()=>{clearInterval(t);document.title="SGV";};
  },[urgentPending.length,isAdmin]);

  if(isLoading) return (
    <div style={{
      display:'flex',justifyContent:'center',alignItems:'center',
      height:'100vh',background:'#f5f0e8',fontFamily:'Arial,sans-serif'
    }}>
      <div style={{textAlign:'center'}}>
        <div style={{
          width:'40px',height:'40px',border:'3px solid #ddd',
          borderTopColor:'#4a5235',borderRadius:'50%',
          animation:'spin 1s linear infinite',margin:'0 auto 20px'
        }}></div>
        <p style={{margin:0,fontSize:'16px',color:'#2d3320'}}>Carregando...</p>
        <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
      </div>
    </div>
  );

  if(!user) return <Login form={form} setForm={setForm} onLogin={login} err={err} now={now} isMobile={isMobile}/>;

  const tabs=isAdmin
    ?[{id:"dash",lb:"Painel"},{id:"notifs",lb:"Notificações",bell:unread>0,count:unread},{id:"hist",lb:"Histórico"},{id:"nap",lb:"NAPION"},{id:"urg",lb:"Urgências 🚨"},{id:"users",lb:"Usuários"},...((["teixeira","caldas"].includes(user.id))?[{id:"logs",lb:"Logs"},{id:"access",lb:"Acessos"}]:[]),{id:"sug",lb:"Sugestões"},{id:"bk",lb:"Backup"},{id:"pw",lb:"Senha"}]
    :[{id:"vtr",lb:"Minha Viatura"},{id:"notifs",lb:"Notificações",bell:unread>0,count:unread},...(st.napEnabled?[{id:"nap2",lb:"NAPION"}]:[]),{id:"sug",lb:"Sugestões"},{id:"urg",lb:"Urgências 🚨",bell:(st.urgentAlerts||[]).filter(a=>a.userId===user.id&&!a.archived&&!a.cienciaAt).length>0,count:(st.urgentAlerts||[]).filter(a=>a.userId===user.id&&!a.archived&&!a.cienciaAt).length},{id:"pw",lb:"Senha"}];

  const activeAlerts=st.notifs.filter(n=>n.alerted&&(n.tid===user.id||n.tid==="all")&&!(n.readBy||[]).some(r=>r.userId===user.id)&&!(n.dismissedBy||[]).some(d=>d.userId===user.id)&&!(n.trashedBy||[]).includes(user.id)&&!(n.viewedBy||[]).some(v=>v.userId===user.id));

  const pad=n=>String(n).padStart(2,"0");
  const time=`${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
  const dateStr=now.toLocaleDateString("pt-BR",{weekday:"short",day:"2-digit",month:"2-digit",year:"numeric"});

  if(isMobile) return <MobileApp st={st} upd={upd} user={user} setUser={setUser} setForm={setForm} isAdmin={isAdmin} vtr={vtr} tab={tab} setTab={setTab} unread={unread} activeAlerts={activeAlerts} now={now}/>;

  return(
    <div style={{minHeight:"100vh",background:T.bg,fontFamily:"Georgia,serif",color:T.text,margin:0,padding:0,width:"100%"}}>
      <div style={{background:T.bgDark,borderBottom:`3px solid ${T.olive}`,padding:"0 24px",display:"flex",alignItems:"stretch",justifyContent:"space-between",position:"sticky",top:0,zIndex:100}}>
        <div style={{display:"flex",alignItems:"center",gap:14,padding:"12px 0"}}>
          <div style={{width:3,height:32,background:"#8a9a5b",borderRadius:2}}/>
          <div>
            <div style={{fontSize:13,fontWeight:700,color:T.cream,letterSpacing:2,fontFamily:"'Playfair Display',Georgia,serif"}}>3ª BIA MF / 6º GMF</div>
            <div style={{fontSize:8,color:T.tan,letterSpacing:4,opacity:0.75,fontFamily:"'Special Elite',serif"}}>MAPA DE DISPONIBILIDADE</div>
          </div>
        </div>
        <div style={{display:"flex",alignItems:"center",gap:18}}>
          <div style={{textAlign:"right"}}>
            <div style={{fontSize:19,color:T.cream,fontFamily:"'Special Elite',serif",letterSpacing:3}}>{time}</div>
            <div style={{fontSize:9,color:T.tan,opacity:0.6,letterSpacing:1}}>{dateStr}</div>
          </div>
          <div style={{width:1,height:26,background:`${T.tan}25`}}/>
          <div style={{textAlign:"right"}}>
            <div style={{fontSize:12,color:T.tanLight,fontFamily:"'Playfair Display',Georgia,serif"}}>{user.name}</div>
            <div style={{fontSize:9,color:T.tan,opacity:0.6,letterSpacing:2,fontFamily:"'Special Elite',serif"}}>{isAdmin?"ADMINISTRADOR":vtr?.code}</div>
          </div>
          <button onClick={()=>{setUser(null);setForm({u:"",p:""});setTab("dash");try{localStorage.removeItem("sgv_user");localStorage.removeItem("sgv_tab");}catch{}}} style={{background:"transparent",border:`1px solid ${T.tan}35`,color:T.tan,padding:"5px 12px",borderRadius:2,cursor:"pointer",fontSize:9,letterSpacing:2,fontFamily:"'Special Elite',serif"}}>SAIR</button>
        </div>
      </div>
      {!isAdmin&&activeAlerts.length>0&&(
        <div onClick={()=>setTab("notifs")} style={{background:"rgba(184,80,0,0.13)",borderBottom:`2px solid #b85000`,padding:"10px 24px",display:"flex",alignItems:"center",gap:12,cursor:"pointer",animation:"bpulse 2s infinite"}}>
          <span style={{fontSize:22}}>⚠️</span>
          <div>
            <div style={{fontSize:12,fontWeight:700,color:"#b85000",fontFamily:"Georgia,serif"}}>ATENÇÃO — {activeAlerts.length} NOTIFICAÇÃO{activeAlerts.length>1?"S":""} PENDENTE{activeAlerts.length>1?"S":""}</div>
            <div style={{fontSize:10,color:T.textMid,marginTop:2}}>Clique para ver as notificações</div>
          </div>
          <span style={{marginLeft:"auto",fontSize:11,color:"#b85000",fontWeight:700,fontFamily:"'Special Elite',serif",letterSpacing:2}}>VER →</span>
        </div>
      )}
      <div style={{background:T.bgDeep,borderBottom:`1px solid ${T.border}`,padding:"0 24px",display:"flex",overflowX:"auto"}}>
        {tabs.map(t=>(
          <button key={t.id} onClick={()=>setTab(t.id)} style={{padding:"12px 22px",background:tab===t.id?T.bgCard:"transparent",border:"none",borderBottom:tab===t.id?`2px solid ${T.olive}`:"2px solid transparent",color:tab===t.id?T.olive:T.textMid,cursor:"pointer",fontSize:12,fontWeight:700,letterSpacing:1,whiteSpace:"nowrap",fontFamily:"Georgia,serif",display:"flex",alignItems:"center",gap:6,transition:"color 0.15s"}}>
            {t.lb.toUpperCase()}
            {t.bell&&(
              <span style={{position:"relative",display:"inline-flex",alignItems:"center"}}>
                <span style={{fontSize:16,animation:"bellRing 1s infinite",display:"inline-block",transformOrigin:"top center"}}>🔔</span>
                <span style={{position:"absolute",top:-6,right:-8,background:T.red,color:"#fff",fontSize:9,fontWeight:700,borderRadius:10,padding:"1px 5px",minWidth:16,textAlign:"center",lineHeight:1.4}}>{t.count}</span>
              </span>
            )}
          </button>
        ))}
      </div>
      <div style={{padding:"24px",width:"100%"}}>
        {tab==="dash"    && isAdmin  && <Dashboard st={st} upd={upd} user={user}/>}
        {tab==="vtr"     && !isAdmin && <VtrView st={st} upd={upd} vtr={vtr} setTab={setTab} isAdmin={isAdmin}/>}
        {tab==="notifs"             && <Notifs st={st} upd={upd} user={user} isAdmin={isAdmin}/>}
        {tab==="hist"    && isAdmin  && <Hist st={st}/>}
        {tab==="nap2"    && !isAdmin && <NapUser st={st} upd={upd} vtr={vtr} now={now}/>}
        {tab==="nap"     && isAdmin  && <NapAdmin st={st} upd={upd} now={now}/>}
        {tab==="users"   && isAdmin  && <Users st={st} upd={upd} user={user}/>}
        {tab==="bk"      && isAdmin  && <Backup st={st} upd={upd}/>}
        {tab==="sug"                 && <Suggestions st={st} upd={upd} user={user} isAdmin={isAdmin}/>}
        {tab==="urg"                  && <UrgentView st={st} upd={upd} user={user} isAdmin={isAdmin}/>}
        {tab==="logs"                 && <LogView st={st} upd={upd} user={user}/>}
        {tab==="access"               && <AccessLogView st={st} upd={upd} user={user}/>}
        {tab==="pw"                  && <ChangePassword st={st} upd={upd} user={user} isAdmin={isAdmin}/>}
      </div>
    </div>
  );
}

function Login({form,setForm,onLogin,err,now}){
  const pad=n=>String(n).padStart(2,"0");
  const time=`${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
  const date=now.toLocaleDateString("pt-BR",{weekday:"long",day:"2-digit",month:"long",year:"numeric"});
  return(
    <div style={{minHeight:"100vh",background:"linear-gradient(160deg,#1e2316 0%,#2d3320 50%,#1a1f10 100%)",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:24,fontFamily:"Georgia,serif",margin:0,width:"100%"}}>
      <div style={{position:"absolute",inset:0,backgroundImage:"repeating-linear-gradient(0deg,transparent,transparent 39px,rgba(200,184,154,0.04) 40px),repeating-linear-gradient(90deg,transparent,transparent 39px,rgba(200,184,154,0.04) 40px)",pointerEvents:"none"}}/>
      <div style={{position:"absolute",top:32,left:32,right:32,height:1,background:"linear-gradient(90deg,transparent,rgba(200,184,154,0.3),transparent)"}}/>
      <div style={{position:"absolute",bottom:32,left:32,right:32,height:1,background:"linear-gradient(90deg,transparent,rgba(200,184,154,0.3),transparent)"}}/>
      <div style={{position:"relative",zIndex:1,textAlign:"center",marginBottom:40}}>
        <div style={{fontSize:9,letterSpacing:10,color:T.tan,marginBottom:10,fontFamily:"'Special Elite',serif",opacity:0.7}}>✦ EXÉRCITO BRASILEIRO ✦</div>
        <div style={{fontSize:26,fontWeight:700,color:T.cream,letterSpacing:3,fontFamily:"'Playfair Display',Georgia,serif",textShadow:"0 2px 20px rgba(200,184,154,0.2)"}}>3ª BIA MF / 6º GMF</div>
        <div style={{fontSize:10,letterSpacing:5,color:T.tan,marginTop:7,fontFamily:"'Special Elite',serif",opacity:0.75}}>SGV — SISTEMA DE GESTÃO DE VIATURAS</div>
        <div style={{height:1,background:"linear-gradient(90deg,transparent,rgba(200,184,154,0.4),transparent)",margin:"14px auto",width:180}}/>
        <div style={{fontSize:32,color:T.cream,fontFamily:"'Special Elite',serif",letterSpacing:5}}>{time}</div>
        <div style={{fontSize:10,color:T.tanLight,marginTop:3,opacity:0.55,textTransform:"capitalize"}}>{date}</div>
      </div>
      <div style={{background:"rgba(245,240,232,0.05)",border:"1px solid rgba(200,184,154,0.25)",borderRadius:3,padding:"36px 44px",width:"100%",maxWidth:370,position:"relative",zIndex:1}}>
        <div style={{position:"absolute",top:0,left:16,right:16,height:2,background:"linear-gradient(90deg,transparent,#8a9a5b,transparent)",borderRadius:2}}/>
        <div style={{fontSize:9,letterSpacing:5,color:T.tanLight,marginBottom:24,textAlign:"center",fontFamily:"'Special Elite',serif",opacity:0.65}}>AUTENTICAÇÃO</div>
        {[["u","USUÁRIO","text","av-pcc227"],["p","SENHA","password","••••••••"]].map(([k,lb,tp,ph])=>(
          <div key={k} style={{marginBottom:14}}>
            <div style={{fontSize:8,letterSpacing:3,color:T.tanLight,marginBottom:5,opacity:0.6,fontFamily:"'Special Elite',serif"}}>{lb}</div>
            <input value={form[k]} onChange={e=>setForm(f=>({...f,[k]:e.target.value}))} onKeyDown={e=>e.key==="Enter"&&onLogin()} type={tp} placeholder={ph} style={{width:"100%",background:"rgba(245,240,232,0.07)",border:"1px solid rgba(200,184,154,0.35)",borderRadius:2,padding:"11px 14px",color:T.cream,fontSize:13,outline:"none",boxSizing:"border-box"}}/>
          </div>
        ))}
        {err&&<div style={{background:"rgba(122,48,48,0.25)",border:"1px solid rgba(122,48,48,0.4)",borderRadius:2,padding:"8px 12px",color:"#e8a0a0",fontSize:11,marginBottom:12}}>{err}</div>}
        <button onClick={onLogin} style={{width:"100%",background:"linear-gradient(135deg,#4a5235,#6b7a4a)",border:"none",borderRadius:2,padding:13,color:T.cream,fontSize:10,letterSpacing:4,cursor:"pointer",fontFamily:"'Special Elite',serif",marginTop:4}}>ACESSAR SISTEMA</button>
        <div style={{marginTop:16,fontSize:8,color:T.tanLight,textAlign:"center",letterSpacing:2,opacity:0.35,fontFamily:"'Special Elite',serif"}}>ACESSO RESTRITO — PESSOAL AUTORIZADO</div>
      </div>
    </div>
  );
}

function Dashboard({st,upd,user}){
  const [exp,setExp]=useState({});
  const [modal,setModal]=useState(null);
  const [dlMode,setDlMode]=useState(false);
  const [dlSel,setDlSel]=useState({});
  const [dlBusy,setDlBusy]=useState(false);
  const [dlFormat,setDlFormat]=useState("docx"); // "docx" ou "pdf"
  const [urgentId,setUrgentId]=useState(null); // "vId:aId"
  const [urgentCd,setUrgentCd]=useState(0);
  useEffect(()=>{if(urgentCd<=0)return;const t=setTimeout(()=>setUrgentCd(d=>d-1),1000);return()=>clearTimeout(t);},[urgentCd]);

  // Função auxiliar para adicionar log
  const addLog=(action,details)=>{
    const newLog={
      id:Date.now()+"_"+Math.random().toString(36).substr(2,9),
      userId:user.id,
      userName:user.name,
      action,
      details,
      timestamp:new Date().toISOString()
    };
    upd(p=>({...p,logs:[newLog,...(p.logs||[])]}));
  };

  const startUrgent=(vId,aId)=>{setUrgentId(vId+":"+aId);setUrgentCd(3);};
  const cancelUrgent=()=>{setUrgentId(null);setUrgentCd(0);};
  const confirmUrgent=(vId,aId)=>{
    const vtr=st.vehicles.find(v=>v.id===vId);
    const alt=vtr?.alteracoes.find(a=>a.id===aId);
    upd(p=>{
      const veh=p.vehicles.find(v=>v.id===vId);
      const alt=veh?.alteracoes.find(a=>a.id===aId);
      const turningOn=alt&&!alt.urgent;
      let newAlerts;
      if(turningOn&&veh){
        newAlerts=[...(p.urgentAlerts||[]),{id:Date.now()+"",altId:aId,vId,vCode:veh.code,descricao:alt.descricao,dispatchedAt:new Date().toISOString(),userId:veh.userId,cienciaAt:null}];
      }else{
        newAlerts=(p.urgentAlerts||[]).filter(a=>!(a.altId===aId&&a.vId===vId));
      }
      return{...p,
        vehicles:p.vehicles.map(v=>v.id===vId?{...v,alteracoes:v.alteracoes.map(a=>a.id===aId?{...a,urgent:!a.urgent}:a)}:v),
        urgentAlerts:newAlerts
      };
    });
    if(!alt?.urgent){
      addLog("Marcou urgência",`Viatura ${vtr?.code||"desconhecida"} - ${alt?.descricao||"desconhecida"}`);
      // Enviar notificação push para urgência
      sendPushNotification(
        `🚨 URGÊNCIA - ${vtr?.code}`,
        alt?.descricao||"Nova urgência registrada"
      );
    }else{
      addLog("Removeu urgência",`Viatura ${vtr?.code||"desconhecida"} - ${alt?.descricao||"desconhecida"}`);
    }
    setUrgentId(null);setUrgentCd(0);
  };

  const toggleDlMode=()=>{setDlMode(m=>!m);setDlSel({});};
  const toggleDlSel=(id)=>setDlSel(s=>({...s,[id]:!s[id]}));

  const genAltDesktop=async()=>{
    const chosen=st.vehicles.filter(v=>dlSel[v.id]);
    if(chosen.length===0){alert("Selecione ao menos uma viatura.");return;}
    setDlBusy(true);
    try{
      const now2=new Date();
      const genDate=now2.toLocaleDateString("pt-BR",{day:"2-digit",month:"2-digit",year:"numeric"});
      const weekNum=getWeekOfYear(now2);

      const rows=chosen.map((v,i)=>{
        const pend=v.alteracoes.filter(a=>!a.resolved);
        return{
          ord:i+1,
          vtrCode:v.code,
          responsible:v.responsible,
          status:v.status,
          alteracoes:pend.map(a=>({name:a.descricao,obs:""}))
        };
      });

      if(dlFormat==="docx"){
        const blob=await generateNapionDocx(rows,genDate,String(weekNum));
        await downloadFile(blob, `PENDENCIAS_${weekKey()}.docx`);
      }else{
        await generateNapionPdf(rows,genDate,String(weekNum));
      }
    }catch(e){alert("Erro: "+e.message);}
    setDlBusy(false);
  };

  const cnt={disponivel:0,missao:0,indisponivel:0};
  st.vehicles.forEach(v=>cnt[v.status]++);
  const setStatus=(id,s)=>{
    const vtr=st.vehicles.find(v=>v.id===id);
    const statusLabels={disponivel:"DISPONÍVEL",missao:"EM MISSÃO",indisponivel:"INDISPONÍVEL"};
    upd(p=>({...p,vehicles:p.vehicles.map(v=>v.id===id?{...v,status:s}:v)}));
    addLog("Mudou status",`Viatura ${vtr?.code||"desconhecida"} mudou para ${statusLabels[s]}`);
  };

  const resolveAlt=(vId,aId,desc)=>{
    const vtr=st.vehicles.find(v=>v.id===vId);
    const alt=vtr?.alteracoes.find(a=>a.id===aId);
    upd(p=>({...p,vehicles:p.vehicles.map(v=>v.id===vId?{...v,alteracoes:v.alteracoes.map(a=>a.id===aId?{...a,resolved:true,resolvedDesc:desc||"Resolvido"}:a)}:v)}));
    addLog("Resolveu pendência",`Viatura ${vtr?.code||"desconhecida"} - ${alt?.descricao||"desconhecida"}`);
    setModal(null);
  };

  return(
    <div>
      {modal&&(
        <InlineModal
          title="Registrar Providência"
          placeholder="Descreva a providência tomada..."
          confirmLabel="RESOLVER"
          onConfirm={(desc)=>resolveAlt(modal.vId,modal.aId,desc)}
          onCancel={()=>setModal(null)}
        />
      )}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",flexWrap:"wrap",gap:10,marginBottom:4}}>
        <SH title="Painel de Disponibilidade" sub={`SEMANA ${weekKey()} — ${st.vehicles.length} VIATURAS`}/>
        <div style={{display:"flex",gap:8,alignItems:"center",flexShrink:0}}>
          {dlMode&&Object.values(dlSel).some(Boolean)&&(
            <>
              <select
                value={dlFormat}
                onChange={e=>setDlFormat(e.target.value)}
                style={{padding:"7px 12px",background:T.bgCard,border:`1px solid ${T.borderDark}`,borderRadius:2,color:T.textMid,fontSize:10,fontWeight:700,cursor:"pointer",fontFamily:"'Special Elite',serif",letterSpacing:1}}
              >
                <option value="docx">.DOCX</option>
                <option value="pdf">.PDF</option>
              </select>
              <Btn variant="dark" style={{padding:"7px 16px",fontSize:10}} onClick={genAltDesktop} disabled={dlBusy}>
                {dlBusy?"Gerando...":`↓ GERAR .${dlFormat.toUpperCase()}`}
              </Btn>
            </>
          )}
          <button onClick={toggleDlMode} style={{padding:"7px 16px",borderRadius:2,border:`2px solid ${dlMode?"#b85000":T.borderDark}`,background:dlMode?"rgba(184,80,0,0.10)":"transparent",color:dlMode?"#b85000":T.textMid,fontSize:10,fontWeight:700,cursor:"pointer",fontFamily:"'Special Elite',serif",letterSpacing:1,transition:"all 0.2s"}}>
            {dlMode?"✕ SAIR DO MODO DOWNLOAD":"⬇ MODO DOWNLOAD"}
          </button>
        </div>
      </div>
      <div style={{display:"flex",gap:12,marginBottom:24,flexWrap:"wrap"}}>
        {[["disponivel","DISPONÍVEIS",SC.disponivel.color],["missao","EM MISSÃO",SC.missao.color],["indisponivel","INDISPONÍVEIS",SC.indisponivel.color],["total","TOTAL",T.olive]].map(([k,lb,c])=>(
          <div key={k} style={{background:T.bgCard,border:`1px solid ${T.border}`,borderTop:`3px solid ${c}`,borderRadius:3,padding:"16px 20px",flex:1,minWidth:120,boxShadow:T.shadow}}>
            <div style={{fontSize:30,fontWeight:700,color:c,fontFamily:"'Playfair Display',Georgia,serif"}}>{k==="total"?st.vehicles.length:cnt[k]}</div>
            <div style={{fontSize:8,letterSpacing:3,color:T.textLight,marginTop:6,fontFamily:"'Special Elite',serif"}}>{lb}</div>
          </div>
        ))}
      </div>
      <div style={{display:"flex",gap:16,marginBottom:16,padding:"8px 14px",background:T.bgCard,border:`1px solid ${T.border}`,borderRadius:2,width:"fit-content"}}>
        {Object.entries(SC).map(([k,c])=>(
          <div key={k} style={{display:"flex",alignItems:"center",gap:6}}>
            <span style={{width:9,height:9,borderRadius:"50%",background:c.dot,display:"inline-block"}}/>
            <span style={{fontSize:9,color:T.textMid,letterSpacing:2,fontFamily:"'Special Elite',serif"}}>{c.label.toUpperCase()}</span>
          </div>
        ))}
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(340px,1fr))",gap:12}}>
        {st.vehicles.map(v=>{
          const c=SC[v.status],isX=exp[v.id],pend=v.alteracoes.filter(a=>!a.resolved).length;
          const unseen=v.alteracoes.filter(a=>!a.seenByAdmin).length;
          const markSeen=()=>{ if(unseen===0)return; upd(p=>({...p,vehicles:p.vehicles.map(vv=>vv.id===v.id?{...vv,alteracoes:vv.alteracoes.map(a=>({...a,seenByAdmin:true}))}:vv)})); };
          return(
            <Card key={v.id} accent={dlMode?(dlSel[v.id]?"#b85000":T.borderDark):(unseen>0?"#1a5a8a":c.dot)}
              style={{
                cursor:dlMode?"pointer":"default",
                transform:dlMode&&dlSel[v.id]?"translateY(-6px) scale(1.02)":"none",
                boxShadow:dlMode&&dlSel[v.id]?`0 12px 32px rgba(184,80,0,0.25)`:undefined,
                transition:"transform 0.18s, box-shadow 0.18s",
                outline:dlMode&&dlSel[v.id]?"2px solid #b85000":"none"
              }}
              onClick={dlMode?()=>toggleDlSel(v.id):undefined}>
              {dlMode&&(
                <div style={{padding:"6px 16px",background:dlSel[v.id]?"rgba(184,80,0,0.10)":"rgba(0,0,0,0.03)",borderBottom:`1px solid ${T.border}`,display:"flex",alignItems:"center",gap:8}}>
                  <input type="checkbox" readOnly checked={!!dlSel[v.id]} style={{width:14,height:14,accentColor:"#b85000",pointerEvents:"none"}}/>
                  <span style={{fontSize:9,color:dlSel[v.id]?"#b85000":T.textLight,fontFamily:"'Special Elite',serif",letterSpacing:1,fontWeight:700}}>
                    {dlSel[v.id]?"SELECIONADA PARA RELATÓRIO":"CLIQUE PARA SELECIONAR"}
                  </span>
                </div>
              )}
              <div style={{padding:"12px 16px",background:unseen>0&&!dlMode?"rgba(26,90,138,0.07)":c.bg,borderBottom:`1px solid ${T.border}`}}>
                <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:8}}>
                  <div style={{display:"flex",alignItems:"center",gap:10,flex:1,minWidth:0}}>
                    <Dot status={v.status}/>
                    {getVtrImg(v.code, v.image)&&<img src={getVtrImg(v.code, v.image)} alt={v.code} style={{width:52,height:40,objectFit:"contain",flexShrink:0,borderRadius:2,opacity:0.92}}/>}
                    <div style={{minWidth:0}}>
                      <div style={{fontWeight:700,fontSize:13,color:T.bgDark,fontFamily:"'Playfair Display',Georgia,serif"}}>{v.code}</div>
                      <div style={{fontSize:10,color:T.textMid,marginTop:1}}>{v.responsible}</div>
                    </div>
                  </div>
                  <div style={{display:"flex",gap:6,alignItems:"center",flexShrink:0}}>
                    {unseen>0&&(
                      <span style={{background:"#1a5a8a",color:"#fff",fontSize:9,fontWeight:700,padding:"3px 9px",borderRadius:10,fontFamily:"Georgia,serif",animation:"bpulse 1.2s infinite",whiteSpace:"nowrap"}}>
                        🔵 {unseen} NOVO{unseen>1?"S":""}
                      </span>
                    )}
                    <button onClick={()=>{setExp(p=>({...p,[v.id]:!p[v.id]}));if(!isX)markSeen();}} style={{background:T.bgCard,border:`1px solid ${T.borderDark}`,color:T.textMid,width:24,height:24,borderRadius:2,cursor:"pointer",fontSize:9}}>{isX?"▲":"▼"}</button>
                  </div>
                </div>
              </div>
              <div style={{padding:"8px 16px",display:"flex",alignItems:"center",justifyContent:"space-between",borderBottom:`1px solid ${T.border}`}}>
                <span style={{fontSize:9,fontWeight:700,color:c.color,fontFamily:"'Special Elite',serif",letterSpacing:2}}>{c.label.toUpperCase()}</span>
                <select value={v.status} onChange={e=>setStatus(v.id,e.target.value)} style={{background:T.bgDeep,border:`1px solid ${T.border}`,color:T.textMid,padding:"3px 7px",borderRadius:2,fontSize:9,cursor:"pointer",fontFamily:"'Special Elite',serif"}}>
                  <option value="disponivel">Disponível</option>
                  <option value="missao">Em Missão</option>
                  <option value="indisponivel">Indisponível</option>
                </select>
              </div>
              {pend>0&&(
                <div style={{padding:"5px 16px",borderBottom:`1px solid ${T.border}`,display:"flex",alignItems:"center",gap:6}}>
                  <span style={{background:T.redBg,color:T.red,fontSize:9,fontWeight:700,padding:"2px 8px",borderRadius:10,border:`1px solid ${T.red}25`,fontFamily:"'Special Elite',serif",letterSpacing:1}}>{pend} PEND.</span>
                </div>
              )}
              {isX&&(
                <div style={{padding:"12px 16px"}}>
                  <div style={{fontSize:8,letterSpacing:2,color:T.textLight,marginBottom:8,fontFamily:"'Special Elite',serif"}}>ALTERAÇÕES REGISTRADAS</div>
                  {v.alteracoes.length===0
                    ?<div style={{color:T.textLight,fontSize:11,fontStyle:"italic",textAlign:"center",padding:"12px 0"}}>Nenhuma alteração esta semana</div>
                    :v.alteracoes.map(a=>(
                      <div key={a.id} style={{background:a.urgent?"rgba(180,60,0,0.12)":a.resolved?T.bgDeep:T.redBg,border:`1px solid ${a.urgent?"rgba(180,60,0,0.4)":a.resolved?T.border:"rgba(122,48,48,0.2)"}`,borderRadius:2,padding:"8px 10px",marginBottom:6,opacity:a.archived?0.55:1}}>
                        {a.urgent&&!a.resolved&&<div style={{fontSize:8,letterSpacing:2,color:"#e07030",fontFamily:"'Special Elite',serif",fontWeight:700,marginBottom:3}}>🚨 URGENTE</div>}
                        <div style={{display:"flex",justifyContent:"space-between",gap:8,alignItems:"flex-start"}}>
                          <div style={{flex:1}}>
                            <div style={{fontSize:11,color:T.text}}>{a.descricao}</div>
                            <div style={{fontSize:9,color:T.textLight,marginTop:2}}>{new Date(a.date).toLocaleString("pt-BR")}</div>
                            {a.resolved&&<div style={{fontSize:9,color:T.green,marginTop:1}}>✓ {a.resolvedDesc}</div>}
                            {a.archived&&<div style={{fontSize:8,color:"#555",marginTop:1,fontFamily:"'Special Elite',serif",letterSpacing:1}}>📦 ARQUIVADO</div>}
                          </div>
                          <div style={{display:"flex",flexDirection:"column",gap:3,flexShrink:0,alignItems:"flex-end"}}>
                            {/* Resolver — pendentes */}
                            {!a.resolved&&<Btn variant="ghost" style={{padding:"2px 8px",fontSize:9,color:T.green,borderColor:T.green+"44"}} onClick={()=>setModal({vId:v.id,aId:a.id})}>✓ Resolver</Btn>}
                            {/* Urgente toggle — só admin, só pendentes */}
                            {!a.resolved&&(urgentId===v.id+":"+a.id?(
                              <div style={{display:"flex",gap:3,alignItems:"center"}}>
                                <Btn variant="red" style={{padding:"2px 6px",fontSize:9,opacity:urgentCd>0?0.5:1,cursor:urgentCd>0?"not-allowed":"pointer"}}
                                  onClick={()=>urgentCd===0&&confirmUrgent(v.id,a.id)}>{urgentCd>0?`${urgentCd}s`:a.urgent?"✕":"OK"}</Btn>
                                <Btn variant="ghost" style={{padding:"2px 5px",fontSize:9}} onClick={cancelUrgent}>✕</Btn>
                              </div>
                            ):(
                              <Btn variant="ghost" style={{padding:"2px 8px",fontSize:9,color:a.urgent?"#e07030":T.textLight,borderColor:a.urgent?"rgba(180,60,0,0.4)":T.border}} onClick={()=>startUrgent(v.id,a.id)}>{a.urgent?"🚨 Urgente":"🚨 Urgente"}</Btn>
                            ))}
                            {/* Arquivar — só resolvidas, não arquivadas */}
                            {a.resolved&&!a.archived&&<Btn variant="ghost" style={{padding:"2px 8px",fontSize:9}} onClick={()=>upd(p=>({...p,vehicles:p.vehicles.map(vv=>vv.id===v.id?{...vv,alteracoes:vv.alteracoes.map(x=>x.id===a.id?{...x,archived:true,archivedAt:new Date().toISOString()}:x)}:vv)}))}>📦 Arquivar</Btn>}
                          </div>
                        </div>
                      </div>
                    ))
                  }
                </div>
              )}
            </Card>
          );
        })}
      </div>
    </div>
  );
}

function VtrView({st,upd,vtr,setTab,isAdmin}){
  const [newA,setNewA]=useState("");
  const [showForm,setShowForm]=useState(false);
  const [expPend,setExpPend]=useState(true);
  const [expRes,setExpRes]=useState(false);
  const [delModal,setDelModal]=useState(null); // aId to delete (confirm)
  const [resolveModal,setResolveModal]=useState(null); // aId to resolve
  const [resolveDesc,setResolveDesc]=useState("");
  const [urgentId,setUrgentId]=useState(null); // aId pending urgent confirm
  const [urgentCd,setUrgentCd]=useState(0);
  useEffect(()=>{if(urgentCd<=0)return;const t=setTimeout(()=>setUrgentCd(d=>d-1),1000);return()=>clearTimeout(t);},[urgentCd]);
  const user=st.users.find(u=>u.id===vtr.userId); // Get user for logging

  const addAlt=()=>{
    if(!newA.trim())return;
    const a={id:Date.now()+"",descricao:newA.trim(),date:new Date().toISOString(),resolved:false,seenByAdmin:false};
    upd(p=>{
      const newLog={
        id:Date.now()+"_"+Math.random().toString(36).substr(2,9),
        userId:user?.id||"unknown",
        userName:user?.name||"Usuário",
        action:"Registrou pendência",
        details:`Viatura ${vtr.code} - ${newA.trim()}`,
        timestamp:new Date().toISOString()
      };
      return{...p,
        vehicles:p.vehicles.map(v=>v.id===vtr.id?{...v,alteracoes:[...v.alteracoes,a]}:v),
        logs:[newLog,...(p.logs||[])]
      };
    });
    setNewA("");setShowForm(false);
  };
  const startUrgent=(id)=>{setUrgentId(id);setUrgentCd(3);};
  const cancelUrgent=()=>{setUrgentId(null);setUrgentCd(0);};
  const confirmUrgent=(id)=>{
    upd(p=>{
      const veh=p.vehicles.find(v=>v.id===vtr.id);
      const alt=veh?.alteracoes.find(a=>a.id===id);
      const turningOn=alt&&!alt.urgent;
      let newAlerts;
      if(turningOn&&veh){
        newAlerts=[...(p.urgentAlerts||[]),{id:Date.now()+"",altId:id,vId:vtr.id,vCode:veh.code,descricao:alt.descricao,dispatchedAt:new Date().toISOString(),userId:veh.userId,cienciaAt:null}];
      }else{
        newAlerts=(p.urgentAlerts||[]).filter(a=>!(a.altId===id&&a.vId===vtr.id));
      }
      const newLog={
        id:Date.now()+"_"+Math.random().toString(36).substr(2,9),
        userId:user?.id||"unknown",
        userName:user?.name||"Usuário",
        action:turningOn?"Marcou urgência":"Removeu urgência",
        details:`Viatura ${vtr.code} - ${alt?.descricao||"desconhecida"}`,
        timestamp:new Date().toISOString()
      };
      return{...p,
        vehicles:p.vehicles.map(v=>v.id===vtr.id?{...v,alteracoes:v.alteracoes.map(a=>a.id===id?{...a,urgent:!a.urgent}:a)}:v),
        urgentAlerts:newAlerts,
        logs:[newLog,...(p.logs||[])]
      };
    });
    setUrgentId(null);setUrgentCd(0);
    // beep se ativando urgência
    if(vtr&&vtr.alteracoes.find(a=>a.id===id)&&!vtr.alteracoes.find(a=>a.id===id).urgent){
      beepUrgent();
      // Enviar notificação push para urgência
      sendPushNotification(
        `🚨 URGÊNCIA - ${vtr.code}`,
        alt?.descricao||"Nova urgência registrada"
      );
    }
  };

  if(!vtr)return null;
  const c=SC[vtr.status];
  const pend=vtr.alteracoes.filter(a=>!a.resolved);
  const resolved=vtr.alteracoes.filter(a=>a.resolved);
  const alertNotifs=st.notifs.filter(n=>(n.tid===vtr.userId||n.tid==="all")&&n.alerted&&!(n.readBy||[]).includes(vtr.userId));

  const removeAlt=(aId)=>{
    const alt=vtr?.alteracoes?.find(a=>a.id===aId);
    upd(p=>{
      const newLog={
        id:Date.now()+"_"+Math.random().toString(36).substr(2,9),
        userId:user?.id||"unknown",
        userName:user?.name||"Usuário",
        action:"Removeu alteração",
        details:`Viatura ${vtr.code} - ${alt?.descricao||"desconhecida"}`,
        timestamp:new Date().toISOString()
      };
      return{...p,
        vehicles:p.vehicles.map(v=>v.id===vtr.id?{...v,alteracoes:v.alteracoes.filter(a=>a.id!==aId)}:v),
        logs:[newLog,...(p.logs||[])]
      };
    });
    setDelModal(null);
  };

  return(
    <div style={{maxWidth:660}}>
      {resolveModal&&(
        <div style={{position:"fixed",inset:0,background:"rgba(20,25,12,0.72)",zIndex:9999,display:"flex",alignItems:"center",justifyContent:"center",padding:24}}>
          <div style={{background:T.bgCard,border:`1px solid ${T.borderDark}`,borderRadius:4,padding:"26px 28px",maxWidth:380,width:"100%",boxShadow:"0 8px 40px rgba(0,0,0,0.4)"}}>
            <div style={{fontSize:13,fontWeight:700,color:T.bgDark,fontFamily:"'Playfair Display',Georgia,serif",marginBottom:10}}>Registrar Providência</div>
            <div style={{fontSize:11,color:T.textMid,marginBottom:12,lineHeight:1.6}}>Descreva a providência tomada para resolver esta pendência:</div>
            <Inp value={resolveDesc} onChange={e=>setResolveDesc(e.target.value)} placeholder="Ex: Peça substituída, manutenção realizada..." rows={3} style={{marginBottom:12}}/>
            <div style={{display:"flex",gap:9,justifyContent:"flex-end"}}>
              <Btn variant="ghost" onClick={()=>setResolveModal(null)}>Cancelar</Btn>
              <Btn onClick={()=>{
                if(!resolveDesc.trim())return;
                const alt=vtr?.alterações?.find(a=>a.id===resolveModal)||vtr?.alteracoes?.find(a=>a.id===resolveModal);
                upd(p=>{
                  const newLog={
                    id:Date.now()+"_"+Math.random().toString(36).substr(2,9),
                    userId:user?.id||"unknown",
                    userName:user?.name||"Usuário",
                    action:"Resolveu pendência",
                    details:`Viatura ${vtr.code} - ${alt?.descricao||"desconhecida"} - Providência: ${resolveDesc.trim()}`,
                    timestamp:new Date().toISOString()
                  };
                  return{...p,
                    vehicles:p.vehicles.map(v=>v.id===vtr.id?{...v,alteracoes:v.alteracoes.map(a=>a.id===resolveModal?{...a,resolved:true,resolvedDesc:resolveDesc.trim(),resolvedAt:new Date().toISOString(),urgent:false}:a)}:v),
                    logs:[newLog,...(p.logs||[])]
                  };
                });
                setResolveModal(null);setResolveDesc("");
              }}>✓ CONFIRMAR</Btn>
            </div>
          </div>
        </div>
      )}
      {delModal&&(
        <div style={{position:"fixed",inset:0,background:"rgba(45,51,32,0.65)",zIndex:9999,display:"flex",alignItems:"center",justifyContent:"center",padding:24}}>
          <div style={{background:T.bgCard,border:`1px solid ${T.borderDark}`,borderRadius:4,padding:"28px 30px",maxWidth:380,width:"100%",boxShadow:"0 8px 40px rgba(45,51,32,0.35)"}}>
            <div style={{fontSize:13,fontWeight:700,color:T.bgDark,fontFamily:"'Playfair Display',Georgia,serif",marginBottom:10}}>Confirmar remoção</div>
            <div style={{fontSize:11,color:T.textMid,marginBottom:18,lineHeight:1.6}}>Deseja remover esta alteração registrada?</div>
            <div style={{display:"flex",gap:9,justifyContent:"flex-end"}}>
              <Btn variant="ghost" onClick={()=>setDelModal(null)}>Cancelar</Btn>
              <Btn variant="red" onClick={()=>removeAlt(delModal)}>REMOVER</Btn>
            </div>
          </div>
        </div>
      )}
      {showForm&&(
        <div style={{position:"fixed",inset:0,background:"rgba(20,25,12,0.72)",zIndex:9999,display:"flex",alignItems:"center",justifyContent:"center",padding:24}}>
          <div style={{background:T.bgCard,border:`1px solid ${T.borderDark}`,borderRadius:4,padding:"26px 28px",maxWidth:400,width:"100%",boxShadow:"0 8px 40px rgba(0,0,0,0.4)"}}>
            <div style={{fontSize:13,fontWeight:700,color:T.bgDark,fontFamily:"'Playfair Display',Georgia,serif",marginBottom:10}}>Registrar Alteração</div>
            <div style={{fontSize:11,color:T.textMid,marginBottom:12,lineHeight:1.6}}>Descreva a alteração observada na viatura:</div>
            <Inp value={newA} onChange={e=>setNewA(e.target.value)} placeholder="Ex: Pneu furado, para-brisa trincado..." rows={3} style={{marginBottom:12}}/>
            <div style={{display:"flex",gap:9,justifyContent:"flex-end"}}>
              <Btn variant="ghost" onClick={()=>{setShowForm(false);setNewA("");}}>Cancelar</Btn>
              <Btn onClick={addAlt}>✓ REGISTRAR</Btn>
            </div>
          </div>
        </div>
      )}
      <SH title={vtr.code} sub={`CHEFE DE PEÇA: ${vtr.responsible}`}/>
      {alertNotifs.length>0&&(
        <div onClick={()=>setTab("notifs")} style={{cursor:"pointer",background:"rgba(180,80,0,0.10)",border:"2px solid #b85000",borderRadius:3,padding:"12px 18px",marginBottom:18,display:"flex",alignItems:"center",gap:14}}>
          <span style={{fontSize:28,flexShrink:0,animation:"bpulse 1s infinite"}}>⚠️</span>
          <div>
            <div style={{fontWeight:700,fontSize:13,color:"#b85000",fontFamily:"'Playfair Display',Georgia,serif"}}>ATENÇÃO — {alertNotifs.length} ALERTA{alertNotifs.length>1?"S":""} NÃO LIDO{alertNotifs.length>1?"S":""}</div>
            <div style={{fontSize:10,color:T.textMid,marginTop:2}}>Clique aqui para ver as notificações</div>
          </div>
        </div>
      )}
      <Card style={{padding:"18px 22px",marginBottom:18,borderLeft:`5px solid ${c.dot}`}}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:12}}>
          <div style={{display:"flex",alignItems:"center",gap:14}}>
            {getVtrImg(vtr.code, vtr.image)&&<img src={getVtrImg(vtr.code, vtr.image)} alt={vtr.code} style={{width:80,height:60,objectFit:"contain",flexShrink:0,opacity:0.93}}/>}
            <div style={{display:"flex",alignItems:"center",gap:10}}>
              <Dot status={vtr.status} size={14}/>
              <div>
                <div style={{fontSize:8,color:T.textLight,letterSpacing:3,fontFamily:"'Special Elite',serif"}}>SITUAÇÃO ATUAL</div>
                <div style={{fontSize:16,fontWeight:700,color:c.color,fontFamily:"'Playfair Display',Georgia,serif",marginTop:1}}>{c.label}</div>
              </div>
            </div>
          </div>
          <select value={vtr.status} onChange={e=>upd(p=>({...p,vehicles:p.vehicles.map(v=>v.id===vtr.id?{...v,status:e.target.value}:v)}))} style={{background:T.bgDeep,border:`1px solid ${T.borderDark}`,color:T.text,padding:"8px 12px",borderRadius:2,fontSize:11,cursor:"pointer",fontFamily:"'Special Elite',serif",letterSpacing:1}}>
            <option value="disponivel">Disponível</option><option value="missao">Em Missão</option><option value="indisponivel">Indisponível</option>
          </select>
        </div>
      </Card>

      <Card style={{marginBottom:12,overflow:"hidden"}}>
        <div onClick={()=>setExpPend(p=>!p)} style={{padding:"13px 18px",display:"flex",justifyContent:"space-between",alignItems:"center",cursor:"pointer",background:pend.length>0?"rgba(122,48,48,0.05)":T.bgCard,borderBottom:expPend?`1px solid ${T.border}`:"none"}}>
          <div style={{display:"flex",alignItems:"center",gap:10}}>
            <div style={{fontSize:8,letterSpacing:3,color:pend.length>0?T.red:T.olive,fontFamily:"'Special Elite',serif",fontWeight:700}}>ALTERAÇÕES PENDENTES</div>
            {pend.length>0&&<span style={{background:T.redBg,color:T.red,fontSize:9,fontWeight:700,padding:"1px 8px",borderRadius:10,border:`1px solid ${T.red}25`,fontFamily:"'Special Elite',serif"}}>{pend.length}</span>}
          </div>
          <div style={{display:"flex",alignItems:"center",gap:10}}>
            <Chip onClick={e=>{e.stopPropagation();setShowForm(f=>!f);}} color={T.olive}>+ Registrar</Chip>
            <span style={{color:T.textLight,fontSize:11}}>{expPend?"▲":"▼"}</span>
          </div>
        </div>
        {expPend&&(
          <div style={{padding:"12px 18px"}}>
            {pend.length===0
              ?<div style={{color:T.textLight,fontSize:12,textAlign:"center",padding:"18px 0",fontStyle:"italic"}}>Nenhuma alteração pendente</div>
              :pend.map(a=>(
                <div key={a.id} style={{background:a.urgent?"rgba(180,60,0,0.10)":T.redBg,border:`1px solid ${a.urgent?"rgba(180,60,0,0.35)":"rgba(122,48,48,0.2)"}`,borderRadius:6,padding:"10px 12px",marginBottom:8}}>
                  {a.urgent&&<div style={{fontSize:9,color:"#d06020",fontWeight:700,marginBottom:5}}>🚨 URGENTE</div>}
                  <div style={{display:"flex",justifyContent:"space-between",gap:10}}>
                    <div style={{flex:1}}>
                      <div style={{fontSize:12,color:T.text,lineHeight:1.5}}>{a.descricao}</div>
                      <div style={{fontSize:9,color:T.textLight,marginTop:3}}>{new Date(a.date).toLocaleString("pt-BR")}</div>
                    </div>
                    <div style={{display:"flex",gap:5,flexWrap:"wrap",marginTop:6}}>
                      <Chip onClick={()=>{setResolveModal(a.id);setResolveDesc("");}} color={T.green}>✓ Resolver</Chip>
                      {isAdmin&&(urgentId===a.id?(
                        <>
                          <Chip onClick={()=>urgentCd===0&&confirmUrgent(a.id)} color={T.red} style={{opacity:urgentCd>0?0.45:1}}>{urgentCd>0?`${urgentCd}s`:a.urgent?"Remover":"Confirmar"}</Chip>
                          <Chip onClick={cancelUrgent} color={T.textLight}>✕</Chip>
                        </>
                      ):(
                        <Chip onClick={()=>startUrgent(a.id)} color={a.urgent?"#d06020":T.textLight}>{a.urgent?"🚨 Urgente":"🚨 Urgente"}</Chip>
                      ))}
                      {isAdmin&&<Chip onClick={()=>setDelModal(a.id)} color={T.red}>✕ Remover</Chip>}
                    </div>
                  </div>
                </div>
              ))
            }
          </div>
        )}
      </Card>

      {resolved.length>0&&(
        <Card style={{overflow:"hidden"}}>
          <div onClick={()=>setExpRes(p=>!p)} style={{padding:"13px 18px",display:"flex",justifyContent:"space-between",alignItems:"center",cursor:"pointer",borderBottom:expRes?`1px solid ${T.border}`:"none"}}>
            <div style={{display:"flex",alignItems:"center",gap:10}}>
              <div style={{fontSize:8,letterSpacing:3,color:T.green,fontFamily:"'Special Elite',serif",fontWeight:700}}>ALTERAÇÕES RESOLVIDAS</div>
              <span style={{background:"rgba(61,107,53,0.1)",color:T.green,fontSize:9,fontWeight:700,padding:"1px 8px",borderRadius:10,border:`1px solid ${T.green}25`,fontFamily:"'Special Elite',serif"}}>{resolved.length}</span>
            </div>
            <span style={{color:T.textLight,fontSize:11}}>{expRes?"▲":"▼"}</span>
          </div>
          {expRes&&(
            <div style={{padding:"12px 18px"}}>
              {resolved.map(a=>(
                <div key={a.id} style={{background:a.archived?"rgba(30,30,30,0.5)":T.bgDeep,border:`1px solid ${a.archived?"#333":T.border}`,borderRadius:2,padding:"10px 12px",marginBottom:8,opacity:a.archived?0.6:1}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:8}}>
                    <div style={{flex:1}}>
                      <div style={{fontSize:12,color:T.textMid,lineHeight:1.5}}>{a.descricao}</div>
                      <div style={{fontSize:9,color:T.textLight,marginTop:2}}>{new Date(a.date).toLocaleString("pt-BR")}</div>
                      <div style={{fontSize:10,color:T.green,marginTop:3}}>✓ {a.resolvedDesc}</div>
                      {a.archived&&<div style={{fontSize:9,color:"#555",marginTop:2,fontFamily:"'Special Elite',serif",letterSpacing:1}}>ARQUIVADO {a.archivedAt?new Date(a.archivedAt).toLocaleDateString("pt-BR"):""}</div>}
                    </div>
                    {isAdmin&&!a.archived&&<Chip onClick={()=>upd(p=>({...p,vehicles:p.vehicles.map(v=>v.id===vtr.id?{...v,alteracoes:v.alteracoes.map(x=>x.id===a.id?{...x,archived:true,archivedAt:new Date().toISOString()}:x)}:v)}))} color={T.textLight} style={{marginTop:4}}>📦 Arquivar</Chip>}
                  </div>
                </div>
              ))}
            </div>
          )}
        </Card>
      )}
    </div>
  );
}


// ── URGÊNCIAS — componente para usuário dar ciência ─────────────────────────
function UrgentView({st,upd,user,isAdmin}){
  const [showArchived,setShowArchived]=useState(false);
  const [deleteId,setDeleteId]=useState(null); // ID da urgência sendo excluída
  const [deleteCountdown,setDeleteCountdown]=useState(0); // Contagem para exclusão
  const [,setSaveStatus]=useState('idle'); // 'idle' | 'saving' | 'saved' | 'error'

  // Efeito para o countdown de exclusão
  useEffect(()=>{
    if(deleteCountdown<=0){
      // Quando countdown chega a 0, para o timer mas mantém o estado para mostrar botão de confirmação
      setDeleteCountdown(0);
      return;
    }
    const timer=setTimeout(()=>setDeleteCountdown(c=>c-1),1000);
    return()=>clearTimeout(timer);
  },[deleteCountdown]);

  const myAlerts=isAdmin?(st.urgentAlerts||[]):(st.urgentAlerts||[]).filter(a=>a.userId===user.id);
  const pending=myAlerts.filter(a=>!a.archived&&!a.cienciaAt);
  const done=myAlerts.filter(a=>!a.archived&&!!a.cienciaAt);
  const archived=myAlerts.filter(a=>!!a.archived);

  const darCiencia=(alertId)=>{
    upd(p=>{
      const alerta=(p.urgentAlerts||[]).find(a=>a.id===alertId);
      const newLog={
        id:Date.now()+"_"+Math.random().toString(36).substr(2,9),
        userId:user.id,
        userName:user.name,
        action:"Confirmou ciência",
        details:`Urgência: ${alerta?.descricao||"desconhecida"} - ${alerta?.vCode||"desconhecida"}`,
        timestamp:new Date().toISOString()
      };
      return{
        ...p,
        urgentAlerts:(p.urgentAlerts||[]).map(a=>a.id===alertId?{...a,cienciaAt:new Date().toISOString()}:a),
        logs:[newLog,...(p.logs||[])]
      };
    });
  };

  const cancelarUrgencia=(alertId)=>{
    if(window.confirm("Tem certeza que deseja cancelar esta urgência?")){
      setSaveStatus('saving'); // Show saving status
      upd(p=>{
        const alerta=(p.urgentAlerts||[]).find(a=>a.id===alertId);
        const newLog={
          id:Date.now()+"_"+Math.random().toString(36).substr(2,9),
          userId:user.id,
          userName:user.name,
          action:"Cancelou urgência",
          details:`Urgência: ${alerta?.descricao||"desconhecida"} - ${alerta?.vCode||"desconhecida"}`,
          timestamp:new Date().toISOString()
        };
        return{
          ...p,
          urgentAlerts:(p.urgentAlerts||[]).filter(a=>a.id!==alertId),
          vehicles:p.vehicles.map(v=>v.id===alerta?.vId?{...v,alteracoes:v.alteracoes.map(a=>a.id===alerta.altId?{...a,urgent:false}:a)}:v),
          logs:[newLog,...(p.logs||[])]
        };
      },(status)=>{
        setSaveStatus(status);
        // Auto-reset status after 3 seconds
        if(status==='saved'||status==='error'){
          setTimeout(()=>setSaveStatus('idle'),3000);
        }
      });
    }
  };

  const arquivarUrgencia=(alertId)=>{
    if(window.confirm("Deseja arquivar esta urgência? Isso moverá para a lista de arquivados.")){
      setSaveStatus('saving'); // Show saving status
      upd(p=>{
        const alerta=(p.urgentAlerts||[]).find(a=>a.id===alertId);
        const newLog={
          id:Date.now()+"_"+Math.random().toString(36).substr(2,9),
          userId:user.id,
          userName:user.name,
          action:"Arquivou urgência",
          details:`Urgência: ${alerta?.descricao||"desconhecida"} - ${alerta?.vCode||"desconhecida"} (Ciência confirmada em ${alerta?.cienciaAt?new Date(alerta.cienciaAt).toLocaleDateString("pt-BR"):"N/A"})`,
          timestamp:new Date().toISOString()
        };
        return{
          ...p,
          urgentAlerts:(p.urgentAlerts||[]).map(a=>a.id===alertId?{...a,archived:true,archivedAt:new Date().toISOString()}:a),
          logs:[newLog,...(p.logs||[])]
        };
      },(status)=>{
        setSaveStatus(status);
        // Auto-reset status after 3 seconds
        if(status==='saved'||status==='error'){
          setTimeout(()=>setSaveStatus('idle'),3000);
        }
      });
    }
  };

  const desarquivarUrgencia=(alertId)=>{
    setSaveStatus('saving'); // Show saving status
    upd(p=>{
      const alerta=(p.urgentAlerts||[]).find(a=>a.id===alertId);
      const newLog={
        id:Date.now()+"_"+Math.random().toString(36).substr(2,9),
        userId:user.id,
        userName:user.name,
        action:"Desarquivou urgência",
        details:`Urgência: ${alerta?.descricao||"desconhecida"} - ${alerta?.vCode||"desconhecida"}`,
        timestamp:new Date().toISOString()
      };
      return{
        ...p,
        urgentAlerts:(p.urgentAlerts||[]).map(a=>a.id===alertId?{...a,archived:false,archivedAt:null}:a),
        logs:[newLog,...(p.logs||[])]
      };
    },(status)=>{
      setSaveStatus(status);
      // Auto-reset status after 3 seconds
      if(status==='saved'||status==='error'){
        setTimeout(()=>setSaveStatus('idle'),3000);
      }
    });
  };

  const iniciarExclusao=(alertId)=>{
    setDeleteId(alertId);
    setDeleteCountdown(3); // 3 segundos para confirmar
  };

  const cancelarExclusao=()=>{
    setDeleteId(null);
    setDeleteCountdown(0);
  };

  const confirmarExclusao=(alertId)=>{
    upd(p=>{
      const alerta=(p.urgentAlerts||[]).find(a=>a.id===alertId);
      const newLog={
        id:Date.now()+"_"+Math.random().toString(36).substr(2,9),
        userId:user.id,
        userName:user.name,
        action:"Excluiu urgência arquivada",
        details:`Urgência: ${alerta?.descricao||"desconhecida"} - ${alerta?.vCode||"desconhecida"} (Arquivada em ${alerta?.archivedAt?new Date(alerta.archivedAt).toLocaleDateString("pt-BR"):"N/A"}, Ciência em ${alerta?.cienciaAt?new Date(alerta.cienciaAt).toLocaleDateString("pt-BR"):"N/A"})`,
        timestamp:new Date().toISOString()
      };
      return{
        ...p,
        urgentAlerts:(p.urgentAlerts||[]).filter(a=>a.id!==alertId),
        vehicles:p.vehicles.map(v=>v.id===alerta?.vId?{...v,alteracoes:v.alteracoes.map(a=>a.id===alerta.altId?{...a,urgent:false}:a)}:v),
        logs:[newLog,...(p.logs||[])]
      };
    });
    setDeleteId(null);
    setDeleteCountdown(0);
  };

  if(myAlerts.length===0) return(
    <div style={{textAlign:"center",color:T.textLight,fontSize:12,padding:"40px 0"}}>
      <div style={{fontSize:32,marginBottom:8}}>✅</div>
      {isAdmin?"Nenhuma urgência registrada":"Você não possui urgências pendentes"}
    </div>
  );

  // ADMIN: Agrupar por viatura
  if(isAdmin){
    const byVehicle={};
    myAlerts.filter(a=>!a.archived).forEach(a=>{
      if(!byVehicle[a.vCode])byVehicle[a.vCode]=[];
      byVehicle[a.vCode].push(a);
    });

    const archivedByVehicle={};
    archived.forEach(a=>{
      if(!archivedByVehicle[a.vCode])archivedByVehicle[a.vCode]=[];
      archivedByVehicle[a.vCode].push(a);
    });

    return(
      <div>
        {isAdmin&&(
          <div style={{display:"flex",gap:8,marginBottom:16,flexWrap:"wrap"}}>
            <button onClick={()=>setShowArchived(false)} style={{padding:"8px 16px",background:!showArchived?T.olive:"transparent",border:!showArchived?"none":`1px solid ${T.border}`,borderRadius:6,color:!showArchived?T.cream:T.textMid,fontSize:11,cursor:"pointer",fontFamily:"Georgia,serif"}}>
              🚨 Urgências Ativas
            </button>
            <button onClick={()=>setShowArchived(true)} style={{padding:"8px 16px",background:showArchived?T.olive:"transparent",border:showArchived?"none":`1px solid ${T.border}`,borderRadius:6,color:showArchived?T.cream:T.textMid,fontSize:11,cursor:"pointer",fontFamily:"Georgia,serif"}}>
              📦 Arquivados ({archived.length})
            </button>
          </div>
        )}

        {!showArchived&&(
          <>
            {Object.entries(byVehicle).map(([vCode,alerts])=>{
              const vehiclePending=alerts.filter(a=>!a.cienciaAt);
              const vehicleDone=alerts.filter(a=>!!a.cienciaAt);

              return(
                <div key={vCode} style={{marginBottom:24}}>
                  <div style={{fontSize:14,fontWeight:700,color:T.bgDark,fontFamily:"'Playfair Display',serif",marginBottom:12,padding:"8px 12px",background:T.bgDeep,borderRadius:4}}>
                    🚨 {vCode} ({vehiclePending.length} pendente{vehiclePending.length!==1?'s':''})
                  </div>

                  {vehiclePending.map(a=>(
                    <div key={a.id} style={{background:"rgba(180,60,0,0.10)",border:"1.5px solid rgba(180,60,0,0.4)",borderRadius:8,padding:"12px 14px",marginBottom:10}}>
                      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:8,flexWrap:"wrap"}}>
                        <div style={{flex:1,minWidth:0}}>
                          <div style={{fontSize:11,fontWeight:700,color:"#d06020",marginBottom:3}}>🚨 URGÊNCIA</div>
                          <div style={{fontSize:12,color:T.text,lineHeight:1.5,marginBottom:4}}>{a.descricao}</div>
                          <div style={{fontSize:9,color:T.textLight}}>Disparado em {new Date(a.dispatchedAt).toLocaleString("pt-BR")}</div>
                        </div>
                        <button onClick={()=>cancelarUrgencia(a.id)} style={{background:T.red,border:"none",borderRadius:8,padding:"8px 14px",color:T.cream,fontSize:11,fontWeight:700,cursor:"pointer",flexShrink:0,alignSelf:"center"}}>✕ Cancelar</button>
                      </div>
                    </div>
                  ))}

                  {vehicleDone.length>0&&(
                    <div style={{marginTop:16}}>
                      <div style={{fontSize:9,color:T.textLight,marginBottom:8,letterSpacing:1}}>✅ CIÊNCIA CONFIRMADA ({vehicleDone.length})</div>
                      {vehicleDone.map(a=>(
                        <div key={a.id} style={{background:"rgba(61,107,53,0.08)",border:"1px solid rgba(61,107,53,0.3)",borderRadius:6,padding:"10px 12px",marginBottom:8,opacity:0.7}}>
                          <div style={{fontSize:11,color:T.text,fontWeight:600}}>{a.descricao}</div>
                          <div style={{fontSize:8,color:T.textLight,marginTop:2}}>Ciência em {new Date(a.cienciaAt).toLocaleString("pt-BR")}</div>
                          <button onClick={()=>arquivarUrgencia(a.id)} style={{background:"transparent",border:`1px solid ${T.border}`,borderRadius:4,padding:"4px 8px",color:T.textMid,fontSize:9,cursor:"pointer",marginTop:6,fontFamily:"Georgia,serif"}}>
                            📦 Arquivar
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </>
        )}

        {showArchived&&(
          <>
            <div style={{fontSize:12,color:T.textLight,marginBottom:16,letterSpacing:1,textAlign:"center"}}>
              Urgências arquivadas foram movidas da lista principal mas permanecem no histórico
            </div>
            {Object.entries(archivedByVehicle).map(([vCode,alerts])=>(
              <div key={vCode} style={{marginBottom:20}}>
                <div style={{fontSize:13,fontWeight:700,color:T.bgDark,fontFamily:"'Playfair Display',serif",marginBottom:10,padding:"6px 12px",background:"rgba(45,51,32,0.05)",borderRadius:4}}>
                  📦 {vCode} ({alerts.length} arquivado{alerts.length!==1?'s':''})
                </div>
                {alerts.map(a=>(
                  <div key={a.id} style={{background:"rgba(45,51,32,0.03)",border:"1px solid rgba(45,51,32,0.1)",borderRadius:6,padding:"10px 12px",marginBottom:6,opacity:deleteId===a.id?0.8:0.65}}>
                    <div style={{fontSize:11,color:T.text,fontWeight:600}}>{a.descricao}</div>
                    <div style={{fontSize:8,color:T.textLight,marginTop:2}}>
                      <div>Ciência em {new Date(a.cienciaAt).toLocaleString("pt-BR")}</div>
                      <div>Arquivado em {new Date(a.archivedAt).toLocaleString("pt-BR")}</div>
                    </div>
                    <div style={{display:"flex",gap:8,marginTop:6}}>
                      <button onClick={()=>desarquivarUrgencia(a.id)} style={{background:"transparent",border:`1px solid ${T.border}`,borderRadius:4,padding:"4px 8px",color:T.textMid,fontSize:9,cursor:"pointer",fontFamily:"Georgia,serif"}}>
                        📤 Desarquivar
                      </button>
                      {deleteId===a.id ? (
                        deleteCountdown>0 ? (
                          // Fase 2: Countdown em andamento
                          <div style={{display:"flex",gap:8,alignItems:"center"}}>
                            <button onClick={cancelarExclusao} style={{background:"transparent",border:"1px solid #999",borderRadius:4,padding:"4px 8px",color:T.textMid,fontSize:9,cursor:"pointer",fontFamily:"Georgia,serif"}}>
                              ✕ Cancelar
                            </button>
                            <div style={{background:"rgba(122,48,48,0.1)",border:"1px solid rgba(122,48,48,0.3)",borderRadius:4,padding:"4px 8px",color:T.red,fontSize:9,fontFamily:"'Special Elite',serif",letterSpacing:1}}>
                              ⏱️ {deleteCountdown}s
                            </div>
                          </div>
                        ) : (
                          // Fase 3: Countdown terminou, botão de confirmação
                          <div style={{display:"flex",gap:8,alignItems:"center"}}>
                            <button onClick={cancelarExclusao} style={{background:"transparent",border:"1px solid #999",borderRadius:4,padding:"4px 8px",color:T.textMid,fontSize:9,cursor:"pointer",fontFamily:"Georgia,serif"}}>
                              ✕ Cancelar
                            </button>
                            <button onClick={()=>confirmarExclusao(a.id)} style={{background:T.red,border:"none",borderRadius:4,padding:"4px 12px",color:T.cream,fontSize:9,fontWeight:700,cursor:"pointer",fontFamily:"Georgia,serif"}}>
                              🗑️ Confirmar Exclusão
                            </button>
                          </div>
                        )
                      ) : (
                        // Fase 1: Botão normal de exclusão
                        <button onClick={()=>iniciarExclusao(a.id)} style={{background:"rgba(122,48,48,0.1)",border:"1px solid rgba(122,48,48,0.3)",borderRadius:4,padding:"4px 8px",color:T.red,fontSize:9,cursor:"pointer",fontFamily:"Georgia,serif"}}>
                          🗑️ Excluir
                        </button>
                      )}
                      )}
                    </div>
                  </div>
                ))}
              </div>
            ))}
            {archived.length===0&&(
              <div style={{textAlign:"center",color:T.textLight,fontSize:12,padding:"40px 0"}}>
                <div style={{fontSize:32,marginBottom:8}}>📦</div>
                Nenhuma urgência arquivada
              </div>
            )}
          </>
        )}
      </div>
    );
  }

  // USUÁRIO: Ver só as suas urgências
  return(
    <div>
      {pending.length>0&&(
        <>
          <div style={{fontSize:12,color:"#d06020",fontWeight:700,marginBottom:12,letterSpacing:0.5}}>🚨 URGÊNCIAS PENDENTES ({pending.length})</div>
          {pending.map(a=>(
            <div key={a.id} style={{background:"rgba(180,60,0,0.15)",border:"2px solid rgba(180,60,0,0.5)",borderRadius:10,padding:"16px 18px",marginBottom:12}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:10}}>
                <div style={{flex:1}}>
                  <div style={{fontSize:13,fontWeight:700,color:"#d06020",marginBottom:4,fontFamily:"'Playfair Display',serif"}}>{a.vCode}</div>
                  <div style={{fontSize:14,color:T.text,lineHeight:1.6,marginBottom:6}}>{a.descricao}</div>
                  <div style={{fontSize:10,color:T.textLight}}>Disparado em {new Date(a.dispatchedAt).toLocaleString("pt-BR")}</div>
                </div>
                <button onClick={()=>darCiencia(a.id)} style={{background:T.olive,border:"none",borderRadius:10,padding:"12px 18px",color:T.cream,fontSize:13,fontWeight:700,cursor:"pointer",flexShrink:0,alignSelf:"center",boxShadow:T.shadow}}>✓ Ciente</button>
              </div>
            </div>
          ))}
        </>
      )}

      {done.length>0&&(
        <div style={{marginTop:20}}>
          <div style={{fontSize:10,color:T.green,fontWeight:700,marginBottom:8,letterSpacing:1}}>✅ CIÊNCIA CONFIRMADA ({done.length})</div>
          {done.map(a=>(
            <div key={a.id} style={{background:"rgba(61,107,53,0.08)",border:"1px solid rgba(61,107,53,0.3)",borderRadius:6,padding:"10px 12px",marginBottom:6,opacity:0.6}}>
              <div style={{fontSize:11,color:T.text}}>{a.descricao}</div>
              <div style={{fontSize:8,color:T.textLight,marginTop:2}}>Ciência em {new Date(a.cienciaAt).toLocaleString("pt-BR")}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// Componente de visualização de logs
function LogView({st,upd,user}){
  const [selectedLogs,setSelectedLogs]=useState({});
  const [removeMode,setRemoveMode]=useState(false);
  const [countdown,setCountdown]=useState(0);

  useEffect(()=>{
    if(countdown>0){
      const t=setTimeout(()=>setCountdown(c=>c-1),1000);
      return()=>clearTimeout(t);
    }else if(countdown===0&&removeMode){
      setRemoveMode(false);
    }
  },[countdown,removeMode]);

  // Verificação de segurança - apenas Teixeira pode acessar
  if(user.id!=="teixeira"){
    return(
      <div style={{textAlign:"center",color:T.textLight,fontSize:12,padding:"40px 0"}}>
        <div style={{fontSize:32,marginBottom:8}}>🔒</div>
        Acesso restrrito
      </div>
    );
  }

  const logs=st.logs||[];

  const toggleLogSelection=(logId)=>{
    // isTeixeira check removed
    setSelectedLogs(s=>({...s,[logId]:!s[logId]}));
  };

  const selectAll=()=>{
    // isTeixeira check removed
    const newSel={};
    logs.forEach(l=>newSel[l.id]=true);
    setSelectedLogs(newSel);
  };

  const clearSelection=()=>setSelectedLogs({});

  const startRemoveMode=()=>{
    const hasSelection=Object.values(selectedLogs).some(v=>v);
    if(!hasSelection){
      alert("Selecione pelo menos um log para remover.");
      return;
    }
    setRemoveMode(true);
    setCountdown(3);
  };

  const confirmRemoval=()=>{
    const toRemove=Object.keys(selectedLogs).filter(id=>selectedLogs[id]);
    upd(p=>({...p,logs:(p.logs||[]).filter(l=>!toRemove.includes(l.id))}));
    setSelectedLogs({});
    setRemoveMode(false);
    setCountdown(0);
  };

  const removeSingleLog=(logId)=>{
    // isTeixeira check removed
    if(window.confirm("Tem certeza que deseja remover este log?")){
      upd(p=>({...p,logs:(p.logs||[]).filter(l=>l.id!==logId)}));
    }
  };

  const formatDate=(isoStr)=>new Date(isoStr).toLocaleString("pt-BR");

  const getActionIcon=(action)=>{
    const icons={
      "Mudou status":"🔄",
      "Adicionou pendência":"➕",
      "Resolveu pendência":"✅",
      "Marcou urgência":"🚨",
      "Removeu urgência":"🔕",
      "Criou usuário":"👤",
      "Alterou senha":"🔑",
      "Cancelou urgência":"❌",
      "Arquivou alteração":"📦",
    };
    return icons[action]||"📝";
  };

  if(logs.length===0)return(
    <div style={{textAlign:"center",color:T.textLight,fontSize:12,padding:"40px 0"}}>
      <div style={{fontSize:32,marginBottom:8}}>📋</div>
      Nenhum log registrado
    </div>
  );

  return(
    <div>
      <div style={{display:"flex",gap:8,marginBottom:16,flexWrap:"wrap"}}>
          {!removeMode?(
            <>
              {Object.values(selectedLogs).some(v=>v)&&(
                <>
                  <button onClick={selectAll} style={{padding:"8px 16px",background:T.bgCard,border:`1px solid ${T.border}`,borderRadius:6,color:T.textMid,fontSize:11,cursor:"pointer",fontFamily:"Georgia,serif"}}>✓ Selecionar Todos</button>
                  <button onClick={clearSelection} style={{padding:"8px 16px",background:T.bgCard,border:`1px solid ${T.border}`,borderRadius:6,color:T.textMid,fontSize:11,cursor:"pointer",fontFamily:"Georgia,serif"}}>✕ Limpar Seleção</button>
                  <button onClick={startRemoveMode} style={{padding:"8px 16px",background:T.red,border:"none",borderRadius:6,color:T.cream,fontSize:11,fontWeight:700,cursor:"pointer",fontFamily:"Georgia,serif"}}>🗑️ Remover Selecionados</button>
                </>
              )}
              {Object.values(selectedLogs).some(v=>v)&&(
                <span style={{fontSize:11,color:T.textMid,alignSelf:"center"}}>{Object.values(selectedLogs).filter(v=>v).length} selecionado(s)</span>
              )}
            </>
          ):(
            <div style={{display:"flex",gap:8,alignItems:"center"}}>
              <span style={{fontSize:12,color:T.red,fontWeight:700}}>⚠️ Confirmando remoção de {Object.values(selectedLogs).filter(v=>v).length} log(s)...</span>
              <button onClick={confirmRemoval} disabled={countdown>0} style={{padding:"8px 16px",background:T.red,border:"none",borderRadius:6,color:T.cream,fontSize:11,fontWeight:700,cursor:countdown>0?"not-allowed":"pointer",fontFamily:"Georgia,serif",opacity:countdown>0?0.6:1}}>
                {countdown>0?`${countdown}s...`:"✓ Confirmar"}
              </button>
              <button onClick={()=>{setRemoveMode(false);setCountdown(0);}} style={{padding:"8px 16px",background:"transparent",border:`1px solid ${T.border}`,borderRadius:6,color:T.textMid,fontSize:11,cursor:"pointer",fontFamily:"Georgia,serif"}}>✕ Cancelar</button>
            </div>
          )}
        </div>

      <div style={{display:"flex",flexDirection:"column",gap:10}}>
        {logs.map(log=>(
          <div key={log.id} style={{background:T.bgCard,border:`1px solid ${selectedLogs[log.id]?"#b85000":T.border}`,borderRadius:8,padding:"14px 16px",display:"flex",gap:12,alignItems:"flex-start"}}>
              <input
                type="checkbox"
                checked={!!selectedLogs[log.id]}
                onChange={()=>toggleLogSelection(log.id)}
                style={{width:16,height:16,accentColor:"#b85000",marginTop:2,flexShrink:0,cursor:"pointer"}}
              />
            <div style={{flex:1,minWidth:0}}>
              <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:6,flexWrap:"wrap"}}>
                <span style={{fontSize:20}}>{getActionIcon(log.action)}</span>
                <span style={{fontSize:13,fontWeight:700,color:T.bgDark}}>{log.action}</span>
                <span style={{fontSize:10,color:T.textLight,padding:"2px 8px",background:T.bgDeep,borderRadius:10}}>{log.userName}</span>
                <span style={{fontSize:9,color:T.textLight}}>{formatDate(log.timestamp)}</span>
                {!removeMode&&(
                  <div style={{marginLeft:"auto",display:"flex",gap:4}}>
                    <button onClick={()=>removeSingleLog(log.id)} style={{padding:"4px 10px",background:"transparent",border:`1px solid ${T.border}`,borderRadius:4,color:T.textMid,fontSize:9,cursor:"pointer",fontFamily:"Georgia,serif"}}>🗑️</button>
                  </div>
                )}
              </div>
              <div style={{fontSize:11,color:T.text,lineHeight:1.5}}>{log.details}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

// Componente de visualização de acessos
function AccessLogView({st,upd,user}){
  const [selectedAccess, setSelectedAccess]=useState({});
  const [removeMode,setRemoveMode]=useState(false);
  const [countdown,setCountdown]=useState(0);

  useEffect(()=>{
    if(countdown>0){
      const t=setTimeout(()=>setCountdown(c=>c-1),1000);
      return()=>clearTimeout(t);
    }else if(countdown===0&&removeMode){
      setRemoveMode(false);
    }
  },[countdown,removeMode]);

  // Verificação de segurança - apenas Teixeira pode acessar
  if(user.id!=="teixeira"){
    return(
      <div style={{textAlign:"center",color:T.textLight,fontSize:12,padding:"40px 0"}}>
        <div style={{fontSize:32,marginBottom:8}}>🔒</div>
        Acesso restrito
      </div>
    );
  }

  const accessLogs=st.accessLogs||[];

  const toggleAccessSelection=(accessId)=>{
    // isTeixeira check removed
    setSelectedAccess(s=>({...s,[accessId]:!s[accessId]}));
  };

  const selectAll=()=>{
    // isTeixeira check removed
    const newSel={};
    accessLogs.forEach(a=>newSel[a.id]=true);
    setSelectedAccess(newSel);
  };

  const clearSelection=()=>setSelectedAccess({});

  const startRemoveMode=()=>{
    const hasSelection=Object.values(selectedAccess).some(v=>v);
    if(!hasSelection){
      alert("Selecione pelo menos um acesso para remover.");
      return;
    }
    setRemoveMode(true);
    setCountdown(3);
  };

  const confirmRemoval=()=>{
    const toRemove=Object.keys(selectedAccess).filter(id=>selectedAccess[id]);
    upd(p=>({...p,accessLogs:(p.accessLogs||[]).filter(a=>!toRemove.includes(a.id))}));
    setSelectedAccess({});
    setRemoveMode(false);
    setCountdown(0);
  };

  const removeSingleAccess=(accessId)=>{
    // isTeixeira check removed
    if(window.confirm("Tem certeza que deseja remover este registro de acesso?")){
      upd(p=>({...p,accessLogs:(p.accessLogs||[]).filter(a=>a.id!==accessId)}));
    }
  };

  const formatDate=(isoStr)=>new Date(isoStr).toLocaleString("pt-BR");

  if(accessLogs.length===0)return(
    <div style={{textAlign:"center",color:T.textLight,fontSize:12,padding:"40px 0"}}>
      <div style={{fontSize:32,marginBottom:8}}>🔐</div>
      Nenhum acesso registrado
    </div>
  );

  return(
    <div>
      <div style={{display:"flex",gap:8,marginBottom:16,flexWrap:"wrap"}}>
          {!removeMode?(
            <>
              {Object.values(selectedAccess).some(v=>v)&&(
                <>
                  <button onClick={selectAll} style={{padding:"8px 16px",background:T.bgCard,border:`1px solid ${T.border}`,borderRadius:6,color:T.textMid,fontSize:11,cursor:"pointer",fontFamily:"Georgia,serif"}}>✓ Selecionar Todos</button>
                  <button onClick={clearSelection} style={{padding:"8px 16px",background:T.bgCard,border:`1px solid ${T.border}`,borderRadius:6,color:T.textMid,fontSize:11,cursor:"pointer",fontFamily:"Georgia,serif"}}>✕ Limpar Seleção</button>
                  <button onClick={startRemoveMode} style={{padding:"8px 16px",background:T.red,border:"none",borderRadius:6,color:T.cream,fontSize:11,fontWeight:700,cursor:"pointer",fontFamily:"Georgia,serif"}}>🗑️ Remover Selecionados</button>
                </>
              )}
              {Object.values(selectedAccess).some(v=>v)&&(
                <span style={{fontSize:11,color:T.textMid,alignSelf:"center"}}>{Object.values(selectedAccess).filter(v=>v).length} selecionado(s)</span>
              )}
            </>
          ):(
            <div style={{display:"flex",gap:8,alignItems:"center"}}>
              <span style={{fontSize:12,color:T.red,fontWeight:700}}>⚠️ Confirmando remoção de {Object.values(selectedAccess).filter(v=>v).length} acesso(s)...</span>
              <button onClick={confirmRemoval} disabled={countdown>0} style={{padding:"8px 16px",background:T.red,border:"none",borderRadius:6,color:T.cream,fontSize:11,fontWeight:700,cursor:countdown>0?"not-allowed":"pointer",fontFamily:"Georgia,serif",opacity:countdown>0?0.6:1}}>
                {countdown>0?`${countdown}s...`:"✓ Confirmar"}
              </button>
              <button onClick={()=>{setRemoveMode(false);setCountdown(0);}} style={{padding:"8px 16px",background:"transparent",border:`1px solid ${T.border}`,borderRadius:6,color:T.textMid,fontSize:11,cursor:"pointer",fontFamily:"Georgia,serif"}}>✕ Cancelar</button>
            </div>
          )}
        </div>

      <div style={{display:"flex",flexDirection:"column",gap:10}}>
        {accessLogs.map(access=>(
          <div key={access.id} style={{background:T.bgCard,border:`1px solid ${selectedAccess[access.id]?"#b85000":T.border}`,borderRadius:8,padding:"14px 16px",display:"flex",gap:12,alignItems:"center"}}>
              <input
                type="checkbox"
                checked={!!selectedAccess[access.id]}
                onChange={()=>toggleAccessSelection(access.id)}
                style={{width:16,height:16,accentColor:"#b85000",flexShrink:0,cursor:"pointer"}}
              />
            <div style={{fontSize:20}}>🔐</div>
            <div style={{flex:1}}>
              <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>
                <span style={{fontSize:13,fontWeight:700,color:T.bgDark}}>{access.userName}</span>
                <span style={{fontSize:9,color:T.textLight}}>{formatDate(access.timestamp)}</span>
                {access.ipAddress&&(
                  <span style={{fontSize:9,color:T.textLight,padding:"2px 8px",background:T.bgDeep,borderRadius:10}}>{access.ipAddress}</span>
                )}
                {!removeMode&&(
                  <button onClick={()=>removeSingleAccess(access.id)} style={{padding:"4px 10px",background:"transparent",border:`1px solid ${T.border}`,borderRadius:4,color:T.textMid,fontSize:9,cursor:"pointer",marginLeft:"auto"}}>🗑️</button>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function Notifs({st,upd,user,isAdmin}){
  const [msg,setMsg]=useState({tid:"all",txt:""});
  const [view,setView]=useState("received");
  // inline response form state: notifId -> text
  const [respForm,setRespForm]=useState({}); // {[notifId]: string}
  const [respOpen,setRespOpen]=useState({}); // {[notifId]: bool}

  const mine=st.notifs.filter(n=>(n.tid===user.id||n.tid==="all")&&!(n.trashedBy||[]).includes(user.id));
  const sent=st.notifs.filter(n=>!(n.trashedBy||[]).includes(user.id)).slice().sort((a,b)=>new Date(b.date)-new Date(a.date));
  const trashed=st.notifs.filter(n=>(n.trashedBy||[]).includes(user.id)).slice().sort((a,b)=>new Date(b.date)-new Date(a.date));

  const alertar=(n)=>upd(p=>({...p,notifs:p.notifs.map(nn=>nn.id===n.id?{...nn,alerted:true}:nn)}));
  const removeAlert=(n)=>upd(p=>({...p,notifs:p.notifs.map(nn=>nn.id===n.id?{...nn,alerted:false}:nn)}));
  const trashNotif=(id)=>upd(p=>({...p,notifs:p.notifs.map(n=>n.id===id?{...n,trashedBy:[...(n.trashedBy||[]),user.id]}:n)}));
  const restoreNotif=(id)=>upd(p=>({...p,notifs:p.notifs.map(n=>n.id===id?{...n,trashedBy:(n.trashedBy||[]).filter(x=>x!==user.id)}:n)}));
  const deleteForever=(id)=>upd(p=>({...p,notifs:p.notifs.filter(n=>n.id!==id)}));

  // Relatar providencia: registra readBy com nome+hora (admin ve como confirmado)
  const submitResponse=(n)=>{
    const txt=(respForm[n.id]||"").trim();
    if(!txt)return;
    upd(p=>({...p,notifs:p.notifs.map(nn=>nn.id===n.id?{...nn,
      responses:[...(nn.responses||[]),{from:user.name,message:txt,date:new Date().toISOString()}],
      readBy:[...(nn.readBy||[]),{userId:user.id,name:user.name,date:new Date().toISOString()}]
    }:nn)}));
    setRespForm(f=>({...f,[n.id]:""}));
    setRespOpen(o=>({...o,[n.id]:false}));
  };

  // Marcar como lida: apenas dispensa o alerta para o usuario (dismissedBy), admin ve como "Visualizada"
  const markReadOnly=(n)=>{
    upd(p=>({...p,notifs:p.notifs.map(nn=>nn.id===n.id?{...nn,
      dismissedBy:[...(nn.dismissedBy||[]),{userId:user.id,name:user.name,date:new Date().toISOString()}]
    }:nn)}));
    setRespOpen(o=>({...o,[n.id]:false}));
  };


  const getTargets=(n)=>{
    if(n.tid==="all") return st.users.filter(u=>u.role!=="admin"&&!u.hidden);
    return st.users.filter(u=>u.id===n.tid);
  };

  return(
    <div style={{maxWidth:720}}>
      <SH title="Notificações" sub="COMUNICADOS E ORDENS DE PROVIDÊNCIA"/>

      {isAdmin&&(
        <Card style={{padding:"18px 20px",marginBottom:18}}>
          <div style={{fontSize:8,letterSpacing:3,color:T.olive,marginBottom:11,fontFamily:"'Special Elite',serif",fontWeight:700}}>ENVIAR NOTIFICAÇÃO</div>
          <select value={msg.tid} onChange={e=>setMsg(m=>({...m,tid:e.target.value}))} style={{width:"100%",background:T.bgDeep,border:`1px solid ${T.border}`,color:T.text,padding:"8px 10px",borderRadius:2,fontSize:11,marginBottom:8,fontFamily:"'Special Elite',serif"}}>
            <option value="all">Todos os usuários</option>
            {st.users.filter(u=>u.role!=="admin"&&!u.hidden).map(u=><option key={u.id} value={u.id}>{u.name} — {u.username}</option>)}
          </select>
          <Inp value={msg.txt} onChange={e=>setMsg(m=>({...m,txt:e.target.value}))} placeholder="Conteúdo da notificação..." rows={3} style={{marginBottom:8}}/>
          <Btn onClick={()=>{
            if(!msg.txt.trim()) return;
            const n={id:Date.now()+"",tid:msg.tid,message:msg.txt.trim(),from:user.name,date:new Date().toISOString(),readBy:[],responses:[],alerted:false};
            upd(p=>({...p,notifs:[...p.notifs,n]}));
            setMsg({tid:"all",txt:""});
            // NÃO enviar notificação local para o admin que está enviando
            // A notificação será recebida pelos destinatários quando eles sincronizarem
          }}>ENVIAR</Btn>
        </Card>
      )}

      <div style={{display:"flex",gap:0,marginBottom:16,border:`1px solid ${T.border}`,borderRadius:2,overflow:"hidden",width:"fit-content"}}>
        {(isAdmin?[["received","RECEBIDAS"],["sent","ENVIADAS"],["trash","🗑 LIXEIRA"]]:[["received","RECEBIDAS"],["trash","🗑 LIXEIRA"]]).map(([v,lb])=>(
          <button key={v} onClick={()=>setView(v)} style={{padding:"8px 22px",background:view===v?T.olive:"transparent",color:view===v?T.cream:T.textMid,border:"none",cursor:"pointer",fontSize:10,fontWeight:700,fontFamily:"Georgia,serif",letterSpacing:1}}>{lb}</button>
        ))}
      </div>

      {/* SENT panel - admin */}
      {isAdmin&&view==="sent"&&(
        <div>
          {sent.length===0
            ?<div style={{color:T.textLight,fontSize:12,fontStyle:"italic"}}>Nenhuma notificação enviada</div>
            :sent.map(n=>{
              const targets=getTargets(n);
              const readBy=(n.readBy||[]);       // responded users [{userId,name,date}]
              const dismissedBy=(n.dismissedBy||[]); // dismissed users [{userId,name,date}]
              const allConfirmed=targets.every(u=>readBy.some(r=>r.userId===u.id));
              const allActioned=targets.every(u=>readBy.some(r=>r.userId===u.id)||dismissedBy.some(d=>d.userId===u.id));
              const unreadTargets=targets.filter(u=>!readBy.some(r=>r.userId===u.id)&&!dismissedBy.some(d=>d.userId===u.id));
              return(
                <Card key={n.id} style={{padding:"14px 16px",marginBottom:10,borderLeft:`3px solid ${allConfirmed?T.green:allActioned?T.oliveMid:T.yellow}`}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:8,marginBottom:8}}>
                    <div style={{flex:1}}>
                      <div style={{fontSize:9,color:T.textLight,letterSpacing:2,fontFamily:"'Special Elite',serif",marginBottom:4}}>
                        PARA: {n.tid==="all"?"TODOS":targets.map(u=>u.name).join(", ")} · {new Date(n.date).toLocaleString("pt-BR")}
                      </div>
                      <div style={{fontSize:12,color:T.text,lineHeight:1.6}}>{n.message}</div>
                    </div>
                    <div style={{display:"flex",gap:6,alignItems:"center",flexShrink:0}}>
                      <span style={{fontSize:9,fontWeight:700,padding:"3px 10px",borderRadius:10,background:allConfirmed?"rgba(61,107,53,0.12)":allActioned?"rgba(61,107,53,0.06)":"rgba(138,112,48,0.12)",color:allConfirmed?T.green:allActioned?T.oliveMid:T.yellow,fontFamily:"'Special Elite',serif",letterSpacing:1,whiteSpace:"nowrap"}}>
                        {allConfirmed?"✓ CONFIRMADA":allActioned?"👁 VISUALIZADA":"PENDENTE"}
                      </span>
                      <button onClick={()=>trashNotif(n.id)} title="Mover para lixeira" style={{background:"transparent",border:`1px solid ${T.red}40`,color:T.red,width:24,height:24,borderRadius:2,cursor:"pointer",fontSize:12,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>🗑</button>
                    </div>
                  </div>
                  {targets.length>0&&(
                    <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:8}}>
                      {targets.map(u=>{
                        const resp=readBy.find(r=>r.userId===u.id);
                        const dism=dismissedBy.find(d=>d.userId===u.id);
                        const color=resp?T.green:dism?T.oliveMid:T.red;
                        const bg=resp?"rgba(61,107,53,0.10)":dism?"rgba(74,82,53,0.08)":"rgba(122,48,48,0.08)";
                        const viewed=(n.viewedBy||[]).find(v=>v.userId===u.id);
                        const label=resp?`✓ ${u.name} — ${new Date(resp.date).toLocaleString("pt-BR")}`:dism?`👁 ${u.name} (dispensou) — ${new Date(dism.date).toLocaleString("pt-BR")}`:viewed?`👁 ${u.name} (abriu) — ${new Date(viewed.date).toLocaleString("pt-BR")}`:`✗ ${u.name}`;
                        return(
                          <span key={u.id} style={{fontSize:9,padding:"2px 8px",borderRadius:10,background:bg,color,border:`1px solid ${color}30`,fontFamily:"'Special Elite',serif"}}>
                            {label}
                          </span>
                        );
                      })}
                    </div>
                  )}
                  {(n.responses||[]).length>0&&(
                    <div style={{marginBottom:8}}>
                      {n.responses.map((r,i)=>(
                        <div key={i} style={{background:T.bgDeep,border:`1px solid ${T.border}`,borderRadius:2,padding:"5px 10px",marginBottom:4,fontSize:11}}>
                          <span style={{color:T.oliveMid,fontWeight:700}}>{r.from}: </span><span style={{color:T.textMid}}>{r.message}</span>
                          <span style={{color:T.textLight,fontSize:9,marginLeft:8}}>{new Date(r.date).toLocaleString("pt-BR")}</span>
                        </div>
                      ))}
                    </div>
                  )}
                  {unreadTargets.length>0&&(
                    <div style={{display:"flex",gap:8,alignItems:"center"}}>
                      {!n.alerted
                        ?<Btn variant="red" style={{padding:"5px 14px",fontSize:10}} onClick={()=>alertar(n)}>⚠ ALERTAR</Btn>
                        :<>
                          <span style={{fontSize:10,color:"#b85000",fontWeight:700,fontFamily:"Georgia,serif",animation:"bpulse 1.5s infinite"}}>⚠️ ALERTA ATIVO</span>
                          <Btn variant="ghost" style={{padding:"4px 10px",fontSize:9}} onClick={()=>removeAlert(n)}>Remover alerta</Btn>
                        </>
                      }
                    </div>
                  )}
                </Card>
              );
            })
          }
        </div>
      )}

      {/* TRASH panel */}
      {view==="trash"&&(
        <div>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:11}}>
            <div style={{fontSize:8,letterSpacing:3,color:T.textLight,fontFamily:"'Special Elite',serif"}}>NOTIFICAÇÕES EXCLUÍDAS</div>
            {trashed.length>0&&<Btn variant="red" style={{padding:"4px 12px",fontSize:9}} onClick={()=>trashed.forEach(n=>deleteForever(n.id))}>🗑 ESVAZIAR LIXEIRA</Btn>}
          </div>
          {trashed.length===0
            ?<div style={{color:T.textLight,fontSize:12,fontStyle:"italic"}}>Lixeira vazia</div>
            :trashed.map(n=>{
              return(
                <Card key={n.id} style={{padding:"13px 16px",marginBottom:9,opacity:0.7,borderLeft:`3px solid ${T.borderDark}`}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:8,marginBottom:6}}>
                    <div style={{flex:1}}>
                      {isAdmin&&<div style={{fontSize:9,color:T.textLight,letterSpacing:1,fontFamily:"'Special Elite',serif",marginBottom:3}}>PARA: {n.tid==="all"?"TODOS":st.users.find(u=>u.id===n.tid)?.name||n.tid} · {new Date(n.date).toLocaleString("pt-BR")}</div>}
                      {!isAdmin&&<div style={{fontSize:9,color:T.textLight,marginBottom:3}}>{n.from} · {new Date(n.date).toLocaleString("pt-BR")}</div>}
                      <div style={{fontSize:12,color:T.textMid,lineHeight:1.5}}>{n.message}</div>
                    </div>
                    <div style={{display:"flex",gap:6,flexShrink:0}}>
                      <button onClick={()=>restoreNotif(n.id)} title="Restaurar" style={{background:"transparent",border:`1px solid ${T.olive}50`,color:T.olive,padding:"3px 10px",borderRadius:2,cursor:"pointer",fontSize:9,fontFamily:"'Special Elite',serif",letterSpacing:1}}>↩ RESTAURAR</button>
                      <button onClick={()=>deleteForever(n.id)} title="Excluir permanentemente" style={{background:"transparent",border:`1px solid ${T.red}50`,color:T.red,padding:"3px 10px",borderRadius:2,cursor:"pointer",fontSize:9,fontFamily:"'Special Elite',serif",letterSpacing:1}}>✕ EXCLUIR</button>
                    </div>
                  </div>
                </Card>
              );
            })
          }
        </div>
      )}

      {/* RECEIVED panel */}
      {(!isAdmin||view==="received")&&(
        <div>
          <div style={{fontSize:8,letterSpacing:3,color:T.textLight,marginBottom:11,fontFamily:"'Special Elite',serif"}}>MENSAGENS RECEBIDAS</div>
          {mine.length===0
            ?<div style={{color:T.textLight,fontSize:12,fontStyle:"italic"}}>Nenhuma notificação</div>
            :mine.map(n=>{
              const responded=(n.readBy||[]).some(r=>r.userId===user.id);
              const dismissed=(n.dismissedBy||[]).some(d=>d.userId===user.id);
              const actioned=responded||dismissed;
              const isRespOpen=respOpen[n.id]||false;
              return(
                <Card key={n.id} style={{padding:"13px 16px",marginBottom:9,borderLeft:`3px solid ${actioned?T.tan:n.alerted?"#b85000":T.olive}`}}>
                  {n.alerted&&!actioned&&(
                    <div style={{background:"rgba(184,80,0,0.08)",border:"1px solid rgba(184,80,0,0.3)",borderRadius:2,padding:"5px 10px",marginBottom:8,fontSize:9,color:"#b85000",fontFamily:"'Special Elite',serif",letterSpacing:1,display:"flex",alignItems:"center",gap:6}}>
                      <span style={{animation:"bpulse 1s infinite",display:"inline-block"}}>⚠️</span> ALERTA ATIVO — RESPOSTA NECESSÁRIA
                    </div>
                  )}
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}>
                    <span style={{fontSize:11,color:T.olive,fontWeight:700,fontFamily:"'Playfair Display',Georgia,serif"}}>{n.from}</span>
                    <div style={{display:"flex",gap:8,alignItems:"center"}}>
                      <span style={{fontSize:9,color:T.textLight}}>{new Date(n.date).toLocaleString("pt-BR")}</span>
                      <button onClick={()=>trashNotif(n.id)} title="Mover para lixeira" style={{background:"transparent",border:`1px solid ${T.red}40`,color:T.red,width:22,height:22,borderRadius:2,cursor:"pointer",fontSize:11,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>🗑</button>
                    </div>
                  </div>
                  <div style={{fontSize:12,color:T.text,lineHeight:1.6,marginBottom:10}}>{n.message}</div>
                  {(n.responses||[]).map((r,i)=>(
                    <div key={i} style={{background:T.bgDeep,border:`1px solid ${T.border}`,borderRadius:2,padding:"6px 10px",marginBottom:5,fontSize:11}}>
                      <span style={{color:T.oliveMid,fontWeight:700}}>{r.from}: </span><span style={{color:T.textMid}}>{r.message}</span>
                    </div>
                  ))}
                  {!isAdmin&&!actioned&&(
                    <div>
                      {!isRespOpen?(
                        <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                          <Btn variant="ghost" style={{padding:"6px 14px",fontSize:9}} onClick={()=>setRespOpen(o=>({...o,[n.id]:true}))}>
                            ✍ RELATAR PROVIDÊNCIA
                          </Btn>
                          <Btn variant="ghost" style={{padding:"6px 14px",fontSize:9,color:T.green,border:`1px solid ${T.green}40`}} onClick={()=>markReadOnly(n)}>
                            ✓ MARCAR COMO LIDA
                          </Btn>
                        </div>
                      ):(
                        <div style={{background:T.bgDeep,border:`1px solid ${T.border}`,borderRadius:2,padding:12,marginTop:4}}>
                          <div style={{fontSize:8,letterSpacing:2,color:T.textLight,marginBottom:6,fontFamily:"'Special Elite',serif"}}>PROVIDÊNCIA TOMADA</div>
                          <textarea
                            value={respForm[n.id]||""}
                            onChange={e=>setRespForm(f=>({...f,[n.id]:e.target.value}))}
                            placeholder="Descreva a providência tomada..."
                            rows={3}
                            style={{width:"100%",background:T.bgCard,border:`1px solid ${T.border}`,borderRadius:2,padding:"9px 12px",color:T.text,fontSize:12,outline:"none",boxSizing:"border-box",resize:"vertical",fontFamily:"Georgia,serif"}}
                            autoFocus
                          />
                          <div style={{display:"flex",gap:8,marginTop:8}}>
                            <Btn onClick={()=>submitResponse(n)}>ENVIAR PROVIDÊNCIA</Btn>
                            <Btn variant="ghost" onClick={()=>setRespOpen(o=>({...o,[n.id]:false}))}>Cancelar</Btn>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  {!isAdmin&&responded&&(
                    <div style={{fontSize:9,color:T.green,marginTop:4,fontFamily:"'Special Elite',serif",letterSpacing:1}}>✓ PROVIDÊNCIA RELATADA</div>
                  )}
                  {!isAdmin&&dismissed&&!responded&&(
                    <div style={{fontSize:9,color:T.textLight,marginTop:4,fontFamily:"'Special Elite',serif",letterSpacing:1}}>✓ Visualizada</div>
                  )}
                </Card>
              );
            })
          }
        </div>
      )}
    </div>
  );
}

function Hist({st}){
  const [sel,setSel]=useState(null);
  return(
    <div style={{maxWidth:760}}>
      <SH title="Histórico Semanal" sub="MEMÓRIAS AUTOMÁTICAS — DOMINGOS ÀS 23:50"/>
      {st.memories.length===0
        ?<Card style={{padding:40,textAlign:"center"}}><span style={{color:T.textLight,fontSize:12,fontStyle:"italic"}}>Nenhum histórico registrado ainda.</span></Card>
        :st.memories.map((m,i)=>(
          <Card key={i} style={{marginBottom:9,overflow:"hidden"}}>
            <div style={{padding:"12px 16px",display:"flex",justifyContent:"space-between",alignItems:"center",cursor:"pointer",background:sel===i?T.bgDeep:"transparent"}} onClick={()=>setSel(sel===i?null:i)}>
              <div>
                <span style={{fontSize:12,color:T.bgDark,fontWeight:700,fontFamily:"'Playfair Display',Georgia,serif"}}>{weekLabel(m.wk)}</span>
                <span style={{fontSize:10,color:T.textLight,marginLeft:12}}>{new Date(m.date).toLocaleString("pt-BR")}</span>
              </div>
              <span style={{color:T.olive,fontSize:10}}>{sel===i?"▲":"▼"}</span>
            </div>
            {sel===i&&(
              <div style={{padding:"0 16px 12px",borderTop:`1px solid ${T.border}`}}>
                {m.vehicles.map(v=>{
                  const c=SC[v.status];
                  return(
                    <div key={v.id} style={{display:"flex",alignItems:"center",gap:10,padding:"8px 0",borderBottom:`1px solid ${T.border}`}}>
                      <Dot status={v.status}/><span style={{fontWeight:700,color:T.bgDark,fontFamily:"'Playfair Display',Georgia,serif",fontSize:12}}>{v.code}</span>
                      <span style={{color:T.textMid,fontSize:10}}>{v.responsible}</span>
                      <span style={{marginLeft:"auto",fontSize:8,color:c.color,fontFamily:"'Special Elite',serif",letterSpacing:2}}>{c.label.toUpperCase()}</span>
                    </div>
                  );
                })}
              </div>
            )}
          </Card>
        ))
      }
    </div>
  );
}

function NapRow({item, displayNum, saved, onSetStatus, onSetObs}){
  return(
    <div style={{background:item.status==="c/a"?T.redBg:item.status==="s/a"?"rgba(61,107,53,0.07)":T.bgCard,border:`1px solid ${item.status==="c/a"?"rgba(122,48,48,0.2)":item.status==="s/a"?"rgba(61,107,53,0.2)":T.border}`,borderRadius:2,padding:"10px 13px",marginBottom:6,opacity:saved?0.82:1}}>
      <div style={{display:"flex",gap:10}}>
        <span style={{fontSize:12,color:T.textLight,minWidth:22,paddingTop:2,fontFamily:"'Special Elite',serif",flexShrink:0}}>{displayNum}.</span>
        <div style={{flex:1}}>
          <div style={{fontSize:14,color:T.text,marginBottom:8,lineHeight:1.6,textTransform:"uppercase"}}>{item.name}</div>
          <div style={{display:"flex",gap:5}}>
            {["s/a","c/a"].map(v=>(
              <button key={v} onClick={()=>!saved&&onSetStatus(item.id,v)} style={{padding:"3px 12px",borderRadius:2,border:`1px solid ${item.status===v?(v==="s/a"?T.green:T.red):T.border}`,background:item.status===v?(v==="s/a"?"rgba(61,107,53,0.1)":T.redBg):"transparent",color:item.status===v?(v==="s/a"?T.green:T.red):T.textLight,cursor:saved?"default":"pointer",fontSize:12,fontFamily:"'Special Elite',serif",letterSpacing:1}}>
                {v.toUpperCase()}
              </button>
            ))}
          </div>
          {item.status==="c/a"&&(
            <textarea
              value={item.obs}
              onChange={e=>onSetObs(item.id, e.target.value)}
              placeholder="Descreva a alteração..."
              rows={2}
              disabled={saved}
              style={{marginTop:6,width:"100%",background:T.bgDeep,border:`1px solid ${T.border}`,borderRadius:2,padding:"9px 12px",color:T.text,fontSize:13,outline:"none",boxSizing:"border-box",resize:"vertical",fontFamily:"Georgia,serif"}}
            />
          )}
        </div>
      </div>
    </div>
  );
}

function NapUser({st,upd,vtr,now}){
  const wk=weekKey(now),rk=`${vtr?.id}_${wk}`;
  const ex=st.napRecords[rk];
  const [items,setItems]=useState(()=>ex?ex.items:st.napItems.map(i=>({...i,status:null,obs:""})));
  const [saved,setSaved]=useState(!!ex);
  const [countdown,setCountdown]=useState(0); // countdown para mostrar botão DOCX
  const [showDocxBtn,setShowDocxBtn]=useState(!!ex); // mostrar botão DOCX - se já existe, mostra direto
  const user=st.users.find(u=>u.id===vtr.userId); // Get user for logging

  // Efeito para controlar o countdown simples
  useEffect(()=>{
    if(countdown<=0){
      if(countdown===0 && saved && !showDocxBtn){
        // Quando o countdown chega a 0, mostra o botão DOCX
        setShowDocxBtn(true);
      }
      return;
    }
    const timer=setTimeout(()=>setCountdown(c=>c-1),1000);
    return()=>clearTimeout(timer);
  },[countdown,saved,showDocxBtn]);

  // Reseta o botão DOCX quando os itens são modificados após salvar
  useEffect(()=>{
    if(saved && showDocxBtn){
      setShowDocxBtn(false);
      setCountdown(0);
    }
  },[items]); // eslint-disable-line react-hooks/exhaustive-deps

  const onSetStatus=useCallback((id,s)=>setItems(p=>p.map(i=>i.id===id?{...i,status:s,obs:s==="s/a"?"":i.obs}:i)),[]);
  const onSetObs=useCallback((id,val)=>setItems(p=>p.map(i=>i.id===id?{...i,obs:val}:i)),[]);

  const save=()=>{
    // 1. Salvar os dados
    const r={vId:vtr.id,code:vtr.code,responsible:vtr.responsible,wk,date:new Date().toISOString(),items};
    const altCount=items.filter(i=>i.status==="c/a").length;
    upd(p=>{
      const newLog={
        id:Date.now()+"_"+Math.random().toString(36).substr(2,9),
        userId:user?.id||"unknown",
        userName:user?.name||"Usuário",
        action:"Realizou inspeção NAPION",
        details:`Viatura ${vtr.code} - Semana ${wk} (${altCount} alterações)`,
        timestamp:new Date().toISOString()
      };
      return{...p,
        napRecords:{...p.napRecords,[rk]:r},
        logs:[newLog,...(p.logs||[])]
      };
    });

    // 2. Iniciar countdown de 3 segundos
    setSaved(true);
    setCountdown(3);
    setShowDocxBtn(false);
  };
  const [dlBusy,setDlBusy]=useState(false);
  const dl=async()=>{
    setDlBusy(true);
    try{
      const now2=new Date();
      const genDate=now2.toLocaleDateString("pt-BR",{day:"2-digit",month:"2-digit",year:"numeric"});
      const weekNum=getWeekOfYear(now2);
      const alts=items.filter(i=>i.status==="c/a").map(i=>({name:i.name,obs:i.obs||""}));
      const rows=[{ord:1,vtrCode:vtr.code,responsible:vtr.responsible,status:vtr.status,alteracoes:alts}];
      const blob=await generateNapionDocx(rows,genDate,String(weekNum));
      await downloadFile(blob, `NAPION_${vtr.code.replace(/ /g,"_")}_${wk}.docx`);

      // Adicionar log de download
      upd(p=>{
        const newLog={
          id:Date.now()+"_"+Math.random().toString(36).substr(2,9),
          userId:user?.id||"unknown",
          userName:user?.name||"Usuário",
          action:"Download NAPION DOCX",
          details:`Viatura ${vtr.code} - Semana ${wk}`,
          timestamp:new Date().toISOString()
        };
        return{...p,logs:[newLog,...(p.logs||[])]};
      });
    }catch(e){alert("Erro: "+e.message);}
    setDlBusy(false);
  };
  if(!st.napEnabled)return<div style={{color:T.textLight,textAlign:"center",padding:40,fontStyle:"italic"}}>NAPION desativado pelo administrador.</div>;
  return(
    <div style={{maxWidth:660}}>
      <SH title="Inspeção NAPION" sub={`${vtr.code} — ${vtr.responsible} — ${weekLabel(wk)}`}/>
      {getVtrImg(vtr.code, vtr.image)&&(
        <div style={{display:"flex",justifyContent:"center",marginBottom:16}}>
          <img src={getVtrImg(vtr.code, vtr.image)} alt={vtr.code} style={{height:90,objectFit:"contain",opacity:0.9}}/>
        </div>
      )}


      <div style={{background:T.yellowBg,border:"1px solid rgba(138,112,48,0.3)",borderRadius:2,padding:"8px 14px",marginBottom:14,fontSize:11,color:T.yellow,fontFamily:"'Special Elite',serif",letterSpacing:2}}>⚠ NÃO LIGAR A VIATURA ATÉ COMPLETAR TODOS OS ITENS PRÉ-PARTIDA</div>
      <div style={{marginBottom:12}}>
        <div style={{fontSize:10,letterSpacing:3,color:T.textLight,marginBottom:8,fontFamily:"'Special Elite',serif"}}>ITENS PRÉ-PARTIDA (ANTES DE LIGAR)</div>
        {st.napItems.filter(i=>i.b).map((i, idx) => <NapRow key={i.id} displayNum={idx + 1} item={items.find(x=>x.id===i.id)||{...i,status:null,obs:""}} saved={saved} onSetStatus={onSetStatus} onSetObs={onSetObs}/>)}
      </div>
      <div style={{background:"rgba(61,107,53,0.07)",border:"1px solid rgba(61,107,53,0.25)",borderRadius:2,padding:"8px 14px",marginBottom:12,fontSize:11,color:T.green,fontFamily:"'Special Elite',serif",letterSpacing:2}}>✦ LIGAR A VIATURA</div>
      <div style={{marginBottom:22}}>
        <div style={{fontSize:10,letterSpacing:3,color:T.textLight,marginBottom:8,fontFamily:"'Special Elite',serif"}}>ITENS PÓS-PARTIDA (VIATURA LIGADA)</div>
        {st.napItems.filter(i=>!i.b).map((i, idx) => <NapRow key={i.id} displayNum={idx + 1} item={items.find(x=>x.id===i.id)||{...i,status:null,obs:""}} saved={saved} onSetStatus={onSetStatus} onSetObs={onSetObs}/>)}
      </div>
      <div style={{display:"flex",gap:10,justifyContent:"center",marginBottom:16}}>
        {!saved && <Btn onClick={save} disabled={countdown > 0}>SALVAR INSPEÇÃO</Btn>}
        {saved && !showDocxBtn && countdown > 0 && (
          <Btn variant="dark" disabled style={{cursor:"default"}}>
            ✓ SALVO EM {countdown}s...
          </Btn>
        )}
        {showDocxBtn && <Btn variant="dark" onClick={dl} disabled={dlBusy}>{dlBusy?"Gerando...":"↓ DOWNLOAD .DOCX"}</Btn>}
      </div>
      {/* Espaço extra para não ficar ofuscado pela barra de navegação inferior no mobile */}
      <div style={{height:80}}/>
    </div>
  );
}

function NapAdmin({st,upd,now}){
  const [ni,setNi]=useState({name:"",b:true});
  const [delItem,setDelItem]=useState(null); // item id pending deletion
  const [delCd,setDelCd]=useState(0);
  useEffect(()=>{
    if(delCd<=0)return;
    const t=setTimeout(()=>setDelCd(c=>c-1),1000);
    return()=>clearTimeout(t);
  },[delCd]);
  const startDelItem=(id)=>{setDelItem(id);setDelCd(4);};
  const cancelDelItem=()=>{setDelItem(null);setDelCd(0);};
  const confirmDelItem=(id)=>{upd(p=>({...p,napItems:p.napItems.filter(i=>i.id!==id)}));setDelItem(null);setDelCd(0);};
  const [sel,setSel]=useState({});       // selected vehicles for docx: {vId: true}
  const [genBusy,setGenBusy]=useState(false);
  const wk=weekKey(now);
  const recs=st.vehicles.map(v=>({v,r:st.napRecords[`${v.id}_${wk}`]||null}));
  const done=recs.filter(x=>x.r).length;

  // Toggle all
  const allSel=st.vehicles.length>0&&st.vehicles.every(v=>sel[v.id]);
  const toggleAll=()=>{
    if(allSel) setSel({});
    else { const s={}; st.vehicles.forEach(v=>s[v.id]=true); setSel(s); }
  };

  const genDocx=async()=>{
    const chosen=st.vehicles.filter(v=>sel[v.id]);
    if(chosen.length===0){alert("Selecione ao menos uma viatura.");return;}
    setGenBusy(true);
    try{
      const now2=new Date();
      const genDate=now2.toLocaleDateString("pt-BR",{day:"2-digit",month:"2-digit",year:"numeric"});
      const weekNum=getWeekOfYear(now2);

      const rows=chosen.map((v,i)=>{
        const r=st.napRecords[`${v.id}_${wk}`]||null;
        const alts=r?r.items.filter(i=>i.status==="c/a").map(i=>({name:i.name,obs:i.obs||""})):[];
        return{
          ord: i+1,
          vtrCode: v.code,
          responsible: v.responsible,
          status: v.status,
          alteracoes: alts
        };
      });

      const blob=await generateNapionDocx(rows,genDate,String(weekNum));
      await downloadFile(blob, `NAPION_${wk}.docx`);
    }catch(e){
      alert("Erro ao gerar: "+e.message);
    }
    setGenBusy(false);
  };

  const [napTab,setNapTab]=useState("cur"); // "cur" | "hist" | "arch"
  return(
    <div style={{maxWidth:760}}>
      <SH title="Administração NAPION" sub={`${weekLabel(wk)}`}/>
      {/* Sub-tabs */}
      <div style={{display:"flex",gap:0,marginBottom:18,borderBottom:`1px solid ${T.border}`}}>
        {[["cur","Semana Atual"],["hist","Semanas Anteriores"],["arch","Pendências Arquivadas"]].map(([id,lb])=>(
          <button key={id} onClick={()=>setNapTab(id)} style={{padding:"8px 16px",background:"transparent",border:"none",borderBottom:napTab===id?`2px solid ${T.olive}`:"2px solid transparent",color:napTab===id?T.olive:T.textMid,cursor:"pointer",fontSize:10,fontWeight:700,letterSpacing:1,fontFamily:"Georgia,serif",transition:"color 0.15s"}}>{lb}</button>
        ))}
      </div>
      {napTab==="hist"&&<NapHistory st={st}/>}
      {napTab==="arch"&&<NapArchived st={st} upd={upd}/>}
      {napTab!=="cur"&&null}
      {napTab==="cur"&&<>
      <div style={{display:"flex",gap:12,marginBottom:18,flexWrap:"wrap"}}>
        {[[st.napEnabled?"ATIVO":"INATIVO","STATUS",st.napEnabled?T.green:T.red],[`${done}/${st.vehicles.length}`,"REALIZADAS",T.olive],[`${st.vehicles.length-done}`,"PENDENTES",T.yellow]].map(([v,lb,c])=>(
          <div key={lb} style={{background:T.bgCard,border:`1px solid ${T.border}`,borderTop:`3px solid ${c}`,borderRadius:3,padding:"14px 18px",flex:1,minWidth:110,boxShadow:T.shadow}}>
            <div style={{fontSize:24,fontWeight:700,color:c,fontFamily:"'Playfair Display',Georgia,serif"}}>{v}</div>
            <div style={{fontSize:8,letterSpacing:3,color:T.textLight,marginTop:5,fontFamily:"'Special Elite',serif"}}>{lb}</div>
          </div>
        ))}
      </div>
      <Btn variant={st.napEnabled?"red":"ghost"} style={{marginBottom:18}} onClick={()=>upd(p=>({...p,napEnabled:!p.napEnabled}))}>{st.napEnabled?"DESATIVAR NAPION":"ATIVAR NAPION"}</Btn>

      {/* Docx report generator */}
      <Card style={{padding:"16px 18px",marginBottom:16}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
          <div style={{fontSize:8,letterSpacing:3,color:T.olive,fontFamily:"'Special Elite',serif",fontWeight:700}}>RELATÓRIO DOCX — SELECIONAR VIATURAS</div>
          <div style={{display:"flex",gap:8}}>
            <Btn variant="ghost" style={{padding:"5px 12px",fontSize:9}} onClick={toggleAll}>{allSel?"Desmarcar tudo":"Selecionar tudo"}</Btn>
            <Btn variant="dark" style={{padding:"5px 14px",fontSize:9}} onClick={genDocx} disabled={genBusy}>
              {genBusy?"Gerando...":"↓ GERAR .DOCX"}
            </Btn>
          </div>
        </div>
        {recs.map(({v,r})=>(
          <div key={v.id} style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"8px 0",borderBottom:`1px solid ${T.border}`}}>
            <div style={{display:"flex",alignItems:"center",gap:10}}>
              <input type="checkbox" checked={!!sel[v.id]} onChange={()=>setSel(s=>({...s,[v.id]:!s[v.id]}))}
                style={{width:15,height:15,cursor:"pointer",accentColor:T.olive}}/>
              <div>
                <span style={{fontWeight:700,color:T.bgDark,fontFamily:"'Playfair Display',Georgia,serif",fontSize:12}}>{v.code}</span>
                <span style={{color:T.textMid,fontSize:10,marginLeft:10}}>{v.responsible}</span>
              </div>
            </div>
            <span style={{fontSize:8,color:r?T.green:T.red,fontFamily:"'Special Elite',serif",letterSpacing:2,fontWeight:700}}>{r?"REALIZADO":"PENDENTE"}</span>
          </div>
        ))}
      </Card>

      <Card style={{padding:"16px 18px"}}>
        <div style={{fontSize:8,letterSpacing:3,color:T.olive,marginBottom:12,fontFamily:"'Special Elite',serif",fontWeight:700}}>ITENS DA INSPEÇÃO</div>
        <div style={{display:"flex",gap:7,marginBottom:12,flexWrap:"wrap"}}>
          <Inp value={ni.name} onChange={e=>setNi(n=>({...n,name:e.target.value}))} placeholder="Nome do novo item..." style={{flex:1,minWidth:180}}/>
          <select value={ni.b?"b":"a"} onChange={e=>setNi(n=>({...n,b:e.target.value==="b"}))} style={{background:T.bgDeep,border:`1px solid ${T.border}`,color:T.text,padding:"8px 10px",borderRadius:2,fontSize:10,fontFamily:"'Special Elite',serif"}}>
            <option value="b">Antes de ligar</option><option value="a">Após ligar</option>
          </select>
          <Btn onClick={()=>{if(!ni.name.trim())return;const id=Math.max(...st.napItems.map(i=>i.id),0)+1;upd(p=>({...p,napItems:[...p.napItems,{id,name:ni.name.trim(),b:ni.b}]}));setNi({name:"",b:true});}}>+ ADD</Btn>
        </div>
        <div style={{maxHeight:250,overflowY:"auto"}}>
          {[
            ...st.napItems.filter(i=>i.b).map((item, idx) => ({...item, displayNum: idx + 1})),
            ...st.napItems.filter(i=>!i.b).map((item, idx) => ({...item, displayNum: idx + 1}))
          ].map(item=>(
            <div key={item.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"6px 9px",borderRadius:2,marginBottom:3,background:T.bgDeep}}>
              <span style={{fontSize:11,color:T.text}}><span style={{color:T.textLight,fontSize:9,marginRight:6,fontFamily:"'Special Elite',serif"}}>{item.b ? `A${item.displayNum}` : `P${item.displayNum}`}.</span>{item.name.toUpperCase()}</span>
              <div style={{display:"flex",gap:5,alignItems:"center",flexShrink:0,marginLeft:8}}>
                <span style={{fontSize:8,color:item.b?T.yellow:T.green,letterSpacing:1,fontFamily:"'Special Elite',serif"}}>{item.b?"ANTES":"APÓS"}</span>
                {delItem!==item.id?(
                  <Btn variant="red" style={{padding:"2px 7px",fontSize:9}} onClick={()=>startDelItem(item.id)}>✕</Btn>
                ):(
                  <div style={{display:"flex",gap:4,alignItems:"center"}}>
                    <Btn variant="red" style={{padding:"2px 7px",fontSize:9,opacity:delCd>0?0.5:1,cursor:delCd>0?"not-allowed":"pointer"}}
                      onClick={()=>delCd===0&&confirmDelItem(item.id)}>{delCd>0?`${delCd}s`:"OK"}</Btn>
                    <Btn variant="ghost" style={{padding:"2px 6px",fontSize:9}} onClick={cancelDelItem}>✕</Btn>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </Card>
    </>}
    </div>
  );
}

// ── NapHistory: consulta semanas anteriores ──────────────────────────────────
function NapHistory({st}){
  const mems=(st.napMemories||[]).slice().sort((a,b)=>b.wk.localeCompare(a.wk));
  const [selWk,setSelWk]=useState(mems.length>0?mems[0].wk:null);
  const [selVeh,setSelVeh]=useState(null);
  if(mems.length===0) return <div style={{color:T.textLight,fontSize:12,padding:"20px 0",textAlign:"center"}}>Nenhum histórico semanal disponível ainda.<br/><span style={{fontSize:10}}>O sistema salva automaticamente ao iniciar nova semana.</span></div>;
  const mem=mems.find(m=>m.wk===selWk);
  const vKeys=mem?Object.keys(mem.records||{}):[]; // "vId_wk"
  const vRecs=vKeys.map(k=>mem.records[k]).sort((a,b)=>a.code.localeCompare(b.code));
  const cur=selVeh?vRecs.find(r=>r.vId===selVeh):null;
  return(
    <div>
      <div style={{display:"flex",gap:8,marginBottom:14,flexWrap:"wrap",alignItems:"center"}}>
        <div style={{fontSize:8,letterSpacing:2,color:T.textLight,fontFamily:"'Special Elite',serif"}}>SEMANA:</div>
        <select value={selWk||""} onChange={e=>{setSelWk(e.target.value);setSelVeh(null);}} style={{background:T.bgDeep,border:`1px solid ${T.border}`,color:T.text,padding:"6px 10px",borderRadius:2,fontSize:11,fontFamily:"Georgia,serif"}}>
          {mems.map(m=><option key={m.wk} value={m.wk}>{weekLabel(m.wk)} ({Object.keys(m.records||{}).length} viaturas)</option>)}
        </select>
      </div>
      {mem&&(
        <div style={{display:"flex",gap:12,flexWrap:"wrap",marginBottom:14}}>
          {vRecs.map(r=>(
            <button key={r.vId} onClick={()=>setSelVeh(selVeh===r.vId?null:r.vId)}
              style={{background:selVeh===r.vId?T.bgCard:T.bgDeep,border:`1px solid ${selVeh===r.vId?T.olive:T.border}`,borderRadius:3,padding:"8px 14px",cursor:"pointer",color:selVeh===r.vId?T.olive:T.textMid,fontSize:10,fontFamily:"Georgia,serif",fontWeight:700,transition:"all 0.15s"}}>
              {r.code}
            </button>
          ))}
        </div>
      )}
      {cur&&(
        <Card style={{padding:"16px 18px"}}>
          <div style={{display:"flex",justifyContent:"space-between",marginBottom:12}}>
            <div>
              <div style={{fontWeight:700,color:T.bgDark,fontFamily:"'Playfair Display',Georgia,serif",fontSize:14}}>{cur.code}</div>
              <div style={{fontSize:10,color:T.textMid,marginTop:2}}>{cur.responsible} — Semana {cur.wk}</div>
            </div>
            <div style={{fontSize:9,color:T.textLight,textAlign:"right"}}>{cur.date?new Date(cur.date).toLocaleString("pt-BR"):""}</div>
          </div>
          <div style={{maxHeight:350,overflowY:"auto"}}>
            {(cur.items||[]).map(item=>(
              <div key={item.id} style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",padding:"7px 0",borderBottom:`1px solid ${T.border}33`}}>
                <div style={{flex:1}}>
                  <span style={{fontSize:10,color:item.status==="c/a"?T.yellow:T.text,textTransform:"uppercase"}}>{item.name}</span>
                  {item.obs&&<div style={{fontSize:9,color:T.textLight,marginTop:2,fontStyle:"italic"}}>{item.obs}</div>}
                </div>
                <span style={{fontSize:9,fontWeight:700,letterSpacing:1,fontFamily:"'Special Elite',serif",color:item.status==="c/a"?T.red:T.green,marginLeft:10,flexShrink:0}}>{item.status?.toUpperCase()||"—"}</span>
              </div>
            ))}
          </div>
        </Card>
      )}
    </div>
  );
}

// ── NapArchived: pendências arquivadas por admin ──────────────────────────────
function NapArchived({st,upd}){
  const [delId,setDelId]=useState(null);
  const [delCd,setDelCd]=useState(0);
  useEffect(()=>{
    if(delCd>0){
      const t=setTimeout(()=>setDelCd(c=>c-1),1000);
      return()=>clearTimeout(t);
    }
  },[delCd]);

  const archived=st.vehicles.flatMap(v=>(v.alteracoes||[]).filter(a=>a.archived).map(a=>({...a,vCode:v.code,vId:v.id})));
  archived.sort((a,b)=>new Date(b.archivedAt||0)-new Date(a.archivedAt||0));
  if(archived.length===0) return <div style={{color:T.textLight,fontSize:12,padding:"20px 0",textAlign:"center"}}>Nenhuma pendência arquivada ainda.</div>;
  const desarquivar=(vId,aId)=>upd(p=>({...p,vehicles:p.vehicles.map(v=>v.id===vId?{...v,alteracoes:v.alteracoes.map(x=>x.id===aId?{...x,archived:false,archivedAt:null}:x)}:v)}));
  const startDel=(vId,aId)=>{setDelId(`${vId}_${aId}`);setDelCd(4);};
  const cancelDel=()=>{setDelId(null);setDelCd(0);};
  const confirmDel=(vId,aId)=>upd(p=>({...p,vehicles:p.vehicles.map(v=>v.id===vId?{...v,alteracoes:v.alteracoes.filter(x=>x.id!==aId)}:v)}));
  const isDeleting=(vId,aId)=>delId===`${vId}_${aId}`;
  return(
    <div>
      <div style={{fontSize:10,color:T.textLight,marginBottom:14}}>{archived.length} pendência(s) arquivada(s)</div>
      {archived.map(a=>(
        <div key={a.id} style={{background:T.bgDeep,border:`1px solid ${T.border}`,borderRadius:3,padding:"10px 14px",marginBottom:8}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:8}}>
            <div style={{flex:1}}>
              <div style={{fontSize:9,color:T.olive,fontFamily:"'Special Elite',serif",letterSpacing:2,marginBottom:3}}>{a.vCode}</div>
              <div style={{fontSize:12,color:T.textMid,lineHeight:1.5}}>{a.descricao}</div>
              <div style={{fontSize:9,color:T.green,marginTop:2}}>✓ {a.resolvedDesc}</div>
              <div style={{fontSize:9,color:"#555",marginTop:2}}>Arquivado: {a.archivedAt?new Date(a.archivedAt).toLocaleString("pt-BR"):""}</div>
            </div>
            <div style={{display:"flex",gap:5,flexShrink:0}}>
              {isDeleting(a.vId,a.id)?(
                <div style={{display:"flex",gap:5,alignItems:"center"}}>
                  <span style={{fontSize:9,color:T.red,fontWeight:700}}>{delCd}s</span>
                  <Btn variant="red" style={{padding:"3px 9px",fontSize:9}} onClick={()=>confirmDel(a.vId,a.id)}>✓ Excluir</Btn>
                  <Btn variant="ghost" style={{padding:"3px 9px",fontSize:9}} onClick={cancelDel}>✕</Btn>
                </div>
              ):(
                <>
                  <Btn variant="ghost" style={{padding:"3px 9px",fontSize:9}} onClick={()=>desarquivar(a.vId,a.id)}>↩ Desarquivar</Btn>
                  <Btn variant="red" style={{padding:"3px 9px",fontSize:9}} onClick={()=>startDel(a.vId,a.id)}>🗑️</Btn>
                </>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

function Users({st,upd,user}){
  const [form,setForm]=useState({username:"",password:"",name:"",vc:"",vr:""});
  const [show,setShow]=useState(false);
  const [confirmId,setConfirmId]=useState(null);
  const [countdown,setCountdown]=useState(0);
  const [editResp,setEditResp]=useState(null);      // userId being edited
  const [editRespVal,setEditRespVal]=useState("");
  const [customImage,setCustomImage]=useState(""); // imagem customizada da viatura

  // Countdown effect
  useEffect(()=>{
    if(countdown<=0) return;
    const t=setTimeout(()=>setCountdown(c=>c-1),1000);
    return ()=>clearTimeout(t);
  },[countdown]);

  // Função auxiliar para adicionar log
  const addLog=(action,details)=>{
    const newLog={
      id:Date.now()+"_"+Math.random().toString(36).substr(2,9),
      userId:user.id,
      userName:user.name,
      action,
      details,
      timestamp:new Date().toISOString()
    };
    upd(p=>({...p,logs:[newLog,...(p.logs||[])]}));
  };

  const startRemove=(id)=>{setConfirmId(id);setCountdown(5);};
  const cancelRemove=()=>{setConfirmId(null);setCountdown(0);};
  const confirmRemove=(id)=>{
    const u=st.users.find(x=>x.id===id);
    upd(p=>({...p,users:p.users.filter(x=>x.id!==id),vehicles:p.vehicles.filter(x=>x.userId!==id)}));
    addLog("Removeu usuário",`Usuário ${u?.name||"desconhecido"} (${u?.username||"desconhecido"}) foi removido`);
    setConfirmId(null);setCountdown(0);
  };

  const add=()=>{
    if(Object.values(form).some(v=>!v.trim())){alert("Preencha todos os campos.");return;}
    if(st.users.find(u=>u.username.toLowerCase()===form.username.toLowerCase())){alert("Login já existe.");return;}
    const vId="v"+Date.now(),uId="u"+Date.now();
    upd(p=>({...p,users:[...p.users,{id:uId,username:form.username.trim(),password:form.password,role:"user",name:form.name.trim(),vehicleId:vId}],vehicles:[...p.vehicles,{id:vId,code:form.vc.trim(),responsible:form.vr.trim(),status:"disponivel",alteracoes:[],userId:uId,image:customImage.trim()||undefined}]}));
    addLog("Criou usuário",`Usuário ${form.name.trim()} (${form.username.trim()}) - Viatura ${form.vc.trim()}`);
    setForm({username:"",password:"",name:"",vc:"",vr:""});setCustomImage("");setShow(false);
  };

  return(
    <div style={{maxWidth:660}}>
      <SH title="Gerenciamento de Usuários" sub="CADASTRO E REMOÇÃO DE CHEFES DE PEÇA"/>
      <Btn style={{marginBottom:16}} onClick={()=>setShow(!show)}>+ NOVO USUÁRIO</Btn>
      {show&&(
        <Card style={{padding:"18px 20px",marginBottom:16}}>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
            {[["username","Login"],["password","Senha"],["name","Nome / Patente"],["vc","Código da Viatura (ex: AV-PCC 230)"],["vr","Chefe de Peça"]].map(([k,lb])=>(
              <div key={k} style={{gridColumn:(k==="name"||k==="vc"||k==="vr")?"span 2":"span 1"}}>
                <div style={{fontSize:8,letterSpacing:2,color:T.textLight,marginBottom:4,fontFamily:"'Special Elite',serif"}}>{lb.toUpperCase()}</div>
                <Inp value={form[k]} onChange={e=>setForm(f=>({...f,[k]:e.target.value}))} type={k==="password"?"password":"text"} placeholder=""/>
              </div>
            ))}
            {/* Campo de Imagem Customizada */}
            <div style={{gridColumn:"span 2"}}>
              <div style={{fontSize:8,letterSpacing:2,color:T.textLight,marginBottom:4,fontFamily:"'Special Elite',serif"}}>FOTO DA VIATURA (OPCIONAL)</div>
              <div style={{display:"flex",gap:8,alignItems:"center"}}>
                <Inp
                  value={customImage}
                  onChange={e=>setCustomImage(e.target.value)}
                  type="text"
                  placeholder="Cole a URL da imagem ou deixe em branco para usar a padrão"
                  style={{flex:1}}
                />
                <input
                  type="file"
                  accept="image/*"
                  onChange={e=>{
                    const file=e.target.files[0];
                    if(file){
                      const reader=new FileReader();
                      reader.onload=ev=>setCustomImage(ev.target.result);
                      reader.readAsDataURL(file);
                    }
                  }}
                  style={{fontSize:10,padding:"4px 8px",border:`1px solid ${T.border}`,borderRadius:2,cursor:"pointer"}}
                />
              </div>
              {customImage&&(
                <div style={{marginTop:8}}>
                  <div style={{fontSize:9,color:T.textLight,marginBottom:4,fontFamily:"'Special Elite',serif"}}>PREVIEW:</div>
                  <img src={customImage} alt="Preview" style={{maxHeight:80,borderRadius:2,border:`1px solid ${T.border}`}}/>
                </div>
              )}
            </div>
          </div>
          <div style={{display:"flex",gap:8,marginTop:12}}>
            <Btn onClick={add}>CRIAR</Btn><Btn variant="ghost" onClick={()=>{setForm({username:"",password:"",name:"",vc:"",vr:""});setCustomImage("");setShow(false);}}>Cancelar</Btn>
          </div>
        </Card>
      )}
      {st.users.filter(u=>!u.hidden).map(u=>{
        const v=st.vehicles.find(vv=>vv.userId===u.id);
        const isConfirming=confirmId===u.id;
        return(
          <Card key={u.id} style={{padding:"13px 16px",marginBottom:8,display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:10,border:isConfirming?`1px solid ${T.red}60`:undefined}}>
            <div style={{flex:1}}>
              <div style={{fontWeight:700,color:T.bgDark,fontSize:12,fontFamily:"'Playfair Display',Georgia,serif"}}>{u.name}</div>
              <div style={{fontSize:9,color:T.textLight,marginTop:1}}>Login: <span style={{color:T.textMid,fontFamily:"monospace"}}>{u.username}</span></div>
              {v&&(
                <div style={{fontSize:9,color:T.textLight,marginTop:2,display:"flex",alignItems:"center",gap:6,flexWrap:"wrap"}}>
                  Viatura: <span style={{color:T.olive,fontWeight:600}}>{v.code}</span>
                  {editResp===u.id?(
                    <div style={{display:"flex",gap:5,alignItems:"center",marginTop:4}}>
                      <Inp value={editRespVal} onChange={e=>setEditRespVal(e.target.value)}
                        style={{padding:"3px 8px",fontSize:10,width:200}}
                        placeholder="Nome do chefe de peça"/>
                      <Btn style={{padding:"2px 8px",fontSize:9}} onClick={()=>{
                        upd(p=>({...p,
                          vehicles:p.vehicles.map(vv=>vv.id===v.id?{...vv,responsible:editRespVal.trim()}:vv),
                          users:p.users.map(uu=>uu.id===u.id?{...uu,name:editRespVal.trim()}:uu)
                        }));
                        setEditResp(null);setEditRespVal("");
                      }}>✓</Btn>
                      <Btn variant="ghost" style={{padding:"2px 7px",fontSize:9}} onClick={()=>{setEditResp(null);setEditRespVal("");}}>✕</Btn>
                    </div>
                  ):(
                    <span style={{fontSize:9,color:T.textLight}}>
                      Chefe: <span style={{color:T.textMid}}>{v.responsible}</span>
                      <button onClick={()=>{setEditResp(u.id);setEditRespVal(v.responsible);}}
                        style={{marginLeft:6,background:"transparent",border:`1px solid ${T.border}`,color:T.textLight,padding:"1px 6px",borderRadius:2,cursor:"pointer",fontSize:9}}>✎ editar</button>
                    </span>
                  )}
                </div>
              )}
              <div style={{fontSize:9,color:T.textLight,marginTop:1}}>Último login: <span style={{color:u.lastLogin?T.textMid:"#666",fontFamily:"monospace"}}>{u.lastLogin?new Date(u.lastLogin).toLocaleString("pt-BR",{day:"2-digit",month:"2-digit",year:"numeric",hour:"2-digit",minute:"2-digit"}):"Nunca"}</span></div>
            </div>
            <div style={{display:"flex",gap:6,alignItems:"center"}}>
              <span style={{fontSize:8,color:u.role==="admin"?T.olive:T.textLight,border:`1px solid ${u.role==="admin"?T.borderDark:T.border}`,padding:"2px 6px",borderRadius:10,letterSpacing:1,fontFamily:"'Special Elite',serif"}}>{u.role.toUpperCase()}</span>
              {u.role!=="admin"&&!isConfirming&&(
                <Btn variant="red" style={{padding:"4px 10px",fontSize:9}} onClick={()=>startRemove(u.id)}>REMOVER</Btn>
              )}
              {u.role!=="admin"&&isConfirming&&(
                <div style={{display:"flex",gap:6,alignItems:"center"}}>
                  <span style={{fontSize:9,color:T.red,fontFamily:"'Special Elite',serif",letterSpacing:1}}>Confirmar?</span>
                  <Btn variant="red" style={{padding:"4px 10px",fontSize:9,opacity:countdown>0?0.5:1,cursor:countdown>0?"not-allowed":"pointer"}}
                    onClick={()=>countdown===0&&confirmRemove(u.id)}>
                    {countdown>0?`${countdown}s`:"SIM"}
                  </Btn>
                  <Btn variant="ghost" style={{padding:"4px 10px",fontSize:9}} onClick={cancelRemove}>NÃO</Btn>
                </div>
              )}
            </div>
          </Card>
        );
      })}
    </div>
  );
}

function Suggestions({st,upd,user,isAdmin}){
  const [txt,setTxt]=useState("");
  const [showForm,setShowForm]=useState(false);
  const [filter,setFilter]=useState("all"); // all | open | aceita | descartada | arquivada
  const [delId,setDelId]=useState(null);
  const [delCd,setDelCd]=useState(0);
  useEffect(()=>{if(delCd<=0)return;const t=setTimeout(()=>setDelCd(d=>d-1),1000);return()=>clearTimeout(t);},[delCd]);
  const startDel=(id)=>{setDelId(id);setDelCd(4);};
  const cancelDel=()=>{setDelId(null);setDelCd(0);};
  const confirmDel=(id)=>{upd(p=>({...p,suggestions:(p.suggestions||[]).filter(s=>s.id!==id)}));setDelId(null);setDelCd(0);};

  const sugs=(st.suggestions||[]).slice().sort((a,b)=>new Date(b.date)-new Date(a.date));
  const filtered=filter==="all"?sugs.filter(s=>!s.archived):filter==="arquivada"?sugs.filter(s=>s.archived):sugs.filter(s=>!s.archived&&s.status===filter);

  // Função auxiliar para adicionar log
  const addLog=(action,details)=>{
    const newLog={
      id:Date.now()+"_"+Math.random().toString(36).substr(2,9),
      userId:user.id,
      userName:user.name,
      action,
      details,
      timestamp:new Date().toISOString()
    };
    upd(p=>({...p,logs:[newLog,...(p.logs||[])]}));
  };

  const submit=()=>{
    if(!txt.trim())return;
    const ns={id:Date.now()+"",text:txt.trim(),date:new Date().toISOString(),authorId:user.id,authorName:user.name,status:"open",archived:false};
    upd(p=>({...p,suggestions:[...(p.suggestions||[]),ns]}));
    addLog("Criou sugestão",`Nova sugestão enviada: "${txt.trim().substring(0,50)}${txt.trim().length>50?"...":""}"`);
    setTxt("");setShowForm(false);
  };
  const setStatus=(id,status)=>{
    const s=(st.suggestions||[]).find(x=>x.id===id);
    upd(p=>({...p,suggestions:(p.suggestions||[]).map(s=>s.id===id?{...s,status,statusAt:new Date().toISOString()}:s)}));
    addLog("Mudou status sugestão",`Sugestão "${s?.text?.substring(0,40)||"desconhecida"}..." mudou para ${status.toUpperCase()}`);
  };
  const toggleArquivar=(id,val)=>{
    const s=(st.suggestions||[]).find(x=>x.id===id);
    upd(p=>({...p,suggestions:(p.suggestions||[]).map(s=>s.id===id?{...s,archived:val,archivedAt:val?new Date().toISOString():null}:s)}));
    addLog(val?"Arquivou sugestão":"Desarquivou sugestão",`Sugestão "${s?.text?.substring(0,40)||"desconhecida"}..."`);
  };

  const statusMeta={
    open:{label:"Em aberto",color:T.textMid,bg:"transparent"},
    aceita:{label:"Aceita",color:T.green,bg:"rgba(61,107,53,0.1)"},
    descartada:{label:"Descartada",color:T.red,bg:T.redBg},
  };
  const counts={open:sugs.filter(s=>!s.archived&&s.status==="open").length,aceita:sugs.filter(s=>!s.archived&&s.status==="aceita").length,descartada:sugs.filter(s=>!s.archived&&s.status==="descartada").length,arquivada:sugs.filter(s=>s.archived).length};

  return(
    <div style={{maxWidth:760}}>
      <SH title="Sugestões" sub="CANAL ABERTO DE IDEIAS E MELHORIAS"/>
      <div style={{display:"flex",gap:10,marginBottom:18,alignItems:"center",flexWrap:"wrap"}}>
        <Btn onClick={()=>setShowForm(f=>!f)} style={{marginRight:8}}>{showForm?"Cancelar":"+ NOVA SUGESTÃO"}</Btn>
        {[["all","Todas",sugs.filter(s=>!s.archived).length],["open","Em aberto",counts.open],["aceita","Aceitas",counts.aceita],["descartada","Descartadas",counts.descartada],["arquivada","Arquivadas",counts.arquivada]].map(([id,lb,n])=>(
          <button key={id} onClick={()=>setFilter(id)} style={{background:filter===id?T.bgCard:"transparent",border:`1px solid ${filter===id?T.olive:T.border}`,color:filter===id?T.olive:T.textMid,padding:"5px 12px",borderRadius:2,cursor:"pointer",fontSize:9,fontFamily:"'Special Elite',serif",letterSpacing:1,fontWeight:700}}>
            {lb.toUpperCase()} <span style={{opacity:0.7}}>({n})</span>
          </button>
        ))}
      </div>
      {showForm&&(
        <Card style={{padding:"18px 20px",marginBottom:18,borderTop:`3px solid ${T.olive}`}}>
          <div style={{fontSize:8,letterSpacing:3,color:T.olive,fontFamily:"'Special Elite',serif",fontWeight:700,marginBottom:10}}>NOVA SUGESTÃO</div>
          <Inp value={txt} onChange={e=>setTxt(e.target.value)} placeholder="Descreva sua sugestão de melhoria..." rows={4} style={{marginBottom:12}}/>
          <div style={{display:"flex",gap:8}}>
            <Btn onClick={submit}>ENVIAR SUGESTÃO</Btn>
            <Btn variant="ghost" onClick={()=>{setShowForm(false);setTxt("");}}>Cancelar</Btn>
          </div>
        </Card>
      )}
      {filtered.length===0&&<div style={{color:T.textLight,fontSize:12,textAlign:"center",padding:"30px 0",fontStyle:"italic"}}>Nenhuma sugestão nesta categoria.</div>}
      {filtered.map(s=>{
        const sm=statusMeta[s.status]||statusMeta.open;
        const isDeleting=delId===s.id;
        return(
          <Card key={s.id} style={{padding:"16px 18px",marginBottom:10,borderLeft:`4px solid ${s.status==="aceita"?T.green:s.status==="descartada"?T.red:T.border}`,opacity:s.archived?0.65:1}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:12}}>
              <div style={{flex:1}}>
                <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:6,flexWrap:"wrap"}}>
                  <span style={{fontSize:10,fontWeight:700,color:T.bgDark,fontFamily:"'Playfair Display',Georgia,serif"}}>{s.authorName}</span>
                  <span style={{fontSize:9,color:T.textLight}}>{new Date(s.date).toLocaleDateString("pt-BR",{day:"2-digit",month:"2-digit",year:"numeric",hour:"2-digit",minute:"2-digit"})}</span>
                  <span style={{background:sm.bg,color:sm.color,fontSize:8,fontWeight:700,padding:"1px 8px",borderRadius:10,border:`1px solid ${sm.color}33`,fontFamily:"'Special Elite',serif",letterSpacing:1}}>{sm.label.toUpperCase()}</span>
                  {s.archived&&<span style={{fontSize:8,color:"#555",fontFamily:"'Special Elite',serif",letterSpacing:1}}>ARQUIVADA</span>}
                </div>
                <div style={{fontSize:12,color:T.text,lineHeight:1.6,whiteSpace:"pre-wrap"}}>{s.text}</div>
                {s.statusAt&&s.status!=="open"&&<div style={{fontSize:9,color:T.textLight,marginTop:4}}>{sm.label} em {new Date(s.statusAt).toLocaleDateString("pt-BR")}</div>}
              </div>
              {isAdmin&&(
                <div style={{display:"flex",flexDirection:"column",gap:5,alignItems:"flex-end",flexShrink:0}}>
                  {!s.archived&&s.status!=="aceita"&&<Btn variant="ghost" style={{padding:"3px 10px",fontSize:9,color:T.green,borderColor:T.green+"55"}} onClick={()=>setStatus(s.id,"aceita")}>✓ Aceitar</Btn>}
                  {!s.archived&&s.status!=="descartada"&&<Btn variant="ghost" style={{padding:"3px 10px",fontSize:9,color:T.red,borderColor:T.red+"44"}} onClick={()=>setStatus(s.id,"descartada")}>✕ Descartar</Btn>}
                  {!s.archived&&s.status==="open"&&null}
                  {!s.archived&&<Btn variant="ghost" style={{padding:"3px 10px",fontSize:9}} onClick={()=>toggleArquivar(s.id,true)}>📦 Arquivar</Btn>}
                  {s.archived&&<Btn variant="ghost" style={{padding:"3px 10px",fontSize:9}} onClick={()=>toggleArquivar(s.id,false)}>↩ Restaurar</Btn>}
                  {!isDeleting?(
                    <Btn variant="red" style={{padding:"3px 8px",fontSize:9}} onClick={()=>startDel(s.id)}>✕ Remover</Btn>
                  ):(
                    <div style={{display:"flex",gap:4,alignItems:"center"}}>
                      <Btn variant="red" style={{padding:"2px 7px",fontSize:9,opacity:delCd>0?0.5:1,cursor:delCd>0?"not-allowed":"pointer"}}
                        onClick={()=>delCd===0&&confirmDel(s.id)}>{delCd>0?`${delCd}s`:"REMOVER"}</Btn>
                      <Btn variant="ghost" style={{padding:"2px 6px",fontSize:9}} onClick={cancelDel}>✕</Btn>
                    </div>
                  )}
                </div>
              )}
            </div>
          </Card>
        );
      })}
    </div>
  );
}

function Backup({st,upd}){
  const [conf,setConf]=useState(0);
  const ref=useRef(null);
  const dl=()=>{
    const b=new Blob([JSON.stringify(st,null,2)],{type:"application/json"});
    const a=document.createElement("a");
    a.href=URL.createObjectURL(b);
    a.download=`backup_bateria_${new Date().toISOString().split("T")[0]}.json`;
    a.click();
    // Adicionar log de download de backup
    const newLog={
      id:Date.now()+"_"+Math.random().toString(36).substr(2,9),
      userId:"system",
      userName:"Sistema",
      action:"Download de backup",
      details:`Backup baixado: backup_bateria_${new Date().toISOString().split("T")[0]}.json`,
      timestamp:new Date().toISOString()
    };
    upd(p=>({...p,logs:[newLog,...(p.logs||[])]}));
  };
  const onFile=e=>{
    const f=e.target.files[0];
    if(!f)return;
    const r=new FileReader();
    r.onload=ev=>{
      try{
        const p=JSON.parse(ev.target.result);
        if(!p.users||!p.vehicles){
          alert("Arquivo inválido.");
          return;
        }
        // Adicionar log de restauração de backup
        const newLog={
          id:Date.now()+"_"+Math.random().toString(36).substr(2,9),
          userId:"system",
          userName:"Sistema",
          action:"Restaurou backup",
          details:`Backup restaurado: ${f.name} (${p.users?.length||0} usuários, ${p.vehicles?.length||0} viaturas)`,
          timestamp:new Date().toISOString()
        };
        upd({...p,logs:[newLog,...(p.logs||[])]});
        saveS({...p,logs:[newLog,...(p.logs||[])]});
        alert("✓ Backup restaurado com sucesso!");
        setConf(0);
      }catch{
        alert("Erro ao ler o arquivo.");
      }
    };
    r.readAsText(f);
    e.target.value="";
  };
  const msgs=["Confirmar? Isso substituirá todos os dados. (1/3)","⚠ Tenha outros backups salvos antes de continuar. (2/3)","Clique para selecionar o arquivo. (3/3)"];
  return(
    <div style={{maxWidth:560}}>
      <SH title="Backup do Sistema" sub="EXPORTAÇÃO E RESTAURAÇÃO DE DADOS"/>
      <input ref={ref} type="file" accept=".json" onChange={onFile} style={{display:"none"}}/>
      <Card style={{padding:"22px 24px",marginBottom:16,borderTop:`3px solid ${T.olive}`}}>
        <div style={{fontSize:12,fontWeight:700,color:T.bgDark,fontFamily:"'Playfair Display',Georgia,serif",marginBottom:6}}>Exportar Backup</div>
        <div style={{fontSize:11,color:T.textMid,marginBottom:14,lineHeight:1.7}}>Salva todos os dados: usuários, viaturas, alterações, histórico semanal, notificações e NAPION em arquivo JSON.</div>
        <Btn onClick={dl}>↓ FAZER DOWNLOAD DO BACKUP</Btn>
      </Card>
      <Card style={{padding:"22px 24px",borderTop:`3px solid ${T.red}`}}>
        <div style={{fontSize:12,fontWeight:700,color:T.bgDark,fontFamily:"'Playfair Display',Georgia,serif",marginBottom:6}}>Restaurar Backup</div>
        <div style={{background:T.yellowBg,border:`1px solid rgba(138,112,48,0.3)`,borderRadius:2,padding:"10px 14px",marginBottom:14,fontSize:11,color:T.yellow,lineHeight:1.7}}>
          <strong>⚠ Atenção:</strong> o upload substituirá completamente todos os dados atuais. Esta operação é irreversível sem outro backup. Mantenha sempre múltiplas cópias em locais distintos.
        </div>
        {conf>0&&<div style={{background:T.redBg,border:`1px solid rgba(122,48,48,0.3)`,borderRadius:2,padding:"8px 12px",marginBottom:12,fontSize:11,color:T.red}}>{msgs[conf-1]}</div>}
        <div style={{display:"flex",gap:8}}>
          <Btn variant="red" onClick={()=>{if(conf<2)setConf(c=>c+1);else ref.current?.click();}}>
            {conf===0?"⬆ RESTAURAR BACKUP":conf===1?"⚠ CONFIRMAR (1/3)":"⚠⚠ CONFIRMAR DEFINITIVO (2/3)"}
          </Btn>
          {conf>0&&<Btn variant="ghost" onClick={()=>setConf(0)}>Cancelar</Btn>}
        </div>
      </Card>
    </div>
  );
}

function ChangePassword({st,upd,user,isAdmin}){
  const [sel,setSel]=useState(user.id);
  const [pw,setPw]=useState({cur:"",nw:"",cf:""});
  const [msg,setMsg]=useState(null);
  const target=st.users.find(u=>u.id===sel)||user;

  const save=()=>{
    // Impede usuários ocultos de alterar senha de outros usuários ocultos
    if(user.hidden){
      const targetUser=st.users.find(u=>u.id===sel);
      if(targetUser?.hidden && targetUser?.id!==user.id){
        setMsg({ok:false,txt:"Usuários ocultos não podem alterar senha de outros usuários ocultos."});
        return;
      }
    }

    if(!isAdmin&&pw.cur!==user.password){setMsg({ok:false,txt:"Senha atual incorreta."});return;}
    if(!pw.nw.trim()||pw.nw.length<4){setMsg({ok:false,txt:"Mínimo 4 caracteres."});return;}
    if(pw.nw!==pw.cf){setMsg({ok:false,txt:"As senhas não coincidem."});return;}
    const targetUser=st.users.find(u=>u.id===sel);
    const newLog={
      id:Date.now()+"_"+Math.random().toString(36).substr(2,9),
      userId:user.id,
      userName:user.name,
      action:"Alterou senha",
      details:isAdmin?`Admin alterou senha do usuário ${targetUser?.name||"desconhecido"}`:`Usuário alterou sua própria senha`,
      timestamp:new Date().toISOString()
    };
    upd(p=>({
      ...p,
      users:p.users.map(u=>u.id===sel?{...u,password:pw.nw}:u),
      logs:[newLog,...(p.logs||[])]
    }));
    setPw({cur:"",nw:"",cf:""});setMsg({ok:true,txt:"Senha alterada com sucesso!"});
  };
  return(
    <div style={{maxWidth:460}}>
      <SH title="Alterar Senha" sub="SEGURANÇA DE ACESSO"/>
      <Card style={{padding:"22px 24px"}}>
        {isAdmin&&(
          <div style={{marginBottom:16}}>
            <div style={{fontSize:8,letterSpacing:3,color:T.textLight,marginBottom:6,fontFamily:"'Special Elite',serif"}}>USUÁRIO</div>
            <select value={sel} onChange={e=>{setSel(e.target.value);setPw({cur:"",nw:"",cf:""});setMsg(null);}} style={{width:"100%",background:T.bgDeep,border:`1px solid ${T.border}`,color:T.text,padding:"8px 10px",borderRadius:2,fontSize:11,fontFamily:"'Special Elite',serif",marginBottom:8}}>
              {st.users.filter(u=>!u.hidden||(u.hidden&&u.id===user.id)).map(u=><option key={u.id} value={u.id}>{u.name} — {u.username}{u.role==="admin"?" (admin)":""}</option>)}
            </select>
            <div style={{padding:"7px 12px",background:T.bgDeep,borderRadius:2,fontSize:11,color:T.textMid,border:`1px solid ${T.border}`}}>
              Senha atual: <strong style={{color:T.olive,fontFamily:"monospace"}}>{target.password}</strong>
            </div>
          </div>
        )}
        {!isAdmin&&(
          <div style={{marginBottom:14}}>
            <div style={{fontSize:8,letterSpacing:3,color:T.textLight,marginBottom:6,fontFamily:"'Special Elite',serif"}}>SENHA ATUAL</div>
            <Inp type="password" value={pw.cur} onChange={e=>setPw(p=>({...p,cur:e.target.value}))} placeholder="••••••"/>
          </div>
        )}
        {[["nw","NOVA SENHA"],["cf","CONFIRMAR NOVA SENHA"]].map(([k,lb])=>(
          <div key={k} style={{marginBottom:14}}>
            <div style={{fontSize:8,letterSpacing:3,color:T.textLight,marginBottom:6,fontFamily:"'Special Elite',serif"}}>{lb}</div>
            <Inp type="password" value={pw[k]} onChange={e=>setPw(p=>({...p,[k]:e.target.value}))} placeholder="••••••"/>
          </div>
        ))}
        {msg&&<div style={{padding:"8px 12px",borderRadius:2,marginBottom:12,fontSize:11,background:msg.ok?"rgba(61,107,53,0.08)":T.redBg,color:msg.ok?T.green:T.red,border:`1px solid ${msg.ok?T.green:T.red}30`}}>{msg.txt}</div>}
        <Btn onClick={save}>SALVAR NOVA SENHA</Btn>
      </Card>
    </div>
  );
}

